import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ViewContainerRef,
  TemplateRef,
  ApplicationRef,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  ValidationErrors,
  ValidatorFn,
  AbstractControl,
  FormBuilder,
  Form,
} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from 'src/environments/environment.dev';
import { v4 as uuidv4 } from 'uuid';
import { NgxSpinnerService } from 'ngx-spinner';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import jsPDF from 'jspdf';
import { BehaviorSubject, ObjectUnsubscribedError, Observable, zip } from 'rxjs';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { MaskingHelper } from '../helpers/MaskingHelper';
import { debug } from 'console';
import { Table } from 'jspdf-autotable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BooleanLiteral } from 'typescript';
import { Constants } from './../helpers/Constant';
import { ThirdPartyApiService } from '../services/third-party-api.service';
import { pdf, exportPDF } from "@progress/kendo-drawing";
import { ArrayOfObjects, State, StateResponse, StatesList } from '../helpers/Interfaces';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { CountryName } from '../enum';
export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = nameRe.test(control.value);
    return forbidden ? { forbiddenName: { value: control.value } } : null;
  };
}
declare let CollectJS: any;
declare let printJS: any;

enum HearAboutPTCCheckBoxType {
  AnotherPtcMember = 1,
  InternetSearch = 2,
  NCMS = 4,
  Other = 8,
  NONE = 0,
  BuyersGuide = 5,
  Publications = 6,
  AnotherPTCMember = 1,
  OwnerOperator = 10,
  OnlineAd = 11,
}

enum CheckBoxEnumFederalProgramTypes {
  NotSet = 0,
  PHMSA = 1,
  FMCSA = 2,
  FRA = 4,
  FAA = 8,
  USCG = 16,
}
enum ProgramsRequested {
  DotFederal = 'DotFederal',
  NonDotCompany = 'NonDotCompany',
  ClientRequired = 'ClientRequired',
}

enum ExtensionNo {
  DerExtension = 'DerExtension',
  AlternateDerExtension = 'AlternateDerExtension'
}

enum EnumCountries {
  USA = 'USA',
  Canada = 'Canada'
}


declare var require: any;

interface Item {
  text: string;
  value: number;
}
interface ItemBooleanValue {
  text: string;
  value: boolean;
}

// const htmlToPdfmake = require('html-to-pdfmake');
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
    selector: 'app-enrollment-form',
    templateUrl: './enrollment-form.component.html',
    styleUrls: ['./enrollment-form.component.css'],
    standalone: false
})
export class EnrollmentFormComponent implements OnInit {
  @ViewChild('printTransactionInfo', { static: false }) printTransactionInfo!: PDFExportComponent;
  @ViewChild('pdfView', { static: false }) pdfView!: PDFExportComponent;
  @ViewChild('pdfAckExport', { static: false }) pdfAckExport!: PDFExportComponent;
  @ViewChild('pdf', { static: false }) pdf!: PDFExportComponent;
  public source: Array<{ text: string; value: number }> = [
    { text: 'Small', value: 1 },
    { text: 'Medium', value: 2 },
    { text: 'Large', value: 3 },
  ];

  // public data_: Array<{ text: string, value: number }>;

  public fieldSetting: Object = { value: 'Id', text: 'FirstName' };
  public tempData: { [key: string]: Object }[] = [
    {
      Id: 1,
      FirstName: 'name 1',
    },
    {
      Id: 2,
      FirstName: 'name 2',
    },
    {
      Id: 3,
      FirstName: 'name 3',
    },
  ];

  @ViewChild('Summary', { static: false })
  Summary!: ElementRef;
  isRepay = false;
  InvoicePdfBase64String:any;

  //Vairables for pdf data
  ListStates: any;
  BillingListStates: any;
  customerData: any;
  customerByIdData: any = {};
  AffiliatedCompanyName: any;
  ReinstatedAccountNumber: any;
  public displayData: any;
  EnrollmentStatusForResendEmail: string = '';
  public CompanyName: any = '';
  TotalEmployees: number = 0;
  AnnualEmployeeFee: number = 0;
  EnrollmentTotal: number = 0;
  HearAboutValue: any;
  hearAboutPTCError: string = "";
  hearAboutPTCOtherError: boolean = false;
  public FederalPrgramsSelected: string = '';
  ProgramsRequested: any = '';
  public ClientProgramSelected: String = '';
  AckAndAgreementValue: any;
  AckDate: any;
  public objProgramSelection: {
    DotFederal: boolean;
    NonDotCompnay: boolean;
    ClientRequired: boolean;
  } = {
      DotFederal: false,
      NonDotCompnay: false,
      ClientRequired: false,
    };
  public DrugTestPanelValue: any;

  lstHearAboutPTCCheckBoxType: any = [
    { item: 'Another Ptc Member', value: 1, isSelected: false },
    { item: 'Internet Search', value: 2, isSelected: false },
    { item: 'NCMS', value: 4, isSelected: false },
    { item: `Buyer's Guide`, value: 5, isSelected: false },
    { item: 'Publications', value: 6, isSelected: false },
    { item: 'Other', value: 8, isSelected: false },
  ];

  public isNoofEmployeeSelected: boolean = false;
  public Der_Phone_no_mask = '000-000-0000';
  public Der_Zip_no_mask = '00000';
  public BillingZipMask = '00000';
  public Der_tax_no_mask = '00-0000000';
  public EXT_mask = '00';
  public ISN_Number = '000-000000';
  public CreditCardZipMask = '00000';
  public rules: { [key: string]: RegExp } = {
    L: /^.{1,35}$/,
  };
  public YesNoItems1: Array<string> = ['Select', 'YES', 'NO'];
  private spinners = new BehaviorSubject<string>('');
  showSpinner = true;
  showSpinner1 = true;
  showListofAuditors = false;
  DotCompanyFederalSeletedPrograms = '';
  public YesNoItems: Array<ItemBooleanValue> = [
    { text: 'YES', value: true },
    { text: 'NO', value: false },
  ];
  public selectedItem: ItemBooleanValue = this.YesNoItems.filter(
    (_) => _.value == false
  )[0];
  public selectedItemIsRandomTesting: ItemBooleanValue = this.YesNoItems.filter(
    (_) => _.value == false
  )[0];

  public RandomDrugAndAlcoholTestingItems: Array<ItemBooleanValue> = [
    { text: 'Drug Only', value: false },
    { text: 'Drug & Alcohal', value: true },
  ];
  public selectedItemDrugAndAlcohol: ItemBooleanValue =
    this.RandomDrugAndAlcoholTestingItems.filter((_) => _.value == false)[0];

  public DrugTestPanelItems: Array<Item> = [
    { text: 'DOT Look-a-like Panel', value: 0 },
    { text: '9-Panel (most common)', value: 1 },
    { text: 'Other Panel (please contact PTC for specifics)', value: 2 },
  ];

  public selectedDrugTestPanelItems: Item = this.DrugTestPanelItems.filter(
    (_) => _.value == 0
  )[0];

  public CountryItems: Array<string> = [
    'USA',
    'Canada'
  ];
  // public USAStateItems: Array<string> = [
  //   'Alabama',
  //   'Alaska',
  //   'American Samoa',
  //   'Arizona',
  //   'Arkansas',
  //   'California',
  //   'Colorado',
  //   'Connecticut',
  //   'Delaware',
  //   'District Of Columbia',
  //   'Federated States Of Micronesia',
  //   'Florida',
  //   'Georgia',
  //   'Guam',
  //   'Hawaii',
  //   'Idaho',
  //   'Illinois',
  //   'Indiana',
  //   'Iowa',
  //   'Kansas',
  //   'Kentucky',
  //   'Louisiana',
  //   'Maine',
  //   'Marshall Islands',
  //   'Maryland',
  //   'Massachusetts',
  //   'Michigan',
  //   'Minnesota',
  //   'Mississippi',
  //   'Missouri',
  //   'Montana',
  //   'Nebraska',
  //   'Nevada',
  //   'New Hampshire',
  //   'New Jersey',
  //   'New Mexico',
  //   'New York',
  //   'North Carolina',
  //   'North Dakota',
  //   'Northern Mariana Islands',
  //   'Ohio',
  //   'Oklahoma',
  //   'Oregon',
  //   'Palau',
  //   'Pennsylvania',
  //   'Puerto Rico',
  //   'Rhode Island',
  //   'South Carolina',
  //   'South Dakota',
  //   'Tennessee',
  //   'Texas',
  //   'Utah',
  //   'Vermont',
  //   'Virgin Islands',
  //   'Virginia',
  //   'Washington',
  //   'West Virginia',
  //   'Wisconsin',
  //   'Wyomin',
  // ];
  public USAStateItems: ArrayOfObjects<State> = [];
  public CanadaStateItems: ArrayOfObjects<State> = [];
  // public CanadaStateItems: Array<string> = [
  //   'Alberta',
  //   'British Columbia',
  //   'Manitoba',
  //   'New Brunswick',
  //   'Newfoundland and Labrador',
  //   'Northwest Territories',
  //   'Nova Scotia',
  //   'Nunavut',
  //   'Ontario',
  //   'Prince Edward Island',
  //   'Quebec',
  //   'Saskatchewan',
  //   'Yukon'
  // ];

  public downloadAsPDF() {
    let pdf = new jsPDF('p', 'pt', 'a4', false);

    pdf.html(this.Summary.nativeElement, {
      callback: (pdf) => {
        //pdf.addFileToVFS('NanumGothic-Regular-normal.ttf', font);
        //pdf.addFont('NanumGothic-Regular-normal.ttf', 'NanumGothic-Regular', 'normal');
        //pdf.setFont('NanumGothic-Regular');

        pdf.save('invoice.pdf');
      },
    });
  }

  public printReceipt() {
    //* Print Only
    printJS('print', 'html');
  }

  public downloadReceipt() {
    // Download as PDF
    let htmlData: any = document.getElementById('print');
    html2canvas(htmlData).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      PDF.save(`Receipt-${this.showTransactionId}.pdf`);
    });
  }

  //   public downloadAsPDF() {
  //     const Summary = this.Summary.nativeElement;
  //     var html = htmlToPdfmake(Summary.innerHTML, {tableAutoSize:true});
  //     let right:any = "right";
  //     let center:any = "center"
  //     let marginData: any = [0, 5, 0, 5];
  //     let marginData2: any = [0, 2, 0, 2];
  //      const documentDefinition =
  //     {
  //       content: [html],
  //       styles: {
  //         'pdf-header': {
  //         alignment: right,
  //         display: 'block',
  //         margin: marginData,
  //       },
  //       'pdf-title': {
  //         bold: true
  //       },
  //       'table': {
  //         margin: marginData,
  //       },
  //       'invoice-details': {
  //         margin: marginData2,
  //         fillColor: "#044D89",
  //         color: 'white',
  //         // fontSize: 14,
  //       },
  //       'text-center': {
  //         alignment: center
  //       },
  //       'text-right': {
  //         alignment: right
  //       },
  //       'pdf-table-header': {
  //         fillColor: '#0075cf'
  //       }
  //   }
  // }
  //     pdfMake.createPdf(documentDefinition).open();

  //   }

  step = 1;

  IsCreateTestGUID = environment.IsCreateTestGUID;
  lstCheckBoxFederalProgramTypes: any = [
    { item: 'PHMSA', value: 1, isSelected: false },
    { item: 'FMCSA', value: 2, isSelected: false },
    { item: 'FRA', value: 4, isSelected: false },
    { item: 'FAA', value: 8, isSelected: false },
    { item: 'USCG', value: 16, isSelected: false },
  ];

  // lstCheckBoxClientRequiremets: any = [
  //   { item: 'Branch Energy', value: 1, isSelected: false },
  //   { item: 'Conoco Phillips', value: 2, isSelected: false },
  //   { item: 'Enbridge', value: 4, isSelected: false },
  //   { item: 'Enterprise', value: 8, isSelected: false },
  //   { item: 'ExxonMobil/XTO', value: 16, isSelected: false },
  //   { item: 'Imperial Oil', value: 32, isSelected: false },
  //   { item: 'Jonah Energy', value: 64, isSelected: false },
  //   { item: 'NuStar Energy', value: 128, isSelected: false },
  //   { item: 'SeaRiver', value: 256, isSelected: false },
  //   // { item: 'XTO', value: 512, isSelected: false },
  // ];
  SelectState = 'Select One';
  SelectProvince = 'Select One';

  lstCheckBoxClientRequiremets: any;
  check_box_type = HearAboutPTCCheckBoxType;
  HearAboutPtcCurrentlyChecked: HearAboutPTCCheckBoxType =
    HearAboutPTCCheckBoxType.NONE;
  showCompanyName: string = '';
  showMailing: string = '';
  showPhoneNo: string = '';
  showTaxIdNo: string = '';
  showIsnNo: string = '';
  showItsNo: string = '';
  showDERName: string = '';
  showDEREmail: string = '';
  showAlternateDERName: string = '';
  showAlternateDEREmail: string = '';
  showBillingContactName: string = '';
  showBillingContactEmail: string = '';
  IsExxonMobilDrugTest: boolean = false;
  ExxonMobilDrugTest: string = 'ExxonMobil/XTO';
  showBillingAddess: string = '';
  randomPool: number = 0;
  MaxEmployees: number = 200;
  EnrollmentTotalFee: any = 0;
  InvalidCreditCardMessage = '';

  // IsValidNoOfEmployeesDotFederal: boolean = true;
  // IsValidNoOfEmployeesNonDotFederal: boolean = true;
  // IsValidNoOfEmployeesClientRequired: boolean = true;
  IsValidNoOfEmployeesProgramInfo: boolean = true;
  IsValidJobTitleDotFederal: boolean = true;
  IsValidJobTitleNonDotFederal: boolean = true;



  IsValidITSAccountNo: boolean = true;
  IsValidNumberITSAccountNo: boolean = true;
  IsValidCreditCardZip: boolean = true;
  objExtenions: {
    IsValidDerExtensions: boolean,
    IsValidAlternateDerExtensions: boolean,
    IsValidNumberDerExtensions: boolean,
    IsValidNumberAlternateDerExtensions: boolean,
  } = { IsValidDerExtensions: true, IsValidAlternateDerExtensions: true, IsValidNumberDerExtensions: true, IsValidNumberAlternateDerExtensions: true }
  objZipValid: {
    IsValidMailingZip: boolean,
    IsValidPhysicalZip: boolean,
    IsValidBillingZip: boolean,
    IsValidCreditCardZip: boolean
  } = {
      IsValidMailingZip: false,
      IsValidPhysicalZip: false,
      IsValidBillingZip: false,
      IsValidCreditCardZip: true
    }

  objZipCollection: {
    MailingZip: string,
    PhysicalZip: string,
    BillingZip: string,
    CreditCardZip: string
  } = {
      MailingZip: 'MailingZip',
      PhysicalZip: 'PhysicalZip',
      BillingZip: 'BillingZip',
      CreditCardZip: 'CreditCardZip'
    }
  showBillingCity: string = '';
  showBillingState: string = '';
  showBillingPhoneNo: string = '';
  showBillingExntention: string = '';
  showBillingFaxNo: string = '';
  public showTransactionId: string = '';
  CustomerInfo: any;
  CustomerId: any;
  CustomerDetail: any;
  IsPassCustomerDetail = false;

  showNextButton: true | any;
  lstShowSummary: any = [];
  lstShowSummaryBillingInfo: any = [];
  lstDer: any = [];
  lstDotEmployees: any = [];
  lstNonDotEmployees: any = [];
  lstBillingInfo: any = [];
  nonEmpsubmitted: any = false;
  SalesTaxPercent: number = 0;
  StateSouthDakota: string = 'South Dakota';
  SalesTax: number = 0;
  IsFederalProgramsSelected = true;
  IsCRProgramsSelected = true;
  objBillingInfo: {
    Id: number;
    OtherBillingContactName: string;
    OtherBillingContactEmail: string;
    OtherBillingContactPhone: string;
  } = {
      Id: 0,
      OtherBillingContactEmail: '',
      OtherBillingContactName: '',
      OtherBillingContactPhone: '',
    };
  objDer: {
    Id: number;
    Name: string;
    Title: string;
    PhoneNo: string;
    Email: string;
    ExtensionNo: string;
    CellNo: string;
    AlternateName: string;
    AlternatePhoneNo: string;
    AlternateExtensionNo: string;
    AlternateCellNo: string;
    AlternateEmail: string;
  } = {
      Id: 0,
      Name: '',
      Title: '',
      Email: '',
      PhoneNo: '',
      ExtensionNo: '',
      CellNo: '',
      AlternateName: '',
      AlternatePhoneNo: '',
      AlternateExtensionNo: '',
      AlternateCellNo: '',
      AlternateEmail: '',
    };
  objDotEmploye: {
    Id: number;
    Title: string;
    IsSupervisor: boolean;
    CDL: boolean;
  } = {
      Id: 0,
      Title: '',
      CDL: false,
      IsSupervisor: false,
    };
  ObjNonDotEmployee: {
    Id: number;
    Title: string;
    IsSupervisor: boolean;
  } = {
      Id: 0,
      Title: '',
      IsSupervisor: false,
    };

  objCompanyInfo: {
    AllowCheckPayment: boolean;
    CompanyName: string;
    SisterCompanyName: string;
    ReinstatedAccountNumber: string;
    ContactName:string;
    IsReinstatedAccount: boolean;
    MailingAddress: string;
    CompanyPhoneNo: string;
    BillingPhoneNo: string;
    DerName: string;
    ListOfAgencies: string;
    Country: string;
    City: string;
    State: string;
    Zip: string;
    FaxNo: string;
    FederalTaxId: string;
    PhysicalAddress: string;
    PhysicalAddressCity: string;
    PhysicalAddressState: string;
    PhysicalAddressZip: string;
    PhysicalPhoneNo: string;
    PhysicalFaxNo: string;
    SameAsMailingAddress: boolean;
    ISNetworldAccountNo: string;
    ITSAccountNo: string;
    TypeOfWork: string;
    IsOilAndGasOperator: string;
    OilAndGasOperatorCompanyNames: string;
    SubContractorCompanyNames: string;
    HearAboutPTC: number;
    HearAboutPTCOther: string;
    objPhysicalAddress: {
      PhysicalAddress: string;
      City: string;
      State: string;
      Zip: string;
    };
    objDer: {
      Id: number;
      Name: string;
      Title: string;
      PhoneNo: string;
      Email: string;
      ExtensionNo: string;
      CellNo: string;
      FaxNo: string;
      AlternateName: string;
      AlternatePhoneNo: string;
      AlternateExtensionNo: string;
      AlternateCellNo: string;
      AlternateEmail: string;
    };
    BillingContact: {
      BillingContactName: string;
      BillingContactEmail: string;
      BillingCountry: string;
      BillingAddress: string;
      BillingState: string;
      BillingCity: string;
      BillingZip: string;
      BillingMobileNo: string;
      BillingPhoneNo: string;
      BillingFaxNo: string;
    };
  } = {
      CompanyName: '',
      SisterCompanyName: '',
      ReinstatedAccountNumber: '',
      ContactName : '',
      IsReinstatedAccount: false,
      MailingAddress: '',
      CompanyPhoneNo: '',
      BillingPhoneNo: '',
      DerName: '',
      City: '',
      ListOfAgencies: '',
      Country: 'USA',
      State: this.SelectState,
      Zip: '',
      FaxNo: '',
      FederalTaxId: '',
      ISNetworldAccountNo: '',
      ITSAccountNo: '',
      TypeOfWork: '',
      IsOilAndGasOperator: 'Select',
      OilAndGasOperatorCompanyNames: '',
      SubContractorCompanyNames: '',
      HearAboutPTC: 0,
      HearAboutPTCOther: '',
      objDer: {
        Id: 0,
        Name: '',
        Title: '',
        Email: '',
        PhoneNo: '',
        ExtensionNo: '',
        CellNo: '',
        FaxNo: '',
        AlternateName: '',
        AlternatePhoneNo: '',
        AlternateExtensionNo: '',
        AlternateCellNo: '',
        AlternateEmail: '',
      },
      objPhysicalAddress: {
        PhysicalAddress: '',
        City: '',
        State: this.SelectState,
        Zip: '',
      },
      BillingContact: {
        BillingContactEmail: '',
        BillingContactName: '',
        BillingAddress: '',
        BillingCountry: 'USA',
        BillingCity: '',
        BillingFaxNo: '',
        BillingMobileNo: '',
        BillingPhoneNo: '',
        BillingState: this.SelectState,
        BillingZip: '',
      },
      PhysicalAddress: '',
      PhysicalAddressCity: '',
      PhysicalAddressState: this.SelectState,
      PhysicalAddressZip: '',
      PhysicalPhoneNo: '',
      PhysicalFaxNo: '',
      SameAsMailingAddress: false,
      AllowCheckPayment: false
    };

  objProgramInfo: {
    NonDotProgramInterestYes: boolean;
    CdlUseRequire: boolean;
    NonDotProgramInterestNo: boolean;
    RandomTestigYes: boolean;
    RandomTestigNo: boolean;
    NcmClientRequiredYes: boolean;
    NcmClientRequiredNo: boolean;
    AdditionalProgramYes: boolean;
    AdditionalProgramNo: boolean;
    LisOfAuditors: string;
    NumberOfEmployees: any;
    FederalProgram: {
      FederalProgramTypes: Number;
      //NumberOfEmployees: number;
      IsInterestedInNonDOTProgram: boolean;
      NonDOTPrograms: Number;
    };
    CompanyProgram: {
      IsRandomTesting: boolean;
      IsRandomDrugAndAlcoholTesting: boolean;
      DrugTestPanel: number;
      // NumberOfEmployees: number;
    };
    NCMSProgram: {
      NCMSOperators: number;
      NCMSOperatorOther: string;
      // NumberOfEmployees: number;
    };
    OtherProgram: {
      OtherPrograms: Number;
      OtherName: string;
      // NumberOfEmployees: number;
    };
    ProgramSelection: {
      DotFederal: boolean;
      NonDotCompnay: boolean;
      ClientRequired: boolean;
    };
  } = {
      NonDotProgramInterestYes: false,
      CdlUseRequire: false,
      NonDotProgramInterestNo: false,
      RandomTestigYes: false,
      RandomTestigNo: false,
      NcmClientRequiredNo: false,
      NcmClientRequiredYes: false,
      AdditionalProgramNo: false,
      AdditionalProgramYes: false,
      NumberOfEmployees: '',
      LisOfAuditors: '',
      FederalProgram: {
        FederalProgramTypes: 0,
        IsInterestedInNonDOTProgram: false,
        NonDOTPrograms: 0,
        //NumberOfEmployees: 0,
      },
      CompanyProgram: {
        DrugTestPanel: 0,
        IsRandomDrugAndAlcoholTesting: false,
        IsRandomTesting: false,
        // NumberOfEmployees: 0,
      },
      NCMSProgram: {
        NCMSOperators: 0,
        NCMSOperatorOther: '',
        // NumberOfEmployees: 0,
      },
      OtherProgram: { //NumberOfEmployees: 0, 
        OtherName: '', OtherPrograms: 0
      },
      ProgramSelection: {
        DotFederal: false,
        NonDotCompnay: false,
        ClientRequired: false,
      },
    };

  objFeesInfo: {
    SetupFee: number;
    AnnualSubscription: number;
    AnnualEmployeeFee: number;
    EnrollmentTotal: number;
    PerUseFees: {
      DrugTest: number;
      ExxonMobilDrugTest: number;
      AlcoholTest: number;
      DOTHistoryCheck: number;
      MobileTestingCharges: number;
      TestingFees: number;
    };
  } = {
      SetupFee: 251,
      AnnualSubscription: 401,
      AnnualEmployeeFee: 541,
      EnrollmentTotal: 1193,
      PerUseFees: {
        DrugTest: 86,
        ExxonMobilDrugTest: 101,
        AlcoholTest: 86,
        DOTHistoryCheck: 19,
        MobileTestingCharges: 22,
        TestingFees: 55,
      },
    };

  PaymentDetails: {
    IsCreditCard: boolean;
    CreditCardZip: string;
    IsCreditCardZipUSA: boolean;
    IsCreditCardPostalCodeCanada: boolean;
    CreditCardDetails: {
      CardHolderName: string;
      CardNumber: string;
      CVC: string;
      ExpiryMonth: number;
      ExpiryYear: number;
    };
    CheckDetails: {
      ABANumber: string;
      CheckNumber: string;
      AccountNumber: string;
    };
  } = {
      IsCreditCard: true,
      CreditCardZip: '',
      IsCreditCardZipUSA: true,
      IsCreditCardPostalCodeCanada: false,
      CreditCardDetails: {
        CardHolderName: '',
        CardNumber: '',
        CVC: '',
        ExpiryMonth: 0,
        ExpiryYear: 0,
      },
      CheckDetails: { ABANumber: '', AccountNumber: '', CheckNumber: '' },
    };

  AckAndAgreement: {
    OutlineServicesCosts: boolean
    ServiceAgreement: boolean
    NoRefundCreditPolicy: boolean;
    ElectronicTransmissionAck: boolean;
    ConsumerReportAck: boolean;
    ElectronicSignatureAck: boolean;
    CompanyRepresentativeName: string;
    CompanyName: string;
    AckDate: string;
  } = {
      OutlineServicesCosts: false,
      ServiceAgreement: false,
      NoRefundCreditPolicy: false,
      ElectronicTransmissionAck: false,
      ElectronicSignatureAck: false,
      ConsumerReportAck: false,
      CompanyRepresentativeName: '',
      CompanyName: '',
      AckDate: '',
    };

  isShownbtnAddDerInfo: boolean = true;
  InvoiceNumber: string = '';

  isShownDerSection: boolean = false; // hidden by default
  isShownDotEmpSection: boolean = false;
  isShownNonDotEmpSection: boolean = false;
  isShownBillingContactInfoSection: boolean = false;
  CustomerData: any;
  companyForm: FormGroup = new FormGroup({});
  employeeForm: FormGroup = new FormGroup({});
  currDiv: string | any;
  paymentForm: FormGroup = new FormGroup({});
  AckAndAgreementForm: FormGroup = new FormGroup({});
  submitted = false;
  PaymentSubmitted = false;
  empsubmitted = false;
  companyStep = false;
  employeeStep = false;
  httpdata: any;
  guid: any;
  IsFormShow: any = true;

  TransactionDate: any;
  FileAgreementPolicies = '';
  FileInvoice = '';
  FileServiceAgreement = '';
  FileTransactionDetail = '';

  NumberWithCommas(num: number) {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  NumberWithCommasWithTwoDecimal(num: number) {
    return num?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  HearAboutPtcCheckBoxChanged(targetType: HearAboutPTCCheckBoxType) {
    this.hearAboutPTCOtherError = false;
    this.objCompanyInfo.HearAboutPTC = targetType;
    if (this.HearAboutPtcCurrentlyChecked === targetType) {
      this.HearAboutPtcCurrentlyChecked = HearAboutPTCCheckBoxType.NONE;
      this.objCompanyInfo.HearAboutPTCOther = '';
      this.objCompanyInfo.HearAboutPTC = HearAboutPTCCheckBoxType.NONE;
      this.hearAboutPTCError = "show";
      return;
    }
    else{
      this.hearAboutPTCError = "hide";
    }
    if (targetType !== HearAboutPTCCheckBoxType.Other) {
      this.objCompanyInfo.HearAboutPTCOther = '';
    }
    this.HearAboutPtcCurrentlyChecked = targetType;
  }


  ChangeCreditCardZipForamt(CreditCardZipType: any) {
    if (CreditCardZipType === EnumCountries.USA) {
      this.PaymentDetails.IsCreditCardPostalCodeCanada = true;
      this.PaymentDetails.IsCreditCardZipUSA = false;
      this.CreditCardZipMask = 'AAA AAA';
    }
    else {
      this.PaymentDetails.IsCreditCardPostalCodeCanada = false;
      this.PaymentDetails.IsCreditCardZipUSA = true;
      this.CreditCardZipMask = '00000';
    }

    this.PaymentDetails.CreditCardZip = '';
  }

  SetFormControl() {
    this.companyForm = new FormGroup({
      fcCompanyName: new FormControl('', Validators.required),
      fcSisterCompanyName: new FormControl(''),
      fcMailingAddress: new FormControl('', Validators.required),
      fcCity: new FormControl('', Validators.required),
      fcListOfAgencies: new FormControl(''),
      fcState: new FormControl('', [
        Validators.required, forbiddenNameValidator(/Select One/i)
        // (control: AbstractControl) => {
        //   if (this.companyForm?.get('fcCountry')?.value === 'Canada') {
        //     return [Validators.required, forbiddenNameValidator(/Select Province/i)];
        //   }
        //   return [Validators.required, forbiddenNameValidator(/Select State/i)];
        // },

      ]),
      fcCountry: new FormControl('', [
        Validators.required,
        forbiddenNameValidator(/Select Country/i),
      ]),
      fcZip: new FormControl('', Validators.required),
      fcSameAsMailingAddress: new FormControl(''),
      // fcCompanyPhoneNo: new FormControl('', Validators.required),
      fcDerName: new FormControl('', Validators.required),
      fcDerTitle: new FormControl('', Validators.required),
      fcDerPhoneNo: new FormControl('', Validators.required),
      fcDerExtensionNo: new FormControl(''),
      fcDerCellNo: new FormControl('', Validators.required),
      fcDerFaxNo: new FormControl(''),
      fcDerEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(
          '[a-zA-Z0-9._-]{1,}@[0-9a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ]),

      fcDerAlternateName: new FormControl('', Validators.required),
      fcDerAlternatePhoneNo: new FormControl('', Validators.required),
      fcDerAlternateExtensionNo: new FormControl(''),
      fcDerAlternateCellNo: new FormControl('', Validators.required),
      fcDerAlternateEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(
          '[a-zA-Z0-9._-]{1,}@[0-9a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ]),
      // fcFaxNo: new FormControl('', Validators.required),
      fcFederalTaxId: new FormControl('', Validators.required),
      fcPipeLineOperator: new FormControl(''),
      fcITSAccountNo: new FormControl('', Validators.minLength(2)),
      fcISNetworldAccountNo: new FormControl(''),
      fcTypeOfWork: new FormControl(''),
      fcIsOilAndGasOperator: new FormControl('', [
        Validators.required,
        forbiddenNameValidator(/Select/i),
      ]),
      fcOilAndGasOperatorCompanyNames: new FormControl(''),
      fcSubContractorCompanyNames: new FormControl(''),
      fcBillingContactName: new FormControl('', Validators.required),
      fcBillingContactEmail: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(
          '[a-zA-Z0-9._-]{1,}@[0-9a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ]),
      fcBillingAddress: new FormControl('', Validators.required),
      fcBillingCity: new FormControl('', Validators.required),
      fcBillingZip: new FormControl('', [
        Validators.required,
        //Validators.pattern("[0-9]{5,}-/^(|\d)+$/")
      ]),
      fcBillingCountry: new FormControl('', [
        Validators.required,
        forbiddenNameValidator(/Select Country/i),
      ]),
      fcBillingState: new FormControl('', [
        Validators.required,
        forbiddenNameValidator(/Select One/i),
      ]),
      fcBillingPhoneNo: new FormControl('', Validators.required),
      fcBillingFaxNo: new FormControl(''),

      fcOtherBillingContactName: new FormControl(''),
      fcOtherBillingContactEmail: new FormControl('', [
        Validators.email,
        Validators.pattern(
          '[a-zA-Z0-9._-]{1,}@[0-9a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ]),
      fcOtherBillingContactPhone: new FormControl(''),

      fcPhysicalAddress: new FormControl('', Validators.required),
      fcPhysicalAddressCity: new FormControl('', Validators.required),
      fcPhysicalAddressState: new FormControl('', [
        Validators.required,
        forbiddenNameValidator(/Select One/i),
      ]),
      fcPhysicalAddressZip: new FormControl('', Validators.required),
      fcPhysicalPhoneNo: new FormControl(''),
      fcPhysicalFaxNo: new FormControl(''),
      fcHearAboutPTCOther: new FormControl(''),
      fcHearAboutPTC: new FormControl(''),
    });

    this.employeeForm = new FormGroup({
      fcDotCheckBox: new FormControl(''),
      //fcDotNumberOfEmployees: new FormControl(''),
      fcListOfAuditors: new FormControl(''),
      fcNonDotJobPostition: new FormControl('', Validators.required),
      fcNonDotEmpTtile: new FormControl(''),
      fcNonDotSupervisor: new FormControl(''),
      fcJobPosition: new FormControl('', Validators.required),
      fcEmpTitle: new FormControl('', Validators.required),
      fcSupervisor: new FormControl(''),
      fcCDL: new FormControl(''),
      fcNonDotProgramInterestYes: new FormControl(''),
      fcNonDotProgramInterestNo: new FormControl(''),
      //fcNotDotNumberOfEmployees: new FormControl(''),
      fcIsRandomDrugAndAlcoholTesting: new FormControl(''),
      fcRandomTestigYes: new FormControl(''),
      fcRandomTestigNo: new FormControl(''),
      fcNcmClientRequiredYes: new FormControl(''),
      fcNcmClientRequiredNo: new FormControl(''),
      fcAdditionalProgramYes: new FormControl(''),
      fcAdditionalProgramNo: new FormControl(''),
      fcDotFederal: new FormControl(''),
      fcNonDotCompnay: new FormControl(''),
      fcClientRequired: new FormControl(''),
      fcCdlUseRequire: new FormControl(''),
      fcClientProgramTypes: new FormControl(''),
      fcIsRandomTesting: new FormControl(''),
      fcOtherName: new FormControl(''),
      //fcClientNumberOfEmployees: new FormControl(''),
      fcNumberOfEmployees: new FormControl(''),
      fcDrugTestPanel: new FormControl(''),
    });

    this.paymentForm = new FormGroup({
      fcCreditCardNo: new FormControl(''),
      fcCardHolderName: new FormControl('', Validators.required),
      fcCcvCode: new FormControl(''),
      fcExpiryMonth: new FormControl(''),
      fcExpiryYear: new FormControl(''),
      fcAbaNo: new FormControl(''),
      fcAccountNo: new FormControl(''),
      fcChequeNo: new FormControl(''),
      fcPaymentSelection: new FormControl(''),
      fcCreditCardZip: new FormControl(''),
      fcIsCreditCardZipUSA: new FormControl(''),
      fcIsCreditCardPostalCodeCanada: new FormControl(''),
    });

    this.AckAndAgreementForm = new FormGroup({
      fcCompanyRepresentativeName: new FormControl('', Validators.required),
      fcCompanyName: new FormControl(''),

      fcNoRefundCreditPolicy: new FormControl(''),
      fcOutlineServicesCosts: new FormControl(''),
      fcServiceAgreement: new FormControl(''),
      fcElectronicTransmissionAck: new FormControl(''),
      fcConsumerReportAck: new FormControl(''),
      fcElectronicSignatureAck: new FormControl('', Validators.required),
      fcAckDate: new FormControl(''),
    });

    window.scrollTo(0, 0);
  }

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    // public loader: LoaderService,
    public cdr: ChangeDetectorRef,
    public appRef: ApplicationRef,
    public datePipe: DatePipe,
    private MaskingHelper: MaskingHelper,
    private modalService: NgbModal,
    private third_party_api_service: ThirdPartyApiService
  ) // data_ = source.slice(),
  { }

  CheckJobTitlePosition(Program: any) {
    if (Program === ProgramsRequested.DotFederal || Program === '') {
      if (this.objProgramInfo.ProgramSelection.DotFederal) {
        this.IsValidJobTitleDotFederal = false;
        if (this.lstDotEmployees.length > 0) {
          this.IsValidJobTitleDotFederal = true;
        }
      }
      else {
        this.IsValidJobTitleDotFederal = true;
      }
    }


    if (Program === ProgramsRequested.NonDotCompany || Program === '') {
      if (this.objProgramInfo.ProgramSelection.NonDotCompnay) {
        this.IsValidJobTitleNonDotFederal = false;
        if (this.lstNonDotEmployees.length > 0) {
          this.IsValidJobTitleNonDotFederal = true;
        }
      }
      else {
        this.IsValidJobTitleNonDotFederal = true;
      }
    }
  }

  checkAllNumberOfEmployess(Program: any) {   
    // if (Program === ProgramsRequested.DotFederal || Program === '') {
    //   if (this.objProgramInfo.ProgramSelection.DotFederal) {
    //     this.IsValidNoOfEmployeesDotFederal = false;
    //     if (this.objProgramInfo.FederalProgram.NumberOfEmployees > 0) {
    //       this.IsValidNoOfEmployeesDotFederal = true;
    //     }
    //   }
    //   else {
    //     this.IsValidNoOfEmployeesDotFederal = true;
    //   }
    // }

    // if (Program === ProgramsRequested.NonDotCompany || Program === '') {
    //   if (this.objProgramInfo.ProgramSelection.NonDotCompnay) {
    //     this.IsValidNoOfEmployeesNonDotFederal = false;
    //     if (this.objProgramInfo.CompanyProgram.NumberOfEmployees > 0) {
    //       this.IsValidNoOfEmployeesNonDotFederal = true;
    //     }
    //   }
    //   else {
    //     this.IsValidNoOfEmployeesNonDotFederal = true;
    //   }
    // }

    // if (Program === ProgramsRequested.ClientRequired || Program === '') {
    //   if (this.objProgramInfo.ProgramSelection.ClientRequired) {
    //     this.IsValidNoOfEmployeesClientRequired = false;
    //     if (this.objProgramInfo.OtherProgram.NumberOfEmployees > 0) {
    //       this.IsValidNoOfEmployeesClientRequired = true;
    //     }
    //   } else {
    //     this.IsValidNoOfEmployeesClientRequired = true;
    //   }
    // }


    this.IsValidNoOfEmployeesProgramInfo = false;
    if (this.objProgramInfo.NumberOfEmployees.toString() != "") {
      this.IsValidNoOfEmployeesProgramInfo = true;
    }



    // if (
    //   this.objProgramInfo.OtherProgram.NumberOfEmployees > 0 ||
    //   this.objProgramInfo.FederalProgram.NumberOfEmployees > 0 ||
    //   this.objProgramInfo.CompanyProgram.NumberOfEmployees > 0
    // ) {
    //   this.isNoofEmployeeSelected = true;
    // } else {
    //   this.isNoofEmployeeSelected = false;
    // }
  }

  changeCDLFromGrid() {
    if (this.objDotEmploye.CDL === false) {
      this.selectedItem = this.YesNoItems.filter((_) => _.value == true)[0];
    } else {
      this.selectedItem = this.YesNoItems.filter((_) => _.value == false)[0];
    }
  }

  // public data: Array<{ text: string; value: number }>;

  // handleFilter(value) {
  //   this.data = this.source.filter(
  //     (s) => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
  //   );
  // }

  createNewGuid = () => {
    const uuid: any = uuidv4();
    let guidUrl = environment.baseUrl + '/AddNewGuid/' + uuid;
    let data = {
      CompanyName:
        'PTC Online' + Math.floor(Math.random() * (10000 - 1 + 1)) + 1,
      ContactEmailAddress:
        'ptconline' +
        Math.floor(Math.random() * (10000 - 1 + 1)) +
        1 +
        '@email.com',
    };
    //this.spinner.show();
    this.spinners.next('start');
    return this.http
      .post(guidUrl, data)
      .toPromise()
      .then(
        (res) => {
          if (res == null) {
            var root = this;
            setTimeout(() => {
              //root.spinner.hide();
              this.spinners.next('stop');
              this.showSpinner = false;
              window.location.href =
                environment.AngularFrontUrl + '/enrollment-form?id=' + uuid;
            }, 5000);
          }
        },
        (err) => {
          // console.log(err + 'error');
        }
      );
  };

  SetExportPdfFileNames(id: any) {
    this.FileAgreementPolicies = Constants.FileName.AgreementPolicies + '-' + Math.floor(new Date().getTime() / 1000.0) + "-" + id;
    this.FileInvoice = Constants.FileName.Invoice + '-' + Math.floor(new Date().getTime() / 1000.0) + "-" + id;
    this.FileServiceAgreement = Constants.FileName.ServiceAgreement + '-' + Math.floor(new Date().getTime() / 1000.0) + "-" + id;
    this.FileTransactionDetail = Constants.FileName.TransactionDetail + '-' + Math.floor(new Date().getTime() / 1000.0) + "-" + id;
  }
  ngOnInit() {
    this.ListStates = this.USAStateItems.map(item => item.stateName);
    this.BillingListStates = this.USAStateItems.map(item => item.stateName);
    if (this.AckAndAgreement.NoRefundCreditPolicy == true) {
      (document.getElementById('next_btn') as HTMLButtonElement).disabled =
        false;
    }
    this.TransactionDate = new Date();
    this.TransactionDate = this.datePipe.transform(
      this.TransactionDate,
      'MM/dd/yyyy hh:mm:ss aa'
    );


    this.SetFormControl();

    this.third_party_api_service.GetStates()
      .subscribe((response: StatesList[]) => {
        this.USAStateItems = this.SetStatesLists(response.filter((item: StatesList) => item.Country === CountryName.UnitedStates));
        this.CanadaStateItems = this.SetStatesLists(response.filter((item: StatesList) => item.Country === CountryName.Canada))
        this.SetNextStepData();
      })

  }

  SetStatesLists( resultStates:[]|any){
    let StatesList:Array<State> = [];
    for (let i=0; i< resultStates.length; i++){
      let stateName:string = resultStates[i].StateName;
      let stateCode:string = resultStates[i].State;
      StatesList.push({stateName,stateCode });
    }
    return StatesList;
  }

  SetNextStepData(){
    this.route.queryParams.subscribe((params: any) => {
      this.guid = params['id'];
      localStorage.setItem('id', this.guid);
      // console.log(this.guid);
      if (this.guid != null) {
        //this.spinner.show();
        this.spinners.next('start');
        this.showSpinner = true;
        setTimeout(() => {
          //this.spinner.hide();
          this.spinners.next('stop');
          this.showSpinner = false;
        }, 5000);
        try {
          let url = environment.baseUrl + '/CheckGuid/' + this.guid;
          // console.log(url);
          this.http.get(url).subscribe(
            (data: any) => {

              this.SetExportPdfFileNames(data.CustomerId);
              this.CustomerInfo = data;
              this.SetInvoiceNo();
              //this.SetClientProgramSelected(this.CustomerInfo.CustomerDetails.CRPrograms);
              let CrProgramSelectedList = this.CustomerInfo.CustomerDetails.CRPrograms;

              try {
                if (this.CustomerInfo.CustomerDetails.CurrentTabName) {
                  this.step = this.CustomerInfo.CustomerDetails.CurrentTabName;
                }

              }
              catch { }

              if (Number(this.step) === 5) {
                this.StepPaymentClicked();
              }

              url = environment.baseUrl + '/CRPrograms';
              this.http.get(url).subscribe(
                (data: any) => {
                  let CRProgramList = data;


                  let lst: any = []
                  CRProgramList.forEach((objCr: any, index: any) => {
                    let obj = { item: objCr.CRProgramName, value: objCr.CRProgramGuid, isSelected: false };
                    lst.push(obj);
                  });
                  this.lstCheckBoxClientRequiremets = lst;

                  try {
                    if (CrProgramSelectedList) {
                      CrProgramSelectedList.forEach((objCr: any) => {
                        let ObjFind = this.lstCheckBoxClientRequiremets.find(
                          (e: any) => e.value === objCr.CRProgramGuid
                        );
                        ObjFind.isSelected = true;
                      });
                    }
                  }
                  catch { }
                  this.SetCheckGuidData(this.CustomerInfo);
                  this.CalculateEnrollmentTotal(this.CustomerInfo);
                  this.objProgramInfo.ProgramSelection = this.GetSelectedListProgramInfo(this.CustomerInfo.CustomerDetails.DefaultFederalProgramType, this.objProgramInfo.ProgramSelection)
                  this.SetIsCRProgramsSelected();
                  this.SetExxonMobilDrugTest();


                  //this.tempPdfGenerator();


                  this.objCompanyInfo.CompanyName = this.CustomerInfo.CompanyName;
                  this.objCompanyInfo.AllowCheckPayment = this.CustomerInfo.CustomerDetails?.AllowCheckPayment;
                  this.objCompanyInfo.SisterCompanyName =
                    this.CustomerInfo.CustomerDetails.CompanyDetails.AffiliatedCompanyName;
                  this.objCompanyInfo.ReinstatedAccountNumber =
                    this.CustomerInfo.CustomerDetails.CompanyDetails.ReinstatedAccountNumber;
                    this.objCompanyInfo.ContactName =
                    this.CustomerInfo.CustomerDetails.CompanyDetails.ContactName;
                  this.objCompanyInfo.IsReinstatedAccount =
                    this.CustomerInfo.CustomerDetails.CompanyDetails.IsReinstatedAccount;
                  let isDotFederal =
                    this.CustomerInfo.CustomerDetails.DefaultFederalProgramType - 1;
                  // this.objProgramInfo.ProgramSelection = this.GetSelectedListProgramInfo(this.CustomerInfo.CustomerDetails.DefaultFederalProgramType, this.objProgramInfo.ProgramSelection)
                  // this.objProgramInfo.ProgramSelection.NonDotCompnay =
                  //   this.CustomerInfo.CustomerDetails.DefaultFederalProgramType -
                  //   2 >=
                  //   0;
                  try {
                    this.objProgramInfo.LisOfAuditors = this.CustomerInfo.CustomerDetails.Auditors.join("\n");
                  } catch { }
                  // this.lstCheckBoxClientRequiremets = this.GetCheckBoxList(
                  //   0,
                  //   this.lstCheckBoxClientRequiremets
                  // );
                  // this.objProgramInfo.ProgramSelection.DotFederal =
                  //   isDotFederal == 0 || isDotFederal == 2;

                  if (this.objProgramInfo.ProgramSelection.DotFederal) {
                    this.lstCheckBoxFederalProgramTypes = this.GetSelectedList(
                      this.CustomerInfo.CustomerDetails.DefaultNonDOTProgramTypes,
                      this.lstCheckBoxFederalProgramTypes
                    );

                    this.objProgramInfo.FederalProgram.FederalProgramTypes =
                      this.CustomerInfo.CustomerDetails.DefaultNonDOTProgramTypes;
                    this.SetIsFederalProgramsSelected();


                    // if (this.objProgramInfo.ProgramSelection.DotFederal) {
                    //   if (this.lstCheckBoxFederalProgramTypes.filter((e: any) => e.isSelected === true).length > 0) {
                    //     this.IsFederalProgramsSelected = true;
                    //   }
                    //   else {
                    //     this.IsFederalProgramsSelected = false;
                    //   }
                    // } else {
                    //   this.IsFederalProgramsSelected = true;
                    // }


                  }
                  this.spinner.hide();
                  this.showSpinner = false;
                  if (data === 'invalid guid') {
                    //this.spinner.show();
                    this.spinners.next('start');
                    this.showSpinner = true;
                    setTimeout(() => {
                      //this.spinner.hide();
                      this.spinners.next('stop');
                      this.showSpinner = false;
                    }, 3000);
                    this.IsFormShow = false;
                  } else {
                    //this.spinner.show();
                    // this.spinners.next('start');
                    // this.showSpinner = true;
                    this.IsFormShow = true;
                  }
                });



            },
            (error) => {
              // console.log(error);
              this.IsFormShow = false;
              //Error callback
              //this.spinner.hide();
              this.spinners.next('stop');
              this.showSpinner = false;
              //alert('something wrong');
              //throw error;   //You can also throw the error to a global error handler
            }
          );
        } catch {
          alert('Something wrong');
        }
      } else {

        this.spinners.next('stop');
        this.showSpinner = false;

        this.IsFormShow = false;
      }
    });
  }

  SetInvoiceNo() {
    this.InvoiceNumber = this.datePipe.transform(new Date(), 'MMddyyyy') + '-' + this.CustomerInfo.CustomerId;
  }

  SetCheckGuidData(CompanyInfoData: any) {
    let BillingCountry = '';
    try {     
      let Country = CompanyInfoData?.CustomerDetails.CompanyDetails.Country;
      BillingCountry = CompanyInfoData?.CustomerDetails.CompanyDetails.BillingCountry;
      if (!Country){
        Country = this.objCompanyInfo.Country;
      }

      if (!BillingCountry){
        BillingCountry = this.objCompanyInfo.BillingContact.BillingCountry;
      }
      this.changeCountry(Country);
      this.changeBillingCountry(BillingCountry);//api changes
    }
    catch { }

    try {
      if (CompanyInfoData?.CustomerDetails.CompanyDetails && CompanyInfoData?.CustomerDetails.CompanyDetails.FederalTaxID) {
        let PrimaryDer = CompanyInfoData?.CustomerDetails.DERs.find(
          (e: any) => e.ContactType === 1
        );
        let AlternateDer = CompanyInfoData?.CustomerDetails.DERs.find(
          (e: any) => e.ContactType === 2
        );
        let PrimaryBilling = CompanyInfoData?.CustomerDetails.BillingContacts.find(
          (e: any) => e.ContactType === 1
        );
        let AlternateBilling = CompanyInfoData?.CustomerDetails.BillingContacts.find(
          (e: any) => e.ContactType === 2
        );


        this.objCompanyInfo.MailingAddress =
          CompanyInfoData?.CustomerDetails.CompanyDetails.MailingAddress.StreetName;
        this.objCompanyInfo.TypeOfWork =
          CompanyInfoData?.CustomerDetails.CompanyDetails.TypeOfWork;
        this.objCompanyInfo.Country =
          CompanyInfoData?.CustomerDetails.CompanyDetails.Country;
        this.objCompanyInfo.City =
          CompanyInfoData?.CustomerDetails.CompanyDetails.MailingAddress.City;
        this.objCompanyInfo.ISNetworldAccountNo =
          CompanyInfoData?.CustomerDetails.CompanyDetails.IsNetworldAccountNo;
        this.objCompanyInfo.State =
          CompanyInfoData?.CustomerDetails.CompanyDetails.MailingAddress.State;
        this.objCompanyInfo.FederalTaxId =
          CompanyInfoData?.CustomerDetails.CompanyDetails.FederalTaxID;
        this.objCompanyInfo.Zip =
          CompanyInfoData?.CustomerDetails.CompanyDetails.MailingAddress.Zip;
        this.objCompanyInfo.ITSAccountNo =
          CompanyInfoData?.CustomerDetails.CompanyDetails.ITSAccountNumber;
        this.objCompanyInfo.SameAsMailingAddress =
          CompanyInfoData?.CustomerDetails.CompanyDetails.PhysicalAddressSameAsMailingAddress;
        this.objCompanyInfo.IsOilAndGasOperator = CompanyInfoData
          .CustomerDetails.CompanyDetails.IsOilAndGasOperator
          ? 'YES'
          : 'NO';
        this.objCompanyInfo.PhysicalAddress =
          CompanyInfoData?.CustomerDetails.CompanyDetails.PhysicalAddress.StreetName;
        this.objCompanyInfo.PhysicalAddressCity =
          CompanyInfoData?.CustomerDetails.CompanyDetails.PhysicalAddress.City;
        this.objCompanyInfo.PhysicalAddressState =
          CompanyInfoData?.CustomerDetails.CompanyDetails.PhysicalAddress.State;
        this.objCompanyInfo.PhysicalAddressZip =
          CompanyInfoData?.CustomerDetails.CompanyDetails.PhysicalAddress.Zip;
        this.objCompanyInfo.OilAndGasOperatorCompanyNames =
          CompanyInfoData?.CustomerDetails.CompanyDetails.OilAndGasOperatorCompanyNames;
        this.objCompanyInfo.SubContractorCompanyNames =
          CompanyInfoData?.CustomerDetails.CompanyDetails.SubContractorCompanyNames;
        // this.objCompanyInfo.HearAboutPTC =
        //   CompanyInfoData?.CustomerDetails.CompanyDetails.HearAboutPTC;
        // if (this.objCompanyInfo.HearAboutPTC === 8) {
        //   this.HearAboutPtcCurrentlyChecked = HearAboutPTCCheckBoxType.Other;
        // }
        this.HearAboutPtcCurrentlyChecked =
          CompanyInfoData?.CustomerDetails.CompanyDetails.HearAboutPTC;
        this.objCompanyInfo.HearAboutPTC = CompanyInfoData?.CustomerDetails.CompanyDetails.HearAboutPTC;
        this.objCompanyInfo.HearAboutPTCOther =
          CompanyInfoData?.CustomerDetails.CompanyDetails.HearAboutPTCOther;
        if (PrimaryDer) {
          this.objCompanyInfo.objDer.Name = PrimaryDer.Name;
          this.objCompanyInfo.objDer.Title = PrimaryDer.Title;
          this.objCompanyInfo.objDer.PhoneNo = PrimaryDer.Address.PhoneNumber;
          this.objCompanyInfo.objDer.ExtensionNo =
            PrimaryDer.Address.Extension;
          this.objCompanyInfo.objDer.CellNo = PrimaryDer.Address.MobileNumber;
          this.objCompanyInfo.objDer.Email = PrimaryDer.EmailAddress;
          this.objCompanyInfo.objDer.FaxNo = PrimaryDer.Address.FaxNumber;
        }

        if (AlternateDer) {
          this.objCompanyInfo.objDer.AlternateName = AlternateDer.Name;
          this.objCompanyInfo.objDer.AlternatePhoneNo =
            AlternateDer.Address.PhoneNumber;
          this.objCompanyInfo.objDer.AlternateExtensionNo =
            AlternateDer.Address.Extension;
          this.objCompanyInfo.objDer.AlternateCellNo =
            AlternateDer.Address.MobileNumber;
          this.objCompanyInfo.objDer.AlternateEmail =
            AlternateDer.EmailAddress;
        }

        if (PrimaryBilling) {
          this.objCompanyInfo.BillingContact.BillingContactName =
            PrimaryBilling.Name;
          this.objCompanyInfo.BillingContact.BillingContactEmail =
            PrimaryBilling.EmailAddress;
          this.objCompanyInfo.BillingContact.BillingAddress =
            PrimaryBilling.Address.StreetName;
          this.objCompanyInfo.BillingContact.BillingCountry = BillingCountry;
          this.objCompanyInfo.BillingContact.BillingState =
            PrimaryBilling.Address.State;
          this.objCompanyInfo.BillingContact.BillingCity =
            PrimaryBilling.Address.City;
          this.objCompanyInfo.BillingContact.BillingZip =
            PrimaryBilling.Address.Zip;
          this.objCompanyInfo.BillingContact.BillingPhoneNo =
            PrimaryBilling.Address.PhoneNumber;
          this.objCompanyInfo.BillingContact.BillingFaxNo =
            PrimaryBilling.Address.FaxNumber;
        }

        if (AlternateBilling) {
          this.objBillingInfo.OtherBillingContactName = AlternateBilling.Name;
          this.objBillingInfo.OtherBillingContactEmail =
            AlternateBilling.EmailAddress;
          this.objBillingInfo.OtherBillingContactPhone =
            AlternateBilling.Address.PhoneNumber;
        }
      }
    }
    catch { }

    try {

      this.SetProgramInformationTab(CompanyInfoData);
    }
    catch { }

    try {
      this.SetAckAndAgreement(CompanyInfoData);
    }
    catch { }
    this.SetPaymentInfoTab(CompanyInfoData);

    this.CalculateSummaryPages();
  }

  SetPaymentInfoTab(CompanyInfoData: any) {
    this.InvoiceNumber = CompanyInfoData?.CustomerDetails.InvoiceNumber;

    if (!this.InvoiceNumber) {
      this.SetInvoiceNo();
    }
    this.showTransactionId = CompanyInfoData?.CustomerDetails.RepayTransactionId;
    if (CompanyInfoData?.CustomerDetails.PaymentDetails.CreditCardDetails) {
      this.PaymentDetails.CreditCardDetails.CardNumber = CompanyInfoData?.CustomerDetails.PaymentDetails.CreditCardDetails.CardNumber;
    }
    if (this.showTransactionId === null) {
      this.showTransactionId = '';
    }
  }


  SetProgramInformationTab(CompanyInfoData: any) {

    let DotEmployee =
      CompanyInfoData?.CustomerDetails.PTCProgramDetails.FederalProgram.Employees;
    let NonDotEmployee =
      CompanyInfoData?.CustomerDetails.PTCProgramDetails.CompanyProgram.Employees;

    this.objCompanyInfo.ListOfAgencies = CompanyInfoData?.CustomerDetails.AuditAgencies === null ? '' : CompanyInfoData?.CustomerDetails.AuditAgencies.join("\n");
    this.objProgramInfo.ProgramSelection = this.GetSelectedListProgramInfo(CompanyInfoData?.CustomerDetails.DefaultFederalProgramType, this.objProgramInfo.ProgramSelection);
    this.objProgramInfo.LisOfAuditors = CompanyInfoData?.CustomerDetails.Auditors === null ? '' : CompanyInfoData?.CustomerDetails.Auditors.join("\n");
    this.objProgramInfo.FederalProgram.FederalProgramTypes =
      CompanyInfoData?.CustomerDetails.PTCProgramDetails.FederalProgram.FederalPrograms;
    let FederalProgramsValue = 0;
    if (CompanyInfoData?.CustomerDetails.CompanyDetails.CompanyName === null) {
      FederalProgramsValue =
        CompanyInfoData?.CustomerDetails.DefaultNonDOTProgramTypes;
    } else {
      FederalProgramsValue =
        CompanyInfoData?.CustomerDetails.PTCProgramDetails
          .FederalProgram.FederalPrograms;
    }


    this.lstCheckBoxFederalProgramTypes = this.GetSelectedList(
      FederalProgramsValue,
      this.lstCheckBoxFederalProgramTypes
    );

    //this.objProgramInfo.FederalProgram.NumberOfEmployees =  CompanyInfoData?.CustomerDetails.PTCProgramDetails.FederalProgram.NumberOfEmployees;
    this.selectedItem = this.YesNoItems.filter(
      (_) =>
        _.value ==
        CompanyInfoData?.CustomerDetails.PTCProgramDetails
          .FederalProgram.FederalCDL
    )[0];
    // this.lstDotEmployees = DotEmployee;
    // this.lstNonDotEmployees = NonDotEmployee;

    this.selectedItemIsRandomTesting = this.YesNoItems.filter(
      (_) =>
        _.value ==
        CompanyInfoData?.CustomerDetails.PTCProgramDetails
          .CompanyProgram.IsRandomTesting
    )[0];

    this.selectedItemDrugAndAlcohol = this.YesNoItems.filter(
      (_) =>
        _.value ==
        CompanyInfoData?.CustomerDetails.PTCProgramDetails
          .CompanyProgram.IsRandomDrugAndAlcoholTesting
    )[0];

    this.selectedDrugTestPanelItems = this.DrugTestPanelItems.filter(
      (_) =>
        _.value ==
        CompanyInfoData?.CustomerDetails.PTCProgramDetails
          .CompanyProgram.DrugTestPanel
    )[0];

    //this.objProgramInfo.CompanyProgram.NumberOfEmployees = CompanyInfoData?.CustomerDetails.PTCProgramDetails.CompanyProgram.NumberOfEmployees;
    this.ObjNonDotEmployee.IsSupervisor = NonDotEmployee.IsSupervisor;
    this.objProgramInfo.OtherProgram.OtherPrograms =
      CompanyInfoData?.CustomerDetails.PTCProgramDetails.OtherProgram.OtherPrograms;

    // this.lstCheckBoxClientRequiremets = this.GetTextSelectedList(
    //   CompanyInfoData?.CustomerDetails.PTCProgramDetails.OtherProgram
    //     .OtherPrograms,
    //   this.lstCheckBoxClientRequiremets
    // );
    this.objProgramInfo.OtherProgram.OtherName =
      CompanyInfoData?.CustomerDetails.PTCProgramDetails.OtherProgram.OtherName;
    //this.objProgramInfo.OtherProgram.NumberOfEmployees =  CompanyInfoData?.CustomerDetails.PTCProgramDetails.OtherProgram.NumberOfEmployees;
    this.objProgramInfo.NumberOfEmployees =  CompanyInfoData?.CustomerDetails.PTCProgramDetails.NumberOfEmployees === 0 && Number(CompanyInfoData?.CustomerDetails.CurrentTabName) <=2 ? '':CompanyInfoData?.CustomerDetails.PTCProgramDetails.NumberOfEmployees;
    this.checkAllNumberOfEmployess('');
    this.SetIsFederalProgramsSelected();
    this.SetIsCRProgramsSelected();
    for (let i = 0; i < DotEmployee.length; i++) {
      let obj = {
        Id: i + 1,
        Title: DotEmployee[i].Title,
        IsSupervisor: DotEmployee[i].IsSupervisor,
        CDL: DotEmployee[i].CDL,
      };
      this.lstDotEmployees.push(obj);
    }

    for (let i = 0; i < NonDotEmployee.length; i++) {
      let obj = {
        Id: i + 1,
        Title: NonDotEmployee[i].Title,
        IsSupervisor: NonDotEmployee[i].IsSupervisor,
      };
      this.lstNonDotEmployees.push(obj);
    }

    this.CheckJobTitlePosition('');
  }

  SetAckAndAgreement(CompanyInfoData: any) {

    if (CompanyInfoData?.CustomerDetails.AckAndAgreement.CompanyRepresentativeName != null) {

      this.AckAndAgreement = CompanyInfoData?.CustomerDetails.AckAndAgreement;
      this.AckAndAgreement.CompanyName = CompanyInfoData.CompanyName;
      this.AckAndAgreement.AckDate = new Date(CompanyInfoData?.CustomerDetails.AckAndAgreement.AckDate).toLocaleDateString();
    }
    //   CompanyRepresentativeName:
    //   this.AckAndAgreement.CompanyRepresentativeName,
    // CompanyName: this.AckAndAgreement.CompanyName,
    // NoRefundCreditPolicy: this.AckAndAgreement.NoRefundCreditPolicy,
    // ElectronicTransmissionAck:
    //   this.AckAndAgreement.ElectronicTransmissionAck,
    // ConsumerReportAck: this.AckAndAgreement.ElectronicSignatureAck,
    // ElectronicSignatureAck: this.AckAndAgreement.ElectronicSignatureAck,
    // // AckDate: this.AckAndAgreement.AckDate,
    // AckDate: new Date(this.AckAndAgreement.AckDate),
  }

  SetExxonMobilDrugTest() {
    let ObjFindExxonMobilDrugTest = this.lstCheckBoxClientRequiremets.find(
      (e: any) => e.item === this.ExxonMobilDrugTest
    );

    if (ObjFindExxonMobilDrugTest.isSelected) {
      this.IsExxonMobilDrugTest = true;
    }
    else {
      this.IsExxonMobilDrugTest = false;
    }
  }
  // SetClientProgramSelected(CrProgramSelectedList: any) {
  //   let url = environment.baseUrl + '/CRPrograms';
  //   this.http.get(url).subscribe(
  //     (data: any) => {
  //       let CRProgramList = data;

  //       let lst: any = []
  //       CRProgramList.forEach((objCr: any) => {
  //         let obj = { item: objCr.CRProgramName, value: objCr.CRProgramGuid, isSelected: false };
  //         lst.push(obj);
  //       });
  //       this.lstCheckBoxClientRequiremets = lst;

  //       try {
  //         if (CrProgramSelectedList) {
  //           CrProgramSelectedList.forEach((objCr: any) => {
  //             let ObjFind = this.lstCheckBoxClientRequiremets.find(
  //               (e: any) => e.value === objCr.CRProgramGuid
  //             );
  //             ObjFind.isSelected = true;
  //           });
  //         }
  //       }
  //       catch { }

  //     });
  // }

  GetSelectedList(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;
    for (let i = lstCheckBox.length - 1; i >= 0; i--) {
      if (RemainingValues - lstCheckBox[i].value >= 0) {
        lstCheckBox[i].isSelected = true;
        RemainingValues = RemainingValues - lstCheckBox[i].value;
      } else {
        lstCheckBox[i].isSelected = false;
      }
    }
    //console.log(lstCheckBox);


    if (lstCheckBox[0].isSelected == true) {
      this.showListofAuditors = true;
    }
    else {
      this.showListofAuditors = false;
    }
    return lstCheckBox;
  }


  GetTextSelectedList(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;
    let FederalProgramTextList = [];
    for (let i = lstCheckBox.length - 1; i >= 0; i--) {
      if (RemainingValues - lstCheckBox[i].value >= 0) {
        FederalProgramTextList.push(lstCheckBox[i].item);
        RemainingValues = RemainingValues - lstCheckBox[i].value;
      }
    }

    let PrgramSelected = '';
    for (let i = FederalProgramTextList.length - 1; i >= 0; i--) {
      if (PrgramSelected != '') {
        PrgramSelected += ', ';
      }
      PrgramSelected += FederalProgramTextList[i];
    }
    return PrgramSelected;
  }

  ngAfterContentInit() {
    // console.log('Current Step', this.step);
    if (this.step == 5) {
      this.setRegisterRepay();
    }
  }

  ProgramSelectionChanged(values: any, Program: string): void {
    this.checkAllNumberOfEmployess(Program);
    this.CheckJobTitlePosition(Program);
    if (Program === ProgramsRequested.DotFederal) {
      // if (values.currentTarget.checked) {
      //   this.IsFederalProgramsSelected = false;
      // }
      // else {
      //   this.IsFederalProgramsSelected = true;
      // }
      this.SetIsFederalProgramsSelected();
    }

    if (Program === ProgramsRequested.ClientRequired) {
      this.SetIsCRProgramsSelected();
      // if (values.currentTarget.checked) {
      //   this.IsCRProgramsSelected = false;
      // }
      // else {
      //   this.IsCRProgramsSelected = true;
      // }
    }
  }

  ngAfterViewInit(): void {
    // var root = this;
    // setTimeout(() => {
    //   //root.spinner.hide();
    //   this.spinners.next('stop');
    //   this.showSpinner = false;
    // }, 2000);

    // $("input").change(function() {
    //   alert("The text has been changed.");
    // });

    // $(document).ready(function(){
    //   $( "input[type='text']" ).change(function(){
    //     alert("The text has been changed.");
    //   });
    // });


    //(document.getElementsByTagName("kendo-textbox")[0]  as HTMLInputElement).addEventListener("change", this.myFunction);



    // $("input").change(function () {    
    //   var input = $(this).val();
    //   var value = String(input);
    //   $(this).val($.trim(value));
    //   console.log($.trim(value));
    // });
    // $("textarea").change(function () {
    //   var input = $(this).val();
    //   var value = String(input);
    //   $(this).val($.trim(value));
    //   console.log($.trim(value));
    // });
  }

  changeInputTrim(event: any, ControlName: any) {
    this.hearAboutPTCOtherError = false;
    event.target.value = event.target.value.trim();
    if (ControlName === Constants.TrimControls.CompanyName) {
      this.objCompanyInfo.CompanyName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.MailingAddress) {
      this.objCompanyInfo.MailingAddress = event.target.value.trim();
      this.changeMailingAddress(event);
    }
    else if (ControlName === Constants.TrimControls.MailingCity) {
      this.objCompanyInfo.City = event.target.value.trim();
      this.changeCity(event);
    }
    else if (ControlName === Constants.TrimControls.PhysicalAddress) {
      this.objCompanyInfo.PhysicalAddress = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.PhysicalCity) {
      this.objCompanyInfo.PhysicalAddressCity = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.TypeOfWork) {
      this.objCompanyInfo.TypeOfWork = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.OilAndGasOperatorCompanyNames) {
      this.objCompanyInfo.OilAndGasOperatorCompanyNames = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.SubContractorCompanyNames) {
      this.objCompanyInfo.SubContractorCompanyNames = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.HearAboutPTCOther) {
      this.objCompanyInfo.HearAboutPTCOther = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.DerName) {
      this.objCompanyInfo.objDer.Name = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.DerTitle) {
      this.objCompanyInfo.objDer.Title = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.DerAlternateName) {
      this.objCompanyInfo.objDer.AlternateName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.BillingContactName) {
      this.objCompanyInfo.BillingContact.BillingContactName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.BillingAddress) {
      this.objCompanyInfo.BillingContact.BillingAddress = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.BillingCity) {
      this.objCompanyInfo.BillingContact.BillingCity = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.OtherBillingContactName) {
      this.objBillingInfo.OtherBillingContactName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.LisOfAuditors) {
      this.objProgramInfo.LisOfAuditors = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.DotEmployeeTitle) {
      this.objDotEmploye.Title = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.NonDotEmployeeTitle) {
      this.ObjNonDotEmployee.Title = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.OtherProgramOtherName) {
      this.objProgramInfo.OtherProgram.OtherName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.CompanyRepresentativeName) {
      this.AckAndAgreement.CompanyRepresentativeName = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.ITSAccountNo) {
      this.objCompanyInfo.ITSAccountNo = event.target.value.trim();
      this.changeItsNo(event);
    }
    else if (ControlName === Constants.TrimControls.DerEmail) {
      this.objCompanyInfo.objDer.Email = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.AlternateDerEmail) {
      this.objCompanyInfo.objDer.AlternateEmail = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.OtherBillingContactEmail) {
      this.objBillingInfo.OtherBillingContactEmail = event.target.value.trim();
    }
    else if (ControlName === Constants.TrimControls.DerExtension) {
      this.objCompanyInfo.objDer.ExtensionNo = event.target.value.trim();
      this.changeExtensionNo(event, ControlName);
    }
    else if (ControlName === Constants.TrimControls.AlternateDerExtension) {
      this.objCompanyInfo.objDer.AlternateExtensionNo = event.target.value.trim();
      this.changeExtensionNo(event, ControlName);
    }
    else if (ControlName === Constants.TrimControls.BillingContactEmail) {
      this.objCompanyInfo.BillingContact.BillingContactEmail = event.target.value.trim();
    }
  }


  setRegisterRepay = () => {
    var root = this;
    let registerInterval = setInterval(() => {
      if (root.isRepay) {
        clearInterval(registerInterval);
      }
      root.isRepay = true;
      root.registerRepay();
      // if (document.getElementById('demoPayButton')) {
      //   console.log('1319');
      //   root.isRepay = true;
      //   root.registerRepay();

      // }
    }, 100);
  };

  registerRepay = () => {
    var root = this;
    if (CollectJS) {
      CollectJS.configure({
        // paymentSelector: '#demoPayButton',
        variant: 'inline',
        styleSniffer: 'false',
        //googleFont: 'Montserrat:400',
        customCss: {
          color: '#495057',
          border: '1px solid #ced4da',
          'font-size': '14px',
          display: 'inline',
          'width': '100',
          height: 'auto',
          padding: '4px 8px',
          'font-weight': '400',
          'line-height': '1.4285714286',
          'background-color': '#fff',
          'background-clip': 'padding-box',
          'border-radius': '0.25rem',
          transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
          'letter-spacing': '1px',
          'font-family': 'Poppins, sans-serif',
          'margin-top': '2px',
        },
        invalidCss: {
          color: 'red',
          border: '1px solid red',
        },

        validCss: {
          color: '#000',
          'background-color': '#fff',
        },
        placeholderCss: {
          color: '#d3d3d3',
          'background-color': '#ffffff',
        },
        focusCss: {
          color: '#000',
          'background-color': '#fff',
          //'box-shadow': '0 0 2px 2px #51a7e8',
          'outline': '0',
          border: '0px solid red',

        },


        fields: {
          checkname: {
            selector: '#demoCheckname',
            title: 'Customer Name',
            placeholder: 'Customer Name',
          },
          ccnumber: {
            selector: '#demoCcnumber',
            title: 'Card Number',
            placeholder: '0000 0000 0000 0000',
          },
          ccexp: {
            selector: '#demoCcexp',
            title: 'Card Expiration',
            placeholder: '00 / 00',
          },
          cvv: {
            // display: 'show',
            selector: '#demoCvv',
            title: 'CVV Code',
            placeholder: '***',
          },
        },
        currency: 'USD',
        country: 'US',
        //   startPaymentRequest : function() {
        //     console.log('StartPayment');
        // },
        validationCallback: function (
          field: string,
          status: any,
          message: string
        ) {
          if (status) {
            root.InvalidCreditCardMessage = '';
            // if (field === 'ccnumber'){
            //   this.InvalidCreditCardMessage = '';
            // }
            // root.InvalidCreditCardMessage = '';
            setTimeout(() => {
              root.cdr.detectChanges();
            }, 50);
            var message = field + ' is now OK: ' + message;
          } else {
            root.InvalidCreditCardMessage = message;
            root.spinners.next('stop');
            root.showSpinner = false;

            setTimeout(() => {
              root.cdr.detectChanges();
            }, 50);
            var message = field + ' is now Invalid: ' + message;
          }
          // console.log(message);
        },
        timeoutDuration: 30000,
        // startPaymentRequest:function(){
        //   console.log('startPaymentRequest');
        // },
        timeoutCallback: function () {
          root.spinners.next('stop');
          root.showSpinner = false;

          setTimeout(() => {
            root.cdr.detectChanges();
          }, 50);
          root.InvalidCreditCardMessage = Constants.Repay.TimeOut;
          // console.log(
          //   "The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity"
          // );
        },
        fieldsAvailableCallback: function () {
          root.spinners.next('stop');
          root.showSpinner = false;

          setTimeout(() => {
            root.cdr.detectChanges();
          }, 50);
          // console.log('Collect.js loaded the fields onto the form');
        },
        callback: async function (response: any) {          

          //root.PaymentSubmitted = true;
          // if (!root.paymentForm.get('fcCreditCardZip')?.valid) {
          //   root.InvalidCreditCardMessage = 'Zip is required';
          //   setTimeout(() => {
          //     root.cdr.detectChanges();
          //   }, 500);
          // }
          // else {
          // root.spinners.next('start');
          // root.showSpinner = true;
          // root.cdr.detectChanges();
          root.PaymentDetails.CreditCardDetails.CardNumber = response.card.number.substring(response.card.number.length - 4, response.card.number.length);
          let ProgramsSelected = root.GetSelectedPRogramMode();
          let PaymentToken = response.token;

          let data = {
            type: 'sale',
            amount: root.EnrollmentTotalFee,
            payment_token: response.token,
            first_name: root.objCompanyInfo.CompanyName,
            address1: root.objCompanyInfo.BillingContact.BillingAddress,
            city: root.objCompanyInfo.BillingContact.BillingCity,
            state: root.objCompanyInfo.BillingContact.BillingState,
            zip: root.GetZipFormat(root.PaymentDetails.CreditCardZip),
            phone: root.GetPhoneNoFormat(root.objCompanyInfo.BillingContact.BillingPhoneNo),
            fax: root.GetFaxNoFormat(root.objCompanyInfo.BillingContact.BillingFaxNo),
            email: root.objCompanyInfo.BillingContact.BillingContactEmail,
            orderid: root.guid,
            order_description: ProgramsSelected
          }
          const headers = { 'content-type': 'application/json' };
          const body = JSON.stringify(data);
          // console.log(body);
          //this.spinner.show();
          root.http
            .post(environment.baseUrl + '/Repay', body, {
              headers: headers,
              responseType: 'text'
            })
            .subscribe(
              (res: any) => {
                root.spinners.next('stop');
                root.showSpinner = false;
                setTimeout(() => {
                  root.cdr.detectChanges();
                }, 500);
                const resString = JSON.stringify(res);

                let ResponseMessage = resString.split('&')[1].split('=')[1];

                if (ResponseMessage === 'SUCCESS' || ResponseMessage === 'Approved') {
                  let resJson = resString.split('&')[3].split('=')[1];
                  root.showTransactionId = resJson;

                  root.TransactionDate = new Date();
                  root.TransactionDate = root.datePipe.transform(
                    root.TransactionDate,
                    'MM/dd/yyyy hh:mm:ss aa'
                  );
                  root.SaveData();
                  //root.NextSaveData();
                } else {
                  if (ResponseMessage.includes('Specified API key not found')) {
                    // root.InvalidCreditCardMessage = 'Transaction is unsuccessful. Please try again ';
                    root.InvalidCreditCardMessage = 'Unfortunately, we couldn\'t collect payment on your purchase. Please take a moment to review your billing information. If it looks correct, please contact support.'
                  }
                  else {
                    root.InvalidCreditCardMessage = ResponseMessage;
                  }
                }
                try {
                  root.cdr.detectChanges();
                }
                catch { }

              },
              (err: any) => {
                root.spinners.next('stop');
                root.showSpinner = false;
                root.cdr.detectChanges();
                // console.log(err);
              }
            );

        },

      });
      //here
      // CollectJS.startPaymentRequest((event:any) => {      
      //   console.log('Loading started');
      // })
      // CollectJS.startPaymentRequest({
      // console.log()
      // });
      //});
    }
  };

  PaymentFormSubmit() {
    if (this.CheckRepayValidation()) {
      if (this.objZipValid.IsValidCreditCardZip) {
        this.spinners.next('start');
        this.showSpinner = true;
        setTimeout(() => {
          this.cdr.detectChanges();

        }, 100);
        CollectJS.startPaymentRequest();
        // 
      }
    }
    else {
      this.InvalidCreditCardMessage = Constants.Repay.EmptyField;
    }
  }

  CheckRepayValidation() {
    let validCheckname = document.querySelector("iframe#CollectJSInlinecheckname.CollectJSInlineIframe.CollectJSValid") !== null;
    let validCardNumber = document.querySelector("iframe#CollectJSInlineccnumber.CollectJSInlineIframe.CollectJSValid") !== null;
    let validExpiration = document.querySelector("iframe#CollectJSInlineccexp.CollectJSInlineIframe.CollectJSValid") !== null;
    let validCvv = document.querySelector("iframe#CollectJSInlinecvv.CollectJSInlineIframe.CollectJSValid") !== null;

    return validCheckname && validCardNumber && validExpiration && validCvv;
  }


  StartLoader() {
    // console.log('Loading started');
  }

  GetSelectedPRogramMode() {
    var root = this;
    let ProgramsSelected = '';
    if (root.objProgramInfo.ProgramSelection.DotFederal) {
      ProgramsSelected = 'DOT (' + this.DotCompanyFederalSeletedPrograms + ')';
    }

    if (root.objProgramInfo.ProgramSelection.NonDotCompnay) {
      if (ProgramsSelected != '') {
        ProgramsSelected += ', ';
      }
      ProgramsSelected += 'Non-Dot(Company)';
    }
    if (root.objProgramInfo.ProgramSelection.ClientRequired) {
      if (ProgramsSelected != '') {
        ProgramsSelected += ', ';
      }
      ProgramsSelected += 'Client-Required';
    }
    return ProgramsSelected;
  }

  // convenience getter for easy access to form fields
  get cf() {
    return this.companyForm.controls;
  }
  get employeeFormGet() {
    return this.employeeForm.controls;
  }
  get AckAndAgreementFormGet() {
    return this.AckAndAgreementForm.controls;
  }
  EditDerInfo(Id: any) {
    let ObjDerFind = this.lstDer.find((e: any) => e.Id === Id);
    this.objDer = JSON.parse(JSON.stringify(ObjDerFind));
    this.isShownDerSection = false;
    this.toggleDerSection();
  }

  onChangeFederalProgramTypes(data: any, event: any) {
    let ObjFind = this.lstCheckBoxFederalProgramTypes.find(
      (e: any) => e.item === data.item
    );
    ObjFind.isSelected = event.target.checked;

    let index = this.lstCheckBoxFederalProgramTypes.indexOf(ObjFind);
    if (index == 0) {
      // alert("FMCHS selected")
      if (ObjFind.isSelected == true) {
        this.showListofAuditors = true;
      }
      else {
        this.showListofAuditors = false;
      }

    }
    this.lstCheckBoxFederalProgramTypes[index] = ObjFind;
    this.SetIsFederalProgramsSelected();
    let sum = this.lstCheckBoxFederalProgramTypes
      .filter((e: any) => e.isSelected === true)
      .reduce((acc: any, cur: any) => acc + cur.value, 0);
    // console.log(sum);
    this.objProgramInfo.FederalProgram.FederalProgramTypes = sum;
    this.DotCompanyFederalSeletedPrograms = this.GetTextSelectedList(sum, this.lstCheckBoxFederalProgramTypes);

  }

  SetIsFederalProgramsSelected() {
    if (this.objProgramInfo.ProgramSelection.DotFederal) {
      if (this.lstCheckBoxFederalProgramTypes.filter((e: any) => e.isSelected === true).length > 0) {
        this.IsFederalProgramsSelected = true;
      }
      else {
        this.IsFederalProgramsSelected = false;
      }
    }
    else {
      this.IsFederalProgramsSelected = true;
    }
  }

  SetIsCRProgramsSelected() {
    if (this.objProgramInfo.ProgramSelection.ClientRequired) {
      if (this.lstCheckBoxClientRequiremets.filter((e: any) => e.isSelected === true).length > 0) {
        this.IsCRProgramsSelected = true;
      }
      else {
        this.IsCRProgramsSelected = false;
      }
    }
    else {
      this.IsCRProgramsSelected = true;
    }
  }

  onChangeOtherProgramTypes(data: any, event: any) {
    let ObjFind = this.lstCheckBoxClientRequiremets.find(
      (e: any) => e.item === data.item
    );
    ObjFind.isSelected = event.target.checked;
    // let index = this.lstCheckBoxClientRequiremets.indexOf(ObjFind);
    // this.lstCheckBoxClientRequiremets[index] = ObjFind;
    this.SetIsCRProgramsSelected();
    this.SetExxonMobilDrugTest();
    // let sum = this.lstCheckBoxClientRequiremets
    //   .filter((e: any) => e.isSelected === true)
    //   .reduce((acc: any, cur: any) => acc + cur.value, 0);
    // console.log(sum);
    // this.objProgramInfo.OtherProgram.OtherPrograms = sum;
  }

  onChangeProgramInfoSelection(data: any, event: any) { }

  toggleDerSection() {
    this.isShownDerSection = !this.isShownDerSection;
  }

  toggleDotEmpSection() {
    this.isShownDotEmpSection = !this.isShownDotEmpSection;
    this.empsubmitted = false;
  }

  toggleNonDotEmpSection() {
    this.isShownNonDotEmpSection = !this.isShownNonDotEmpSection;
    this.nonEmpsubmitted = false;
  }
  toggleBillingContactInfoSection() {
    this.isShownBillingContactInfoSection =
      !this.isShownBillingContactInfoSection;
  }

  AddContactInfo() {
    if (this.objBillingInfo.Id === 0) {
      this.objBillingInfo.Id = this.lstDer.length + 1;
      this.lstBillingInfo.push(this.objBillingInfo);
    } else {
      let objBillingContactFind = this.lstBillingInfo.find(
        (e: any) => e.Id === this.objBillingInfo.Id
      );
      let index = this.lstBillingInfo.indexOf(objBillingContactFind);
      this.lstBillingInfo[index] = this.objBillingInfo;
    }
    this.ClearBillingContact();
  }

  PaymentModeClick(IsCreditCard: boolean) {
    this.InvalidCreditCardMessage = '';

    if (this.showTransactionId === '') {
      this.PaymentDetails.IsCreditCard = IsCreditCard;

      if (IsCreditCard) {
        this.PaymentDetails.CreditCardZip = ''
      }
    }

    if (IsCreditCard) {
      this.setRegisterRepay();
    }

  }

  SameAsMailingCheckBoxChanged(event: any) {
    //this.objCompanyInfo.SameAsMailingAddress = event.target.checked;
    if (event.target.checked) {
      this.objCompanyInfo.PhysicalAddress = this.objCompanyInfo.MailingAddress;
      this.objCompanyInfo.PhysicalAddressState = this.objCompanyInfo.State;
      this.objCompanyInfo.PhysicalAddressCity = this.objCompanyInfo.City;
      this.objCompanyInfo.PhysicalAddressZip = this.objCompanyInfo.Zip;
      this.objCompanyInfo.PhysicalFaxNo = this.objCompanyInfo.FaxNo;
      this.objCompanyInfo.PhysicalPhoneNo = this.objCompanyInfo.CompanyPhoneNo;
      this.objZipValid.IsValidPhysicalZip = this.objZipValid.IsValidMailingZip;
    } else {
      this.objCompanyInfo.PhysicalAddress = '';
      this.objCompanyInfo.PhysicalAddressState = this.SelectState;
      this.objCompanyInfo.PhysicalAddressCity = '';
      this.objCompanyInfo.PhysicalAddressZip = '';
      this.objCompanyInfo.PhysicalFaxNo = '';
      this.objCompanyInfo.PhysicalPhoneNo = '';
      this.objZipValid.IsValidPhysicalZip = false;
    }
  }
  changeFaxNo(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalFaxNo = this.objCompanyInfo.FaxNo;
    }
  }

  changePhoneNo(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalPhoneNo = this.objCompanyInfo.CompanyPhoneNo;
    }
  }
  changeMailingAddress(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalAddress = this.objCompanyInfo.MailingAddress;
    }
  }

  changeState(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalAddressState = event;
    }
  }

  changeCountry(event: any) {
    if (event === 'USA') {
      this.ListStates = this.USAStateItems.map(item => item.stateName);
      this.objCompanyInfo.State = this.SelectState;
      this.objCompanyInfo.PhysicalAddressState = this.SelectState;
      this.objCompanyInfo.BillingContact.BillingState = this.SelectState;
      this.Der_Zip_no_mask = '00000';

    } else if (event === 'Canada') {
      this.ListStates = this.CanadaStateItems.map(item => item.stateName);
      this.objCompanyInfo.State = this.SelectProvince;
      this.objCompanyInfo.PhysicalAddressState = this.SelectProvince;
      this.objCompanyInfo.BillingContact.BillingState = this.SelectProvince;
      this.Der_Zip_no_mask = 'AAA AAA'//'L0L 0L0';

    }
    this.objZipValid.IsValidMailingZip = false;
    this.objZipValid.IsValidPhysicalZip = false;
    this.objCompanyInfo.Zip = '';
    this.objCompanyInfo.PhysicalAddressZip = '';

  }

  changeBillingCountry(event: any) {
    if (event === 'USA') {
      this.BillingListStates = this.USAStateItems.map(item => item.stateName);
      this.objCompanyInfo.BillingContact.BillingState = this.SelectState;
      this.BillingZipMask = '00000';
      this.CreditCardZipMask = '00000';
      this.PaymentDetails.IsCreditCardPostalCodeCanada = false;
      this.PaymentDetails.IsCreditCardZipUSA = true;
    } else if (event === 'Canada') {
      this.BillingListStates = this.CanadaStateItems.map(item => item.stateName);
      this.objCompanyInfo.BillingContact.BillingState = this.SelectProvince;
      this.BillingZipMask = 'AAA AAA';
      this.CreditCardZipMask = 'AAA AAA';
      this.PaymentDetails.IsCreditCardPostalCodeCanada = true;
      this.PaymentDetails.IsCreditCardZipUSA = false;
    }
    this.objZipValid.IsValidBillingZip = false;
    this.objCompanyInfo.BillingContact.BillingZip = '';
    this.PaymentDetails.CreditCardZip = '';
  }

  changeCity(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalAddressCity = this.objCompanyInfo.City;
    }
  }

  changeMailingZip(event: any) {
    if (this.objCompanyInfo.SameAsMailingAddress) {
      this.objCompanyInfo.PhysicalAddressZip = this.objCompanyInfo.Zip;
    }

  }

  AddDer() {
    if (this.objDer.Id === 0) {
      this.objDer.Id = this.lstDer.length + 1;
      this.lstDer.push(this.objDer);
    } else {
      let objDerFind = this.lstDer.find((e: any) => e.Id === this.objDer.Id);
      let index = this.lstDer.indexOf(objDerFind);
      this.lstDer[index] = this.objDer;
    }

    if (this.lstDer.length >= 5) {
      this.isShownbtnAddDerInfo = false;
    }
    this.ClearDer();
  }
  ClearBillingContact() {
    this.objBillingInfo = {
      Id: 0,
      OtherBillingContactEmail: '',
      OtherBillingContactName: '',
      OtherBillingContactPhone: '',
    };
    this.toggleBillingContactInfoSection();
  }
  ClearDer() {
    this.objDer = {
      Id: 0,
      Name: '',
      Title: '',
      Email: '',
      PhoneNo: '',
      ExtensionNo: '',
      CellNo: '',
      AlternateName: '',
      AlternatePhoneNo: '',
      AlternateExtensionNo: '',
      AlternateCellNo: '',
      AlternateEmail: '',
    };
    this.toggleDerSection();
  }
  ClearDotEmp() {
    this.ClearFieldsDotEmp();
    this.toggleDotEmpSection();
  }

  ClearFieldsDotEmp() {
    this.objDotEmploye = {
      Id: 0,
      Title: '',
      CDL: false,
      IsSupervisor: false,
    };
  }

  DeleteDotEmp(Id: any) {
    let ObjFind = this.lstDotEmployees.find((e: any) => e.Id === Id);
    let index = this.lstDotEmployees.indexOf(ObjFind);
    this.lstDotEmployees.splice(index, 1);
    this.isShownDotEmpSection = false;
    this.ClearFieldsDotEmp();
    this.CheckJobTitlePosition(ProgramsRequested.DotFederal);
  }

  DeleteNonDotEmp(Id: any) {
    let ObjFind = this.lstNonDotEmployees.find((e: any) => e.Id === Id);
    let index = this.lstNonDotEmployees.indexOf(ObjFind);
    this.lstNonDotEmployees.splice(index, 1);
    this.isShownNonDotEmpSection = false;
    this.CheckJobTitlePosition(ProgramsRequested.NonDotCompany);
  }

  EditContactSection(Id: any) {
    let ObjBillingFind = this.lstBillingInfo.find((e: any) => e.Id === Id);
    this.objBillingInfo = JSON.parse(JSON.stringify(ObjBillingFind));
    this.isShownBillingContactInfoSection = false;
    this.toggleBillingContactInfoSection();
  }

  EditDotEmp(Id: any) {
    let ObjDotEmpFind = this.lstDotEmployees.find((e: any) => e.Id === Id);
    this.objDotEmploye = JSON.parse(JSON.stringify(ObjDotEmpFind));
    this.isShownDotEmpSection = false;
    this.toggleDotEmpSection();
  }

  btnAddDotEmployees() {
    this.ClearDotEmp();
    this.isShownDotEmpSection = true;
  }

  btnSaveDotEmployees() {
    if (this.employeeForm.get('fcJobPosition')?.valid) {
      if (this.objDotEmploye.Id === 0) {
        this.objDotEmploye.Id = this.lstDotEmployees.length + 1;
        this.lstDotEmployees.push(this.objDotEmploye);
        this.CheckJobTitlePosition(ProgramsRequested.DotFederal);
      } else {
        let objDotEmpFind = this.lstDotEmployees.find(
          (e: any) => e.Id === this.objDotEmploye.Id
        );
        let index = this.lstDotEmployees.indexOf(objDotEmpFind);
        this.lstDotEmployees[index] = this.objDotEmploye;
        this.submitted = true;
        this.empsubmitted = false;
      }
      this.ClearDotEmp();
    }
    this.empsubmitted = true;
  }

  btnAddNonDotEmployees() {
    this.ClearNonDotEmp();
    this.isShownNonDotEmpSection = true;
  }



  btnSaveNonDotEmployees() {
    if (this.employeeForm.get('fcNonDotJobPostition')?.valid) {
      if (this.ObjNonDotEmployee.Id === 0) {
        this.ObjNonDotEmployee.Id = this.lstNonDotEmployees.length + 1;
        this.lstNonDotEmployees.push(this.ObjNonDotEmployee);
        this.CheckJobTitlePosition(ProgramsRequested.NonDotCompany);
      } else {
        let objNonDotEmpFind = this.lstNonDotEmployees.find(
          (e: any) => e.Id === this.ObjNonDotEmployee.Id
        );
        let index = this.lstNonDotEmployees.indexOf(objNonDotEmpFind);
        this.lstNonDotEmployees[index] = this.ObjNonDotEmployee;
        this.submitted = true;
      }
      this.ClearNonDotEmp();
    }
    this.nonEmpsubmitted = true;
  }

  EditNonDotEmp(Id: any) {
    let ObjNonDotEmpFind = this.lstNonDotEmployees.find(
      (e: any) => e.Id === Id
    );
    this.ObjNonDotEmployee = JSON.parse(JSON.stringify(ObjNonDotEmpFind));
    this.isShownNonDotEmpSection = false;
    this.toggleNonDotEmpSection();
  }

  ClearNonDotEmp() {
    this.ClearFieldsNonDotEmp();
    this.toggleNonDotEmpSection();
  }

  ClearFieldsNonDotEmp() {
    this.ObjNonDotEmployee = {
      Id: 0,
      Title: '',
      IsSupervisor: false,
    };
  }

  changeTaxIdNo(event: any) {
    this.showTaxIdNo = event.target.value;
  }
  changeIsnNo(event: any) {
    this.showIsnNo = event.target.value;
  }

  changeItsNo(event: any) {
    this.IsValidNumberITSAccountNo = true;
    this.IsValidITSAccountNo = true;

    if (!event.target.value) {
      this.IsValidITSAccountNo = true;
    }
    else {
      if (event.target.value.length > 1) {
        if (event.target.value.length > 20) {
          this.objCompanyInfo.ITSAccountNo = event.target.value.substring(0, 20);
        }
        if (!this.isNumber(event.target.value.substring(0, 20))) {
          this.IsValidNumberITSAccountNo = false;
        }
        else {
          this.IsValidITSAccountNo = true;
        }

      }
      else {
        this.IsValidITSAccountNo = false;
      }
    }
  }


  isNumber(str: any) {
    var pattern = /^\d+\.?\d*$/;
    return pattern.test(str);  // returns a boolean
  }

  isAlphaNumberic(str: any) {
    // var pattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;///^[a-zA-Z0-9 ]*$/;
    var pattern = /^[A-Za-z0-9][A-Za-z0-9][A-Za-z0-9][ -]?[A-Za-z0-9][A-Za-z0-9][A-Za-z0-9]$/;///^[a-zA-Z0-9 ]*$/;
    return pattern.test(str);  // returns a boolean
  }



  ITSNoKeyPress(event: any) {
    if (event.target.value.length === 20) { return false; }
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }



  //Zip Change Events
  ZipKeyPress(event: any) {

    // if (event.target.value.length === 20) { return false; }
    var keyCode = (event.which) ? event.which : event.keyCode



    //let valid = true;
    if (this.objCompanyInfo.Country === EnumCountries.USA) {
      if (event.target.value.length === 5) { return false; }
      if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
        return false;
      }

      // if (event.target.value >= 5)
      // {
      //   return false;
      // }

      // if (!this.isNumber(event.target.value)){
      //   return false;
      // }


    } else {
      if (event.target.value.length === 7) { return false; }

      if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || keyCode == 32)) {
        return false;
      }
      // if (event.target.value >= 7)
      // {
      //   return false;
      // }

      // if (!this.isAlphaNumberic(event.target.value)){
      //   return false;
      // }
    }


    // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    //   return false;
    // }
    return true;
  }


  changeZip(event: any, Zip: any) {
    let IsValid = true;
    let IsValidLength = true;
    let ZipValue = event.target.value;
    let SelectedCountry = this.objCompanyInfo.Country;
    if (Zip === this.objZipCollection.CreditCardZip) {
      SelectedCountry = this.PaymentDetails.IsCreditCardZipUSA ? EnumCountries.USA : EnumCountries.Canada;
    }

    if (!event.target.value) {
      IsValid = true;
    }
    else {
      if (event.target.value.length >= 1) {
        if (SelectedCountry === EnumCountries.USA) {
          if (event.target.value.length >= 5) {
            ZipValue = event.target.value.substring(0, 5);
          }
          else {
            IsValid = false;
          }
        }
        else {
          if (event.target.value.length >= 7) {
            ZipValue = event.target.value.substring(0, 7);
          }
          else {
            IsValid = false;
          }
        }


        IsValidLength = this.CheckZip(ZipValue, SelectedCountry)



        // if (!this.CheckZip(ZipValue)) {
        //   IsValid = false;
        // }
        // else {
        //   IsValid = true;
        // }

      }
      else {
        IsValid = false;
      }
    }

    if (Zip === this.objZipCollection.PhysicalZip) {
      this.objZipValid.IsValidPhysicalZip = (IsValid && IsValidLength);
      this.objCompanyInfo.PhysicalAddressZip = ZipValue;
    }
    else if (Zip === this.objZipCollection.MailingZip) {
      this.objZipValid.IsValidMailingZip = (IsValid && IsValidLength);
      this.objCompanyInfo.Zip = ZipValue;

      if (this.objCompanyInfo.SameAsMailingAddress) {
        this.objZipValid.IsValidPhysicalZip = (IsValid && IsValidLength);
        this.objCompanyInfo.PhysicalAddressZip = ZipValue;
      }
    }
    else if (Zip === this.objZipCollection.BillingZip) {
      this.objZipValid.IsValidBillingZip = (IsValid && IsValidLength);
      this.objCompanyInfo.BillingContact.BillingZip = ZipValue;
    }
    else if (Zip === this.objZipCollection.CreditCardZip) {
      this.objZipValid.IsValidCreditCardZip = (IsValid && IsValidLength);
      if (this.PaymentDetails.CreditCardZip.trim().length === 0) {
        this.objZipValid.IsValidCreditCardZip = true;
      }
      this.PaymentDetails.CreditCardZip = ZipValue;
    }
  }

  CheckZip(str: any, SelectedCountry: any) {
    if (SelectedCountry === EnumCountries.USA) {
      return this.isNumber(str);
    }
    else {
      return this.isAlphaNumberic(str);
    }
  }

  // onChangeCreditCardZip(event: any)
  // {
  //   if (event.target.value.length >= 5) {
  //     this.InvalidCreditCardMessage = '';
  //   }
  // }


  changeCreditCardZip(event: any) {
    let IsValid = false;
    if (!event.target.value) {
      IsValid = true;
    }
    else {
      if (event.target.value.length >= 5) {
        IsValid = true;
      }
      else {
        IsValid = false;
      }
    }
    IsValid;
    if (!IsValid) {
      this.InvalidCreditCardMessage = '5 digits Zip Code is required';
    }
    else {
      this.InvalidCreditCardMessage = '';
    }
  }

  CreditCardZipKeyPress(event: any) {
    if (event.target.value.length > 4) { return false; }
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  changeExtensionNo(event: any, Extension: any) {   
    let IsValid = true;
    let IsValidNumber = true;

    if (!event.target.value) {
      IsValid = true;
    }
    else {
      if (event.target.value.length > 6) {
        if (Extension === ExtensionNo.DerExtension) {
          this.objCompanyInfo.objDer.ExtensionNo = event.target.value.substring(0, 6);
        }
        else if (Extension === ExtensionNo.AlternateDerExtension) {
          this.objCompanyInfo.objDer.AlternateExtensionNo = event.target.value.substring(0, 6);
        }
      }

      if (event.target.value.length >= 3 && event.target.value.length <= 6) {
        if (!this.isNumber(event.target.value.substring(0, 20))) {
          IsValidNumber = false;
        }
        else {
          IsValid = true;
        }
      }

      else {
        IsValid = false;
      }
    }
    if (Extension === ExtensionNo.DerExtension) {
      this.objExtenions.IsValidDerExtensions = IsValid;
      this.objExtenions.IsValidNumberDerExtensions = IsValidNumber;
    }
    else if (Extension === ExtensionNo.AlternateDerExtension) {
      this.objExtenions.IsValidAlternateDerExtensions = IsValid;
      this.objExtenions.IsValidNumberAlternateDerExtensions = IsValidNumber;
    }
  }

  ExtensionNoKeyPress(event: any) {
    if (event.target.value.length > 5) { return false; }
    var charCode = (event.which) ? event.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  changeDERName(event: any) {
    this.showDERName = event.target.value;
  }
  changeDEREmail(event: any) {
    this.showDEREmail = event.target.value;
  }
  changeAlternateDERName(event: any) {
    this.showAlternateDERName = event.target.value;
  }
  changeAlternateDEREmail(event: any) {
    this.showAlternateDEREmail = event.target.value;
  }
  changeBillingContactName(event: any) {
    this.showBillingContactName = event.target.value;
  }
  changeBillingContactEmail(event: any) {
    this.showBillingContactEmail = event.target.value;
  }
  changeBillingAddess(event: any) {
    this.showBillingAddess = event.target.value;
  }
  changeBillingCity(event: any) {
    this.showBillingCity = event.target.value;
  }
  changeBillingState(event: any) {
    this.showBillingState = event;
  }
  changeBillingPhoneNo(event: any) {
    this.showBillingPhoneNo = event.target.value;
  }
  changeBillingExntention(event: any) {
    this.showBillingExntention = event.target.value;
  }
  changeBillingFaxNo(event: any) {
    this.showBillingFaxNo = event.target.value;
  }
  changeConductRandomTest(event: any, CheckBoxType: any) {
    if (event.target.checked) {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.RandomTestigYes = true;
        this.objProgramInfo.RandomTestigNo = false;
      } else {
        this.objProgramInfo.RandomTestigYes = false;
        this.objProgramInfo.RandomTestigNo = true;
      }
    } else {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.RandomTestigYes = false;
        this.objProgramInfo.RandomTestigNo = true;
      } else {
        this.objProgramInfo.RandomTestigYes = true;
        this.objProgramInfo.RandomTestigNo = false;
      }
    }
  }

  changeAdditionalProgram(event: any, CheckBoxType: any) {
    if (event.target.checked) {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.AdditionalProgramYes = true;
        this.objProgramInfo.AdditionalProgramNo = false;
      } else {
        this.objProgramInfo.AdditionalProgramYes = false;
        this.objProgramInfo.AdditionalProgramNo = true;
      }
    } else {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.AdditionalProgramYes = false;
        this.objProgramInfo.AdditionalProgramNo = true;
      } else {
        this.objProgramInfo.AdditionalProgramYes = true;
        this.objProgramInfo.AdditionalProgramNo = false;
      }
    }
  }
  changeNcmClientRequired(event: any, CheckBoxType: any) {
    if (event.target.checked) {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.NcmClientRequiredYes = true;
        this.objProgramInfo.NcmClientRequiredNo = false;
      } else {
        this.objProgramInfo.NcmClientRequiredYes = false;
        this.objProgramInfo.NcmClientRequiredNo = true;
      }
    } else {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.NcmClientRequiredYes = false;
        this.objProgramInfo.NcmClientRequiredNo = true;
      } else {
        this.objProgramInfo.NcmClientRequiredYes = true;
        this.objProgramInfo.NcmClientRequiredNo = false;
      }
    }
  }

  changeNonDotProgramInterest(event: any, CheckBoxType: any) {
    if (event.target.checked) {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.NonDotProgramInterestYes = true;
        this.objProgramInfo.NonDotProgramInterestNo = false;
      } else {
        this.objProgramInfo.NonDotProgramInterestYes = false;
        this.objProgramInfo.NonDotProgramInterestNo = true;
      }
    } else {
      if (CheckBoxType === 'yes') {
        this.objProgramInfo.NonDotProgramInterestYes = false;
        this.objProgramInfo.NonDotProgramInterestNo = true;
      } else {
        this.objProgramInfo.NonDotProgramInterestYes = true;
        this.objProgramInfo.NonDotProgramInterestNo = false;
      }
    }
  }

  next() {    
    var root = this;
    if (root.step == 1) {
      if(this.objCompanyInfo.HearAboutPTC === 8 && !this.objCompanyInfo.HearAboutPTCOther){
        this.hearAboutPTCOtherError = true;
       return ;
      } 
      root.submitted = true;
      // console.log(root.companyForm);
      if(this.objCompanyInfo.HearAboutPTC === HearAboutPTCCheckBoxType.NONE){
        this.hearAboutPTCError = "show"
      }
      
      if (!(this.IsValidITSAccountNo && this.IsValidNumberITSAccountNo && this.objExtenions.IsValidAlternateDerExtensions && this.objExtenions.IsValidDerExtensions && this.objExtenions.IsValidNumberAlternateDerExtensions && this.objExtenions.IsValidNumberDerExtensions) || this.objCompanyInfo.HearAboutPTC === HearAboutPTCCheckBoxType.NONE) {
        window.scrollTo(0, 0);
        return;
      }


      if (root.companyForm.invalid) {
        // try {
        //   this.IsValidITSAccountNo = root.companyForm.controls['fcITSAccountNo'].valid;
        // }
        // catch { }
        window.scrollTo(0, 0);
        return;
      }
    } else if (root.step == 2) {
      root.empsubmitted = true;
    }

    root.step++;

    if (root.step == 4) {
      this.CalculateSummaryPages();
    }

    if (root.step == 5) {
      this.StepPaymentClicked();
    }

    if (root.step == 6) {
    }

    if (root.step <= 5) {

      this.CalculateEnrollmentTotal();
    }
    //localStorage.setItem('objCompanyInfo', JSON.stringify(this.objCompanyInfo));
    window.scrollTo(0, 0);
  }

  handleUpdateCurrentDate(){
    this.http.patch(environment.baseUrl + '/EnrollmentCustomerUpdated/' + this.guid, {CustomerUpdated: new Date()}).subscribe(
      () => {},
      (error) => {
        console.error('PATCH failed:', error);
      }
    );
  }

  StepPaymentClicked() {
    this.InvalidCreditCardMessage = '';
    this.PaymentDetails.CreditCardZip = '';
    this.setRegisterRepay();
  }

  CalculateSummaryPages() {
    this.objProgramInfo.FederalProgram.FederalProgramTypes
    this.DotCompanyFederalSeletedPrograms = this.GetTextSelectedList(this.objProgramInfo.FederalProgram.FederalProgramTypes, this.lstCheckBoxFederalProgramTypes);
    this.SetSummaryData();
    
    // TotalEmployees = (this.objProgramInfo.FederalProgram.NumberOfEmployees +
    //   this.objProgramInfo.CompanyProgram.NumberOfEmployees +
    //   this.objProgramInfo.OtherProgram.NumberOfEmployees);
    
  }

CalculateEnrollmentTotal(customerData: any = {}) {
  this.CalculateSummaryPages()
  
  let stateCode: string = "";
  let TotalEmployees = 0;

  if(customerData?.CustomerDetails){
    if(this.objCompanyInfo.Country === "USA"){
      stateCode =  this.USAStateItems.find(item => item.stateName === customerData?.CustomerDetails?.CompanyDetails?.PhysicalAddress?.State)?.stateCode ?? ""
   } else if(this.objCompanyInfo.Country === "Canada"){
     stateCode =  this.CanadaStateItems.find(item => item.stateName === customerData?.CustomerDetails?.CompanyDetails?.PhysicalAddress?.State)?.stateCode ?? ""
   }
  } else {
    if(this.objCompanyInfo.Country === "USA"){
      stateCode = this.USAStateItems.find(item => item.stateName === this.objCompanyInfo.State)?.stateCode ?? ""
   } else if(this.objCompanyInfo.Country === "Canada"){
     stateCode = this.CanadaStateItems.find(item => item.stateName === this.objCompanyInfo.State)?.stateCode ?? ""
   }
   
  }
  
  const idToken = localStorage.getItem("id_token");
  const headers = { Authorization: `Bearer ${idToken}`,'content-type': 'application/json' };
   this.http
    .get<StateResponse>(environment.baseUrl + `/statesalestax/${stateCode}` , {
      headers: headers,
    }).subscribe((response: StateResponse) =>{
      this.SalesTaxPercent = response.SalesTaxRate
      TotalEmployees = this.objProgramInfo.NumberOfEmployees;
      this.randomPool = (TotalEmployees >= this.MaxEmployees ? this.MaxEmployees : TotalEmployees) * this.CustomerInfo.CustomerDetails.FeeDetails.AnnualEmployeeFee;
      this.EnrollmentTotalFee = this.CustomerInfo.CustomerDetails.FeeDetails.SetupFee + this.CustomerInfo.CustomerDetails.FeeDetails.AnnualSubscription + this.randomPool + this.CustomerInfo.CustomerDetails.FeeDetails.ExpeditedShippingFee;
      this.SalesTax = this.EnrollmentTotalFee * response.SalesTaxRate * 0.01;
      this.EnrollmentTotalFee = this.EnrollmentTotalFee + this.SalesTax;
      this.NextSaveData();
    })
}

  NextSaveData() {
    let obj = this.SetCompanyInfoForSave();
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(obj);
    //this.spinner.show();
    this.http
      .post(environment.baseUrl + '/Next/' + this.guid, body, {
        headers: headers,
      })
      .subscribe(
        (data: any) => {
          this.customerByIdData = data;
          // console.log('Success');
        },
        (err) => {
          this.spinners.next('stop');
          this.showSpinner = false;
          // console.log(err);
        }
      );

  }



  confirm(pdf:any) {
    try
    {
      pdf.export().then((group:any)  => {
        const options = <pdf.PDFOptions>{ paperSize: "A4", landscape: false };
        exportPDF(group, options).then(data => {         
          this.InvoicePdfBase64String = data.replace("data:application/pdf;base64,","");
          var root = this;
          root.SaveData();          
        });
      });     
    }
    catch {}

    // root.cdr.detectChanges();
    // root.appRef.tick();
    //console.log(root.SaveData);
  }

  Finish() {
    ++this.step;
  }

  print(elem: string) {
    let mywindow: any = window.open('', 'PRINT', 'A4');

    mywindow.document.write(
      '<html><head><title>' + document.title + '</title>'
    );
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h1>' + document.title + '</h1>');
    mywindow.document.write(document.getElementById(elem)?.innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }

  GetCompanyDetail() {
    let CompanyDetails = {
      CompanyName: this.objCompanyInfo.CompanyName,
      AffiliatedCompanyName: this.objCompanyInfo.SisterCompanyName,
      AllowCheckPayment: this.objCompanyInfo.AllowCheckPayment,
      ContactPhoneNumber: this.CustomerInfo.CustomerDetails.CompanyDetails.ContactPhoneNumber,
      ReinstatedAccountNumber: this.objCompanyInfo.ReinstatedAccountNumber,
      ContactName : this.objCompanyInfo.ContactName,
      IsReinstatedAccount: this.objCompanyInfo.IsReinstatedAccount,
      Country: this.objCompanyInfo.Country,
      BillingCountry: this.objCompanyInfo.BillingContact.BillingCountry,
      TypeOfWork: this.objCompanyInfo.TypeOfWork,
      FederalTaxID: this.objCompanyInfo.FederalTaxId,
      ITSAccountNumber: this.objCompanyInfo.ITSAccountNo.toString(),
      IsNetworldAccountNo: this.objCompanyInfo.ISNetworldAccountNo,
      IsOilAndGasOperator:
        this.objCompanyInfo.IsOilAndGasOperator === 'YES' ? true : false,
      OilAndGasOperatorCompanyNames:
        this.objCompanyInfo.OilAndGasOperatorCompanyNames,
      SubContractorCompanyNames:
        this.objCompanyInfo.SubContractorCompanyNames,
      HearAboutPTC: this.objCompanyInfo.HearAboutPTC,
      HearAboutPTCOther: this.objCompanyInfo.HearAboutPTCOther,
      PhysicalAddressSameAsMailingAddress:
        this.objCompanyInfo.SameAsMailingAddress,
      MailingAddress: {
        StreetName: this.objCompanyInfo.MailingAddress,
        City: this.objCompanyInfo.City,
        Zip: this.objCompanyInfo.Zip,
        State: this.objCompanyInfo.State,
      },
      PhysicalAddress: {
        StreetName: this.objCompanyInfo.PhysicalAddress,
        City: this.objCompanyInfo.PhysicalAddressCity,
        Zip: this.objCompanyInfo.PhysicalAddressZip,
        State: this.objCompanyInfo.PhysicalAddressState,
      },
    }
    return CompanyDetails;
  }

  GetPrimaryDer() {
    let PrimaryDer = {
      ContactType: 1,
      Name: this.objCompanyInfo.objDer.Name,
      Title: this.objCompanyInfo.objDer.Title,
      EmailAddress: this.objCompanyInfo.objDer.Email,
      Address: {
        PhoneNumber: this.objCompanyInfo.objDer.PhoneNo,
        MobileNumber: this.objCompanyInfo.objDer.CellNo,
        StreetName: '',
        City: '',
        Zip: '',
        State: '',
        FaxNumber: this.objCompanyInfo.objDer.FaxNo,
        Extension: this.objCompanyInfo.objDer.ExtensionNo,
      },
    };
    return PrimaryDer;
  }

  GetSecondaryDer() {
    let SecondaryDer = {
      ContactType: 2,
      Name: this.objCompanyInfo.objDer.AlternateName,
      EmailAddress: this.objCompanyInfo.objDer.AlternateEmail,
      Title: '',
      Address: {
        PhoneNumber: this.objCompanyInfo.objDer.AlternatePhoneNo,
        MobileNumber: this.objCompanyInfo.objDer.AlternateCellNo,
        StreetName: '',
        City: '',
        Zip: '',
        State: '',
        FaxNumber: '',
        Extension: this.objCompanyInfo.objDer.AlternateExtensionNo,
      },
    };

    return SecondaryDer;
  }

  GetPriamryBillingInfo() {
    let PriamryBillingContactInfo = {
      ContactType: 1,
      Name: this.objCompanyInfo.BillingContact.BillingContactName,
      EmailAddress: this.objCompanyInfo.BillingContact.BillingContactEmail,
      Title: '',
      Address: {
        StreetName: this.objCompanyInfo.BillingContact.BillingAddress,
        City: this.objCompanyInfo.BillingContact.BillingCity,
        Zip: this.objCompanyInfo.BillingContact.BillingZip,
        State: this.objCompanyInfo.BillingContact.BillingState,
        PhoneNumber: this.objCompanyInfo.BillingContact.BillingPhoneNo,
        MobileNumber: this.objCompanyInfo.BillingContact.BillingMobileNo,
        FaxNumber: this.objCompanyInfo.BillingContact.BillingFaxNo,
      },
    };

    return PriamryBillingContactInfo;
  }

  GetSecondaryBillingInfo() {
    let SecondaryBillingContactInfo = {
      ContactType: 2,
      Name: this.objBillingInfo.OtherBillingContactName,
      EmailAddress: this.objBillingInfo.OtherBillingContactEmail,
      Title: '',
      Address: {
        StreetName: '',
        City: '',
        Zip: '',
        State: '',
        PhoneNumber: this.objBillingInfo.OtherBillingContactPhone,
        MobileNumber: '',
        FaxNumber: '',
      },
    };
    return SecondaryBillingContactInfo;
  }


  GetAckAndAgreement() {
    let AckAndAgreement = null;
    if (this.AckAndAgreement.AckDate != '') {
      AckAndAgreement = {
        CompanyRepresentativeName:
          this.AckAndAgreement.CompanyRepresentativeName,
        CompanyName: this.AckAndAgreement.CompanyName,
        NoRefundCreditPolicy: this.AckAndAgreement.NoRefundCreditPolicy,
        ElectronicTransmissionAck:
          this.AckAndAgreement.ElectronicTransmissionAck,
        ConsumerReportAck: this.AckAndAgreement.ElectronicSignatureAck,
        ElectronicSignatureAck: this.AckAndAgreement.ElectronicSignatureAck,
        OutlineServicesCosts: this.AckAndAgreement.OutlineServicesCosts,
        ServiceAgreement: this.AckAndAgreement.ServiceAgreement,
        // AckDate: this.AckAndAgreement.AckDate,
        AckDate: new Date(this.AckAndAgreement.AckDate),
      }
    }

    return AckAndAgreement;
  }

  SaveData() {
    try {
      let ObjFind = this.lstCheckBoxFederalProgramTypes.find(
        (e: any) => e.item === "PHMSA"
      );

      if (!ObjFind.isSelected) {
        this.objProgramInfo.LisOfAuditors = '';
      }
    }
    catch { }
    this.spinners.next('start');
    this.showSpinner = true;
    let obj = this.SetCompanyInfoForSave();
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(obj);
    // console.log(body);

    this.http
      .post(environment.baseUrl + '/Save/' + this.guid, body, {
        headers: headers,
      })
      .subscribe(
        (data: any) => {

          // console.log('Success');
          this.CustomerId = this.CustomerInfo.CustomerId;

          this.CustomerDetail = data;
          this.IsPassCustomerDetail = true;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 50);
          this.SetDataForProfilePdf(this.CustomerDetail);
          // console.log(JSON.stringify(this.CustomerDetail));
          ++this.step;
          this.spinners.next('stop');
          this.showSpinner = false;
          try {
            this.cdr.detectChanges();
          }
          catch { }



          // this.http
          //   .get(environment.baseUrl + `/CustomerDetails/${this.CustomerId}`, {
          //     headers: {
          //       'Content-Type': 'application/json',
          //       'Accept': 'application/json',
          //     },
          //   })
          //   .subscribe(
          //     (res: any) => {

          //       this.CustomerDetail = res;
          //       this.IsPassCustomerDetail = true;
          //       setTimeout(() => {
          //         this.cdr.detectChanges();
          //       }, 50);
          //       this.SetDataForProfilePdf(this.CustomerDetail);
          //       console.log(JSON.stringify(this.CustomerDetail));

          //       this.spinners.next('stop');
          //       this.showSpinner = false;
          //       try {
          //         this.cdr.detectChanges();
          //       }
          //       catch { }
          //     }, (err) => {
          //       this.spinners.next('stop');
          //       this.showSpinner = false;
          //       console.log(err);
          //     });



        },
        (err) => {
          this.spinners.next('stop');
          this.showSpinner = false;
          // console.log(err);
        }
      );
  }

  getFeeDetails(){
    this.SetDataForProfilePdf(this.CustomerInfo);
    const AnnualEmployeeFee = (this.CustomerInfo.CustomerDetails.FeeDetails.AnnualEmployeeFee * (this.TotalEmployees >= this.MaxEmployees ? this.MaxEmployees : this.TotalEmployees))
   return {
      SetupFee: this.CustomerInfo?.CustomerDetails?.FeeDetails?.SetupFee,
      AnnualSubscription: AnnualEmployeeFee,
      AnnualEmployeeFee: (this.CustomerInfo?.CustomerDetails?.FeeDetails?.AnnualEmployeeFee * (this.TotalEmployees >= this.MaxEmployees ? this.MaxEmployees : this.TotalEmployees)),
      DrugTest: this.objFeesInfo.PerUseFees.DrugTest,
      ExxonMobilDrugTest: this.objFeesInfo.PerUseFees.ExxonMobilDrugTest,
      AlcoholTest: this.objFeesInfo.PerUseFees.AlcoholTest,
      DOTHistoryCheck: this.objFeesInfo.PerUseFees.DOTHistoryCheck,
      MobileTestingCharges: this.objFeesInfo.PerUseFees.MobileTestingCharges,
      TestingFees: this.objFeesInfo.PerUseFees.TestingFees,
      ExpeditedShippingFee: this.CustomerInfo?.CustomerDetails?.FeeDetails?.ExpeditedShippingFee,
  }
  }

  SetCompanyInfoForSave() {
    let ObjCreditCardDetials: any;

    if (this.PaymentDetails.CreditCardDetails.CardNumber) {
      ObjCreditCardDetials = {
        CardHolderName: this.PaymentDetails.CreditCardDetails.CardHolderName,
        CardNumber: this.PaymentDetails.CreditCardDetails.CardNumber,
        CVC: this.PaymentDetails.CreditCardDetails.CVC,
        ExpiryMonth: this.PaymentDetails.CreditCardDetails.ExpiryMonth,
        ExpiryYear: this.PaymentDetails.CreditCardDetails.ExpiryYear
      }
    }
    else {
      ObjCreditCardDetials = null;
    }

    let DefaultFederalProgramType = 0;
    if (this.objProgramInfo.ProgramSelection.DotFederal) {
      DefaultFederalProgramType += 1;
    }

    if (this.objProgramInfo.ProgramSelection.NonDotCompnay) {
      DefaultFederalProgramType += 2;
    }

    if (this.objProgramInfo.ProgramSelection.ClientRequired) {
      DefaultFederalProgramType += 4;
    }
    let CrPrgramsSelected: any = [];
    this.lstCheckBoxClientRequiremets.forEach((objCr: any) => {
      if (objCr.isSelected) {
        let obj = { CRProgramGuid: objCr.value, };
        CrPrgramsSelected.push(obj);
      }
    });


    var obj = {
      DefaultFederalProgramType: DefaultFederalProgramType,
      DefaultNonDOTProgramTypes:
        this.objProgramInfo.FederalProgram.FederalProgramTypes,
      Auditors: this.objProgramInfo.LisOfAuditors.match(/[^\r\n]+/g),
      CRPrograms: CrPrgramsSelected,
      EmailBodyInBase64: this.InvoicePdfBase64String,
      InvoiceNumber: this.InvoiceNumber,
      AuditAgencies: this.objCompanyInfo.ListOfAgencies.match(/[^\r\n]+/g),
      CurrentTabName: this.step.toString(),
      CompanyDetails: this.GetCompanyDetail(),
      AllowCheckPayment: this.objCompanyInfo.AllowCheckPayment,
      LastModifiedDateTime: this.CustomerInfo?.LastModifiedDateTime,
      // CompanyDetails: {
      //   CompanyName: this.objCompanyInfo.CompanyName,
      //   AffiliatedCompanyName: this.objCompanyInfo.SisterCompanyName,
      //   ReinstatedAccountNumber: this.objCompanyInfo.ReinstatedAccountNumber,
      //   IsReinstatedAccount: this.objCompanyInfo.IsReinstatedAccount,
      //   TypeOfWork: this.objCompanyInfo.TypeOfWork,
      //   FederalTaxID: this.objCompanyInfo.FederalTaxId,
      //   ITSAccountNumber: this.objCompanyInfo.ITSAccountNo.toString(),
      //   IsNetworldAccountNo: this.objCompanyInfo.ISNetworldAccountNo,
      //   IsOilAndGasOperator:
      //     this.objCompanyInfo.IsOilAndGasOperator === 'YES' ? true : false,
      //   OilAndGasOperatorCompanyNames:
      //     this.objCompanyInfo.OilAndGasOperatorCompanyNames,
      //   SubContractorCompanyNames:
      //     this.objCompanyInfo.SubContractorCompanyNames,
      //   HearAboutPTC: this.objCompanyInfo.HearAboutPTC,
      //   HearAboutPTCOther: this.objCompanyInfo.HearAboutPTCOther,
      //   PhysicalAddressSameAsMailingAddress:
      //     this.objCompanyInfo.SameAsMailingAddress,
      //   MailingAddress: {
      //     StreetName: this.objCompanyInfo.MailingAddress,
      //     City: this.objCompanyInfo.City,
      //     Zip: this.objCompanyInfo.Zip,
      //     State: this.objCompanyInfo.State,
      //   },
      //   PhysicalAddress: {
      //     StreetName: this.objCompanyInfo.PhysicalAddress,
      //     City: this.objCompanyInfo.PhysicalAddressCity,
      //     Zip: this.objCompanyInfo.PhysicalAddressZip,
      //     State: this.objCompanyInfo.PhysicalAddressState,
      //   },
      // },
      DERs: [] as any,
      BillingContacts: [] as any,
      PTCProgramDetails: {
        FederalProgram: {
          FederalPrograms:
            this.objProgramInfo.FederalProgram.FederalProgramTypes,
          // NumberOfEmployees: this.objProgramInfo.FederalProgram.NumberOfEmployees === null ? 0 : this.objProgramInfo.FederalProgram.NumberOfEmployees,
          NonDOTPrograms: 0,
          FederalCDL: this.selectedItem.value,//this.objProgramInfo.CdlUseRequire,
          Employees: this.lstDotEmployees,
        },
        CompanyProgram: {
          IsRandomTesting: this.selectedItemIsRandomTesting.value,
          IsRandomDrugAndAlcoholTesting: this.selectedItemDrugAndAlcohol.value,
          DrugTestPanel: this.selectedDrugTestPanelItems.value,
          // NumberOfEmployees: this.objProgramInfo.CompanyProgram.NumberOfEmployees === null ? 0 : this.objProgramInfo.CompanyProgram.NumberOfEmployees,
          Employees: this.lstNonDotEmployees,
        },
        NCMSProgram: null,
        OtherProgram: {
          OtherPrograms: this.objProgramInfo.OtherProgram.OtherPrograms,
          OtherName: this.objProgramInfo.OtherProgram.OtherName,
          //NumberOfEmployees: this.objProgramInfo.OtherProgram.NumberOfEmployees === null ? 0 : this.objProgramInfo.OtherProgram.NumberOfEmployees,
        },
        NumberOfEmployees: this.objProgramInfo.NumberOfEmployees === null ? 0 : Number(this.objProgramInfo.NumberOfEmployees),
      },
      PaymentDetails: {
        IsCreditCard: this.PaymentDetails.IsCreditCard,
        CreditCardDetails: ObjCreditCardDetials
      },
      FeeDetails: this.getFeeDetails(),
      FeeEnrollmentTotal: this.EnrollmentTotalFee,
      SalesTaxRate: this.SalesTaxPercent,
      RepayTransactionId: this.showTransactionId,
      AckAndAgreement: this.GetAckAndAgreement()
    };

    obj.DERs.push(this.GetPrimaryDer());
    obj.DERs.push(this.GetSecondaryDer());
    obj.BillingContacts.push(this.GetPriamryBillingInfo());
    obj.BillingContacts.push(this.GetSecondaryBillingInfo());


    return obj;
  }


  tempPdfGenerator() {

    this.http
      .get(environment.baseUrl + `/CustomerDetails/40`, {
        headers: {
          Authorization: `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjQxNkM2N0MxQUFDRDhGNjY3NTY0QUJDMzIxQkEwQTM5NTg3NTY2MzIiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJRV3hud2FyTmoyWjFaS3ZESWJvS09WaDFaakkifQ.eyJuYmYiOjE2NzQ1Njc2NjYsImV4cCI6MTY3NDU3MTI2NiwiaXNzIjoiaHR0cHM6Ly9sb2dpbmRldi5jb21wb3VuZC1jb25uZWN0LmNvbSIsImF1ZCI6WyJodHRwczovL2xvZ2luZGV2LmNvbXBvdW5kLWNvbm5lY3QuY29tL3Jlc291cmNlcyIsInVzZXJhcGkiXSwiY2xpZW50X2lkIjoiZWNvbnNvbGVfdGVzdF9jb2RlIiwic3ViIjoiYTM5NDVhNmMtZmNkOS00NjI1LTlkMDItNWYyYjVlNzk3YmQ5IiwiYXV0aF90aW1lIjoxNjc0NTY0OTg5LCJpZHAiOiJsb2NhbCIsInB0Y29ubGluZUlkIjoicHRjZGVtbyIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWUiOiJwdGNkZW1vIiwiaHR0cDovL3NjaGVtYXMueG1sc29hcC5vcmcvd3MvMjAwNS8wNS9pZGVudGl0eS9jbGFpbXMvZW1haWxhZGRyZXNzIjoiamVmZkBwaXBlbGluZXRlc3RpbmcuY29tIiwiZW1haWwiOiJqZWZmQHBpcGVsaW5ldGVzdGluZy5jb20iLCJ1c2VyaWQiOiJhMzk0NWE2Yy1mY2Q5LTQ2MjUtOWQwMi01ZjJiNWU3OTdiZDkiLCJmaXJzdG5hbWUiOiJQVEMiLCJsYXN0bmFtZSI6IkRlbW8iLCJDb21wYW55SUQiOiIzMDk4IiwiY29tcGFueSI6IlBUQyBPTkxJTkUgREVNTyBDT01QQU5ZIiwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsInVzZXJhcGkiLCJvZmZsaW5lX2FjY2VzcyJdLCJhbXIiOlsicHdkIl19.H8fzQPl0je63v5Wk2d4Dt8AxTlwkU1qFmX61o2V5oVWUfhM9yb-XFjcRdeI0TtH4yUu5YUKt-E4tqWzrNJoDAd1Jv-FEnSQ_xftuzX-Vl9QaL0wBrPL6T0Dtq0oZ1JSUBo8S9XkUZmNlHRxDBE6b7i-m9quTSaL1y9hDyueKMaKxK9oTIMt2d58RVkExsR0ONh0uO6XNCchi1nannwhJ1Khjru343RCXHJQ4n8EzVrRPXYdWGmFVkNp0FWaFhwKfvcxAN7zVMFoK-5s1ZJ9Jo8OPhR0cjei3UR0VO0AiC4trlJEi6_JB2TE2FbbC15f4mkayrT9vZt3Y7jnWdzDgWg`,
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      })
      .subscribe(
        (res: any) => {
          this.CustomerDetail = res;
          this.SetDataForProfilePdf(this.CustomerDetail);
          this.spinners.next('stop');
          this.showSpinner = false;

          this.IsPassCustomerDetail = true;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);

          // console.log(JSON.stringify(this.CustomerDetail));

          try {
            this.cdr.detectChanges();
          }
          catch { }
        }, (err) => {
          this.spinners.next('stop');
          this.showSpinner = false;
          // console.log(err);
        });
  }


  SetDataForProfilePdf(CustomerData: any) {
    this.customerByIdData = CustomerData

    // console.log(JSON.stringify(CustomerData));
    this.AffiliatedCompanyName = this.customerByIdData.CustomerDetails.CompanyDetails.AffiliatedCompanyName;
    this.ReinstatedAccountNumber = this.customerByIdData.CustomerDetails.CompanyDetails.ReinstatedAccountNumber;
    //this.InvoiceNumber = this.customerByIdData.CustomerDetails.InvoiceNumber;

    // console.log(this.customerByIdData);
    // if (this.customerByIdData.Notes.length == 1 && this.customerByIdData.Notes[0].Notes == "") {
    //   this.displayData = [];
    // }
    // else {
    //   this.displayData = this.customerByIdData.Notes;
    // }
    this.SetCRProgramSelectedList(this.customerByIdData.CustomerDetails.CRPrograms);
    this.SetExxonMobilDrugTest();
    // this.displayData.reverse();
    this.EnrollmentStatusForResendEmail = this.customerByIdData.EnrollmentStatus;
    this.CompanyName = this.customerByIdData.CompanyName;
    try {
      this.TotalEmployees =
        this.customerByIdData.CustomerDetails.PTCProgramDetails.NumberOfEmployees ;
    } catch { }

    let valueHearAbout = this.customerByIdData.CustomerDetails.CompanyDetails.HearAboutPTC;
    if (valueHearAbout === 0) {
      this.HearAboutValue = HearAboutPTCCheckBoxType[HearAboutPTCCheckBoxType.NONE];
    } else {
      this.HearAboutValue = this.GetTextSelectedList(
        valueHearAbout,
        this.lstHearAboutPTCCheckBoxType
      );
    }
    this.setAckDate();
    this.AckAndAgreementValue =
      this.customerByIdData.CustomerDetails.AckAndAgreement;
    // console.log(this.AckAndAgreementValue);
    if(this.AckAndAgreementValue){
      this.AckDate = this.datePipe.transform(
        this.AckAndAgreementValue.AckDate,
        'MM/dd/yyyy'
      );
    }
    this.AckDate = this.AckDate == "01/01/0001" ? "" : this.AckDate;
    let FedralProgramsValues =
      this.customerByIdData.CustomerDetails.PTCProgramDetails
        .FederalProgram.FederalPrograms;

    this.FederalPrgramsSelected = this.GetTextSelectedList(
      FedralProgramsValues,
      this.lstCheckBoxFederalProgramTypes
    );

    this.GetProgramsRequested(
      this.customerByIdData.CustomerDetails.DefaultFederalProgramType
    );
    this.ClientProgramSelected = this.GetSelectedClientRequiredText();//this.lstCheckBoxClientRequiremets.filter((e: any) => e.isSelected === true).map((m:any) => m.CRProgramName).join(', ');
    // this.ClientProgramSelected = this.GetTextSelectedList(
    //   this.customerByIdData.CustomerDetails.PTCProgramDetails
    //     .OtherProgram.OtherPrograms,
    //   this.lstCheckBoxClientRequiremets
    // );

    // this.lstCheckBoxClientRequiremets = this.GetCheckBoxList(
    //   this.customerByIdData.CustomerDetails.PTCProgramDetails
    //     .OtherProgram.OtherPrograms,
    //   this.lstCheckBoxClientRequiremets
    // );

    let DrugTestPanelApi =
      this.customerByIdData.CustomerDetails.PTCProgramDetails
        .CompanyProgram.DrugTestPanel;

    this.DrugTestPanelValue = this.DrugTestPanelItems.filter(
      (_) => _.value == DrugTestPanelApi
    )[0].text;


    this.objProgramSelection = this.GetSelectedListProgramInfo(this.customerByIdData.CustomerDetails.DefaultFederalProgramType, this.objProgramSelection);
    //this.requestEnded();
  }

  SetCRProgramSelectedList(CrPrgramsList: any) {
    try {
      if (CrPrgramsList) {
        CrPrgramsList.forEach((objCr: any) => {
          let ObjFind = this.lstCheckBoxClientRequiremets.find(
            (e: any) => e.value === objCr.CRProgramGuid
          );
          if(ObjFind.isSelected){
            ObjFind.isSelected = true;
          } else {
            ObjFind.isSelected = false;
          }
        });
      }
    }
    catch { }
  }



  GetSelectedClientRequiredText() {
    let lst: any = [];
    this.lstCheckBoxClientRequiremets.forEach((objCr: any) => {
      if (objCr.isSelected) {
        lst.push(objCr.item);
      }
    });
    return lst.join(", ");
  }

  GetSelectedListProgramInfo(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;

    if (RemainingValues - 4 >= 0) {
      lstCheckBox.ClientRequired = true;
      RemainingValues = RemainingValues - 4;
    }

    if (RemainingValues - 2 >= 0) {
      lstCheckBox.NonDotCompnay = true;
      RemainingValues = RemainingValues - 2;
    }

    if (RemainingValues - 1 >= 0) {
      lstCheckBox.DotFederal = true;
      RemainingValues = RemainingValues - 1;
    }
    return lstCheckBox;
  }

  GetProgramsRequested(FedralProgramsValues: any) {
    let RemainingValues = FedralProgramsValues;

    let lstProgramsRequested = [];

    if (RemainingValues - 4 >= 0) {
      lstProgramsRequested.push('Client Required');
      RemainingValues = RemainingValues - 4;
    }

    if (RemainingValues - 2 >= 0) {
      lstProgramsRequested.push('Non-DOT (Company)');
      RemainingValues = RemainingValues - 2;
    }

    if (RemainingValues - 1 >= 0) {
      lstProgramsRequested.push('DOT (' + this.FederalPrgramsSelected + ')');
      RemainingValues = RemainingValues - 1;
    }

    this.ProgramsRequested = lstProgramsRequested.reverse().join(', ');
  }

  GetCheckBoxList(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;

    for (let i = lstCheckBox.length - 1; i >= 0; i--) {
      if (RemainingValues - lstCheckBox[i].value >= 0) {
        lstCheckBox[i].isSelected = true;
        RemainingValues = RemainingValues - lstCheckBox[i].value;
      } else {
        lstCheckBox[i].isSelected = false;
      }
    }

    // let PrgramSelected = '';
    // for (let i = FederalProgramTextList.length - 1; i >= 0; i--) {
    //   if (PrgramSelected != '') {
    //     PrgramSelected += ', ';
    //   }
    //   PrgramSelected += FederalProgramTextList[i];
    // }
    return lstCheckBox;
  }

  // getCustomersById(id: any) {
  //   let options = {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Accept': 'application/json',
  //     }
  //   }
  //   return this.http.get(environment.baseUrl + `/CustomerDetails/${id}`,options);
  // }
  OutlineServicesCosts() {
    this.AckAndAgreement.OutlineServicesCosts =
      !this.AckAndAgreement.OutlineServicesCosts;

    if (this.AckAndAgreement.OutlineServicesCosts == true) {
      let outlineServicesText = '';
      outlineServicesText += '<p>The following services will be performed by our company:</p>'

      outlineServicesText += '<ul><li><h2 style="margin-bottom:5px;">Policy & Procedure Manual</h2><p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy & procedure manual). Applicant and employee acknowledgment forms are included.</p></li><li><h2 style="margin-bottom:5px;">Certified Laboratory Services</h2><p>Drug testing laboratory services for the program is a Substance Abuse and Mental Health Services Administration (SAMHSA), certified laboratory. The lab for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p></li><li><h2 style="margin-bottom:5px;">Medical Review Officer (MRO) Services</h2><p>The MRO oversees the drug testing results to ensure validity of the results and to make sure that the employee\'s rights are preserved. The MRO for our program is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, Kansas 67502.</p></li><li><h2 style="margin-bottom:5px;">Collection Kit</h2><p>Testing supplies and kits are provided at no charge with clients only paying for shipping and handling.</p></li><li><h2 style="margin-bottom:5px;">Collection Sites</h2><p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctors office). Approved collection sites are identified on our website (www.pipelinetesting.com). All collection sites utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations. </p></li><li><h2 style="margin-bottom:5px;">Breath Alcohol Technician (BAT) Services</h2><p>Trained BATs and collection facilities are provided by either mobile service or walk-in facilities.</p></li><li><h2 style="margin-bottom:5px;">Testing Schedule</h2><p>All employees working in a "covered" position are subject to unannounced testing based on random selection. All random selections are computer generated. The current annualized random drug testing rate is published on <a class="a-link d-inline py-0" href="https://www.transportation.gov/odapc/random-testing-rates" target="_blank">Random Testing Rates</a> for employees subject to the PHMSA regulations.</p></li><li><h2 style="margin-bottom:5px;">Employee Assistance Program (EAP) & Supervisor Training</h2><p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p></li><li><h2 style="margin-bottom:5px;">Substance Abuse Professional (SAP) Services</h2><p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p></li><li><h2 style="margin-bottom:5px;">Drug/Alcohol History Checks</h2><p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant\'s previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p></li><li><h2 style="margin-bottom:5px;">Recordkeeping</h2><p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p></li><li><h2 style="margin-bottom:5px;">PTC Online Access</h2><p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p></li><li><h2 style="margin-bottom:5px;">ePay<sup>TM</sup></h2><p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p></li><li><h2 style="margin-bottom:5px;">Statistical Data Reporting</h2><p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p></li><li><h2 style="margin-bottom:5px;">Compliance Audits and/or Updates</h2><p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p><p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p></li></ul>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Policy & Procedure Manual</b></h2>';
      // outlineServicesText +=
      // '<p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy & procedure manual). Applicant and employee acknowledgment forms are included.</p>';
      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Certified Laboratory Services</b></h2>';
      // outlineServicesText +=
      // '<p>Drug testing laboratory services for the program is a Substance Abuse and Mental Health Services Administration (SAMHSA), certified laboratory. The lab for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p>';
      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Medical Review Officer (MRO) Services</b></h2>';
      // outlineServicesText +=
      // '<p>The MRO oversees the drug testing results to ensure validity of the results and to make sure that the     employee\'s rights are preserved. The MRO for our program is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, Kansas 67502</p>';
      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Collection Kit</b></h2>';
      // outlineServicesText +=
      // '<p>PTC furnishes all relevant drug and alcohol collection supplies, including chain of custody forms, to the employer at no extra charge via ground delivery. Overnight shipping and handling of the specimen to the lab is also included.</p>';
      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Collection Sites</b></h2>';
      // outlineServicesText +=
      // '<p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctor’s office). Approved collection sites are identified on our website (www.pipelinetesting.com) as Preferred (P), Standard (blue pushpin), and even sites with higher than average testing fees (yellow pushpin) in which a surcharge may apply. All collection sites utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Breath Alcohol Technician (BAT) Services</b></h2>';
      // outlineServicesText +=
      // '<p>Trained BATs and collection facilities are provided by either mobile service or walk-in facilities.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Testing Schedule</b></h2>';
      // outlineServicesText +=
      // '<p>All employees working in a "covered" position are subject to unannounced testing based on random selection. All random selections are computer generated. The current annualized random drug testing rate is published on https://www.transportation.gov/odapc/random-testing-rates for employees subject to the PHMSA regulations.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Employee Assistance Program (EAP) & Supervisor Training</b></h2>';
      // outlineServicesText +=
      // '<p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Substance Abuse Professional (SAP) Services</b></h2>';
      // outlineServicesText +=
      // '<p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p>';
      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Drug/Alcohol History Checks</b></h2>';
      // outlineServicesText +=
      // '<p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant&rsquo;s previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Recordkeeping</b></h2>';
      // outlineServicesText +='<p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>PTC Online Access</b></h2>';
      // outlineServicesText +=
      // '<p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>ePay<sup>TM</sup></b></h2>';
      // outlineServicesText +=
      // '<p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Statistical Data Reporting</b></h2>';
      // outlineServicesText +=
      // '<p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p>';

      // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Compliance Audits and/or Updates</b></h2>';
      // outlineServicesText +=
      // '<p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p>';


      // outlineServicesText +=
      // '<p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p>';

      outlineServicesText += '<h2 style="margin-bottom:8px"><b>FEES FOR ALL SERVICES AS OUTLINED</b></h2>';
      outlineServicesText += '<table cellpadding="4" style=" width: 92%; margin: 0 auto;"><tr><td style="width:90px" class="text-right pr-3 align-top">$250.00</td><td><b>Administration Fee</b><br /><span style="font-size:13px; line-height:14px">(one time set-up charge)</span></td></tr><tr><td class="text-right pr-3 align-top">$550.00</td><td><b>Annual Subscription Fee / Renewal </b><br/><span style="font-size:13px; line-height:13px">(This fee covers statistical data reporting, assistance with compliance audits, record keeping, etc.)</span></td></tr><tr><td class="text-right pr-3 align-top">$30.00</td><td><b>Annual Employee Fee</b><br/><span style="font-size:13px; line-height:13px"><i>(This fee covers the supervisor training module, EAP informational materials, posters, testing schedules, and related program resources. The annual employee fee is calculated based on the average number of employees during the previous 12 months at a rate of $30.00 per employee, with a maximum annual employee fee of $6,000.00.)</i></span></td></tr><tr><td class="text-right pr-3 align-top">$85.00</td><td><b>Each Drug Test</b><br/><span style="font-size:13px; line-height:13px">(This fee covers the specimen collection, laboratory and MRO fees.)*</span></td></tr><tr><td class="text-right pr-3 align-top">$85.00</td><td><b>Each Alcohol Test</b><br/><span style="font-size:13px; line-height:13px">(This fee covers the initial and confirmation alcohol testing fee.)*</span></td></tr><tr><td class="text-right pr-3 align-top">$18.00</td><td><b>Each Drug/Alcohol History Check</b><br/><span style="font-size:13px; line-height:13px">Required by 49 CFR Part 40.25.<br/><i>$25 history check fee applies if legacy paper authorization method utilized. (Checks performed through PTC Assist, LLC.)</i></span></td></tr></table>';

      outlineServicesText += '<div style="border:2px solid #ccc" class="px-4 py-3 my-4"><h2 class="text-center" style="margin-bottom:5px">"Example Estimate Based on Five (5) Employees"</h2><p class="text-center">(Adjust the estimate for the number of "covered" employees for your company.)</p><table style="width: 86%; margin: 0 auto;" cellpadding="0"><tr><td><strong>Administration Fee (1x fee)</strong></td><td class="text-right">$250.00</td><td></td></tr><tr><td><strong>Annual Subscription Fee / Renewal </strong></td><td class="text-right">$550.00</td></tr><td></td><tr><td><strong>Annual Employee Fee</strong></td><td class="text-right"></td><td></td></tr><tr><td><strong>(5 Employees X $30.00)</strong></td><td class="text-right"><span style="text-decoration:underline">$150.00</span></td><td><span style="font-size:13px">&nbsp;(Maximum Employee Fee $6,000)</span></td></tr><tr><td><strong>Total</strong></td><td class="text-right">$950.00</td><td></td></tr></table><p style="font-size:13px;font-weight:bold; padding-top:20px">**NOTE** All drug and/or alcohol tests will be invoiced after completion at $85.00 per test  if and when any testing is completed. The DOT required history checks will also be invoiced after completion.</p><p style="font-size:13px;">If previous drug testing had been conducted with a SAMHSA certified lab and all tests were DOT 5-panel tests and your company has been conducting random testing at the proper annualized rate. The drug testing records may be transferred with employee release. Contact us with further questions regarding the potential for you to transfer your past DOT records.</p></div>';

      outlineServicesText += '<p>*PTC consolidates all fees associated with alcohol and drug testing. PTC will pay up to a pre-determined, maximum collection fee per test. Other charges may apply for after-hour, on-site, out-of-network, or non-standard rate testing.</p>';

      Swal.fire({
        title: 'Outline of Services and Costs',
        html: outlineServicesText,
      });
    }


    this.setAckDate();
  }
  ServiceAgreement() {
    this.AckAndAgreement.ServiceAgreement =
      !this.AckAndAgreement.ServiceAgreement;

    if (this.AckAndAgreement.ServiceAgreement == true) {
      let serviceAgreementText = '';
          
          serviceAgreementText += '<p style="margin:5px 20px;">The U.S. Department of Transportation (DOT) has published rules requiring DOT covered employers to test certain employees under certain circumstances for the presence of certain prohibited drugs and alcohol and to provide such employees with an employee assistance program. The ' + this.objCompanyInfo.CompanyName + ' is subject to performing covered employee functions under and subject to the aforesaid rules and is required and desires to comply with said DOT requirements and/or the ' + this.objCompanyInfo.CompanyName + ' is an employer conducting NON-DOT drug and alcohol testing and wishes to adopt an Alcohol and Drug Program pursuant to the DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements.</p>';
          
          serviceAgreementText += '<p style="margin:5px 20px;">' + this.objCompanyInfo.CompanyName + ' desires to engage Pipeline Testing Consortium, Inc. (PTC), a Kansas Corporation, and PTC desires to be engaged to assist ' + this.objCompanyInfo.CompanyName + ' in administering their Alcohol and Drug programs and desires to contract with the ' + this.objCompanyInfo.CompanyName + ' to assist, and act as ' + this.objCompanyInfo.CompanyName + '’s agent, in administering its program by administering the Testing (pre-employment, post-accident, at random, reasonable cause, return-to-duty or follow-up) Employee Assistance Program, and Recordkeeping functions of the DOT regulations and/or NON-DOT requirements. PTC wishes to enlist ' + this.objCompanyInfo.CompanyName + ' in a Consortium of DOT-regulated employers and/or NON-DOT employers for greater efficiency in compliance with said regulations and/or ' + this.objCompanyInfo.CompanyName + ' requirements.</p>';
          
          serviceAgreementText += '<p style="margin:5px 20px;">THEREFORE, ' + this.objCompanyInfo.CompanyName + ' hereby contracts with PTC to administer the Alcohol and Drug Testing, Employee Assistance Program, and Recordkeeping functions required of ' + this.objCompanyInfo.CompanyName + ' by the DOT regulations and/or NON-DOT requirements, upon the following terms and conditions:</p>';
          
          serviceAgreementText += '<ol style="margin:10px;">'
          
          + '<li><h2 style="margin-bottom:5px;">SERVICES</h2><p>PTC will provide ' + this.objCompanyInfo.CompanyName + ' with an Alcohol and Drug Program that is intended to be adopted and used by ' + this.objCompanyInfo.CompanyName + ' in conjunction with its business as an operator or contractor under the applicable DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements. ' + this.objCompanyInfo.CompanyName + ' hereby agrees to execute through PTC a Drug Testing and Service Agreement with Clinical Reference Laboratory, 8433 Quivira Road, Lenexa, Kansas, 66215, and to name and appoint David Paine, MD of American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, KS, 67502 as its Medical Review Officer pursuant to the DOT regulations (collectively the “Services”). The ' + this.objCompanyInfo.CompanyName + ' agrees that PTC shall be the exclusive provider of the Services during the Term of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">MEMBERSHIP IN CONSORTIUM</h2><p>Subject to the terms and conditions of this Agreement, PTC will enlist ' + this.objCompanyInfo.CompanyName + ' in, and ' + this.objCompanyInfo.CompanyName + ' agrees to be listed as, a member of a Consortium (or group) of DOT-regulated employers and/or NON-DOT employers who have or will individually contract with PTC for similar services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">TERM</h2><p>The Term of this Agreement will start on the 1st day of the Month in which this Agreement is electronically signed by the ' + this.objCompanyInfo.CompanyName + ' and will continue until terminated in accordance with the terms and conditions of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SUBSCRIPTION FEES</h2><p>In exchange for the Services and Membership in the PTC Consortium, the ' + this.objCompanyInfo.CompanyName + ' shall pay an Annual Subscription Fee and Annual Employee Fee as established by PTC from time to time (the “Fees”) which shall be paid in accordance with PTC’s No Refund and Credit Policy. PTC may terminate or suspend this Agreement, the Services under this Agreement, and remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium if ' + this.objCompanyInfo.CompanyName + ' is in default of its obligations to pay the Fees or is in default under PTC’s No Refund and Credit Policy. This Agreement and Membership in the Consortium may be canceled in writing by ' + this.objCompanyInfo.CompanyName + ' at any time, however, there is NO REFUND for any unused portion of the Fees.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RECORDS RETENTION</h2><p>PTC shall retain records, including the ' + this.objCompanyInfo.CompanyName + '’s records, for the period of their immediate or current use, unless longer retention is necessary for historical reference or to comply with contractual or legal requirements. Thereafter, all records may be destroyed in accord with PTC’s then-current records retention policy.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">COOPERATION</h2><p>' + this.objCompanyInfo.CompanyName + ' will reasonably cooperate with PTC to facilitate PTC\'s responsibilities under this Agreement. Reasonable cooperation shall include, but not be limited to, making reasonable efforts to insure that those employees subject to DOT regulations and/or NON-DOT requirements adhere to the ' + this.objCompanyInfo.CompanyName + '\'s Alcohol and Drug Program and PTC procedures; submit to drug and alcohol testing, conduct DOT background/history checks, education or training as appropriate and travel to PTC specimen collection sites when required by PTC and/or ' + this.objCompanyInfo.CompanyName + '.</p><p>The ' + this.objCompanyInfo.CompanyName + ' shall designate PTC as its agent and hereby authorize PTC to receive all test results from the MRO. PTC shall promptly, upon receipt from the MRO, report all test results to ' + this.objCompanyInfo.CompanyName + '. ' + this.objCompanyInfo.CompanyName + ' shall designate a ' + this.objCompanyInfo.CompanyName + ' management official as the Designated Employer Representative (DER) to receive such confidential test results from PTC. PTC shall maintain all test results and records in strict confidence consistent with applicable DOT regulations and/or NON-DOT requirements.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">DEFAULT</h2><p>In the event ' + this.objCompanyInfo.CompanyName + ' fails to make payments of amounts due under this contract within 30 days from the date of invoice, PTC is authorized to suspend performance of its obligations to ' + this.objCompanyInfo.CompanyName + ' until full payment of the amount upon which ' + this.objCompanyInfo.CompanyName + ' is in default. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium and to report on any listing or report of compliance prepared or caused to be prepared by PTC that ' + this.objCompanyInfo.CompanyName + ' is not in compliance with applicable regulations (or, in the case where PTC is listing only ' + this.objCompanyInfo.CompanyName + '’s in compliance, to omit such defaulting' + this.objCompanyInfo.CompanyName + '). Such action by PTC shall not relieve ' + this.objCompanyInfo.CompanyName + ' of its obligation to pay any annual, administration, or other fees provided herein.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">REIMBURSEMENT</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to be solely responsible for obtaining reimbursement for testing costs from ' + this.objCompanyInfo.CompanyName + ' employees where desired by ' + this.objCompanyInfo.CompanyName + ' and where permissible under applicable laws and employment contracts.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">ADDITIONAL COMPENSATION</h2><p>To the extent the issuance of new, amended or supplemental regulations by the Department of Transportation necessitates additional testing or other services not contemplated by the terms of this Agreement, the compensation to be paid to PTC as a result of the additional testing or other services shall be agreed upon by the parties to this Agreement, but shall in no event be less than the actual cost incurred by PTC in providing the additional testing or other services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RESPONSIBILITY REGARDING TEST RESULTS, DETERMINATIONS, REFERRALS, AND REPORTING</h2><p>' + this.objCompanyInfo.CompanyName + ' shall be solely responsible for taking any action required by applicable DOT regulations or NON-DOT requirements based on an employee’s positive or refused drug or alcohol test. ' + this.objCompanyInfo.CompanyName + ' shall also be solely responsible for any other post-testing action concerning the employment status of its employee, whether required by applicable regulations, ' + this.objCompanyInfo.CompanyName + ' requirements, or ' + this.objCompanyInfo.CompanyName + '’s discretion. In addition, ' + this.objCompanyInfo.CompanyName + ' is responsible for making any testing determinations required by applicable DOT regulations or NON-DOT requirements for post-accident, reasonable-cause, or refusal-to-test situations. ' + this.objCompanyInfo.CompanyName + ' shall make any required referral to a qualified Substance Abuse Professional following a positive or refused drug or alcohol test. If applicable, ' + this.objCompanyInfo.CompanyName + ' is responsible for any required reporting to the Federal Motor Carrier Safety Administration Clearinghouse, except those items required to be reported by the Medical Review Officer.</p></li>'

          + '<li><h2 style="margin-bottom:5px;">INDEMNITY</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to hold PTC harmless and to indemnify and defend PTC from all claims, causes of action, or suits by employees or third parties except those that are a direct and proximate result of PTC’s willful wrongdoing, gross negligence, or fraud in the performance of functions administered by it under this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">JURISDICTION</h2><p>This Agreement shall be governed by and construed under the laws of the State of Kansas without regard to conflicts of laws principles. Any action or proceeding seeking to enforce any provision of, or based on any right arising out of, this Agreement shall be brought against either of the parties only in the courts of the State of Kansas, County of Reno, or, if it has or can acquire jurisdiction, in the United States District Court for the District of Kansas, and each of the parties consents to the exclusive jurisdiction of such courts (and of the appropriate appellate courts) in any such action or proceeding and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on either party anywhere in the world.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SEVERABILITY</h2><p>If any provision of this Agreement is held invalid or unenforceable by any court of competent jurisdiction, the other provisions of this Agreement will remain in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">BINDING EFFECT</h2><p>This Agreement shall be binding upon and inure to the benefit of the successors and assigns of the parties hereto.</p></li>'
          
          + '</ol>';



      Swal.fire({
        title: 'Service Agreement',
        html: serviceAgreementText,
      });
    }


    this.setAckDate();
  }
  SpanPopupNoRefund() {
    this.AckAndAgreement.NoRefundCreditPolicy =
      !this.AckAndAgreement.NoRefundCreditPolicy;
    if (this.AckAndAgreement.NoRefundCreditPolicy == true) {
      Swal.fire({
        title: 'No Refund & Credit Policy',
        html: '<p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>',
        //showCancelButton: true,
        //cancelButtonText: `<div><button onClick="print()" class="next action-button popup_print_btn">Print</button></div>`,
      });
    }

    /* Swal.fire('No Refund & Credit Policy','Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually. In the event the company fails to make payments of amounts due under this agreement within 60 days from the date of invoice, PTC is authorized under this agreement to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration or other fees provided under this agreement.');*/
    this.setAckDate();
  }

  SpanPopupElectronicTransmission() {
    this.AckAndAgreement.ElectronicTransmissionAck =
      !this.AckAndAgreement.ElectronicTransmissionAck;
    if (this.AckAndAgreement.ElectronicTransmissionAck) {
      Swal.fire({
        title: 'Electronic Transmission Acknowledgment',
        html: '<p>This is to confirm your company’s permission to use web or e-mail as a means of receiving test results, as opposed to calling the test results out by phone. As the contracted agent, Pipeline Testing Consortium, Inc. maintains all original records on behalf of your company. The guidelines will be as follows: </p> <p>• Individual expectations of privacy and confidentiality must be carefully maintained. Any transmission is confidential and is intended only for the use of the individual or entity identified. If the reader of the communication is not the intended recipient, they are hereby notified that dissemination or distribution of the data contained therein is prohibited under federal and state laws. </p> <p> Please acknowledge that you have read the above requirements/ restrictions for giving / receiving tests results via web or e-mail. </p>',
        //showCancelButton: true,
        //cancelButtonColor: '#fff',
        //cancelButtonText: `<div><button onClick="print()" class="next action-button popup_print_btn">Print</button></div>`,
      });
    }
    this.setAckDate();
  }


  SpanPopupAllAckAndAgreement() {

    let outlineServicesText = '<h2 style="margin-bottom:5px;"><b>Outline of Services and Costs</b></h2>';


    outlineServicesText += '<p>The following services will be performed by our company:</p>'

    outlineServicesText += '<ul><li><h2 style="margin-bottom:5px;">Policy & Procedure Manual</h2><p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy & procedure manual). Applicant and employee acknowledgment forms are included.</p></li><li><h2 style="margin-bottom:5px;">Certified Laboratory Services</h2><p>Drug testing laboratory services for the program is a Substance Abuse and Mental Health Services Administration (SAMHSA), certified laboratory. The lab for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p></li><li><h2 style="margin-bottom:5px;">Medical Review Officer (MRO) Services</h2><p>The MRO oversees the drug testing results to ensure validity of the results and to make sure that the employee\'s rights are preserved. The MRO for our program is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, Kansas 67502.</p></li><li><h2 style="margin-bottom:5px;">Collection Kit</h2><p>Testing supplies and kits are provided at no charge with clients only paying for shipping and handling.</p></li><li><h2 style="margin-bottom:5px;">Collection Sites</h2><p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctors office). Approved collection sites are identified on our website (www.pipelinetesting.com). All collection sites utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations. </p></li><li><h2 style="margin-bottom:5px;">Breath Alcohol Technician (BAT) Services</h2><p>Trained BATs and collection facilities are provided by either mobile service or walk-in facilities.</p></li><li><h2 style="margin-bottom:5px;">Testing Schedule</h2><p>All employees working in a "covered" position are subject to unannounced testing based on random selection. All random selections are computer generated. The current annualized random drug testing rate is published on https://www.transportation.gov/odapc/random-testing-rates for employees subject to the PHMSA regulations.</p></li><li><h2 style="margin-bottom:5px;">Employee Assistance Program (EAP) & Supervisor Training</h2><p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p></li><li><h2 style="margin-bottom:5px;">Substance Abuse Professional (SAP) Services</h2><p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p></li><div class="print-space-1"></div><li><h2 style="margin-bottom:5px;">Drug/Alcohol History Checks</h2><p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant\'s previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p></li><li><h2 style="margin-bottom:5px;">Recordkeeping</h2><p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p></li><li><h2 style="margin-bottom:5px;">PTC Online Access</h2><p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p></li><li><h2 style="margin-bottom:5px;">ePay<sup>TM</sup></h2><p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p></li><li><h2 style="margin-bottom:5px;">Statistical Data Reporting</h2><p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p></li><li><h2 style="margin-bottom:5px;">Compliance Audits and/or Updates</h2><p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p><p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p></li></ul>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Policy & Procedure Manual</b></h2>';
    // outlineServicesText +=
    // '<p>Implementation of your individualized Alcohol and Drug Testing Plans (written policy & procedure manual). Applicant and employee acknowledgment forms are included.</p>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Certified Laboratory Services</b></h2>';
    // outlineServicesText +=
    // '<p>Drug testing laboratory services for the program is a Substance Abuse and Mental Health Services Administration (SAMHSA), certified laboratory. The lab for our program is: Clinical Reference Laboratory, 8433 Quivira, Lenexa, Kansas 66215.</p>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Medical Review Officer (MRO) Services</b></h2>';
    // outlineServicesText +=
    // '<p>The MRO oversees the drug testing results to ensure validity of the results and to make sure that the     employee\'s rights are preserved. The MRO for our program is: Dr. David W. Paine, American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, Kansas 67502</p>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Collection Kit</b></h2>';
    // outlineServicesText +=
    // '<p>PTC furnishes all relevant drug and alcohol collection supplies, including chain of custody forms, to the employer at no extra charge via ground delivery. Overnight shipping and handling of the specimen to the lab is also included.</p>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Collection Sites</b></h2>';
    // outlineServicesText +=
    // '<p>Included with drug testing is a specimen collection site (your local clinic, hospital or doctor’s office). Approved collection sites are identified on our website (www.pipelinetesting.com) as Preferred (P), Standard (blue pushpin), and even sites with higher than average testing fees (yellow pushpin) in which a surcharge may apply. All collection sites utilized must be listed in the PTC Collection Site Network. Additional charges may apply for collection sites used outside the approved network, for after-hour services, on-site(mobile) testing, and other situations.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Breath Alcohol Technician (BAT) Services</b></h2>';
    // outlineServicesText +=
    // '<p>Trained BATs and collection facilities are provided by either mobile service or walk-in facilities.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Testing Schedule</b></h2>';
    // outlineServicesText +=
    // '<p>All employees working in a "covered" position are subject to unannounced testing based on random selection. All random selections are computer generated. The current annualized random drug testing rate is published on https://www.transportation.gov/odapc/random-testing-rates for employees subject to the PHMSA regulations.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Employee Assistance Program (EAP) & Supervisor Training</b></h2>';
    // outlineServicesText +=
    // '<p>The employee assistance program (EAP) includes informational material for each employee, hot- line number posters, and an online training module covering drug and alcohol recognition, testing and understanding for supervisors and managers.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Substance Abuse Professional (SAP) Services</b></h2>';
    // outlineServicesText +=
    // '<p>The Substance Abuse Professional (SAP) provides an evaluation of an employee who tests positive for alcohol and/or drugs. PTC will coordinate the follow-up program established by the Substance Abuse Professional.</p>';
    // outlineServicesText +='<div class="print-space-1"></div>';
    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Drug/Alcohol History Checks</b></h2>';
    // outlineServicesText +=
    // '<p>Employers hiring any applicant for a DOT position must obtain information about any DOT alcohol and/or drug misuse from the applicant&rsquo;s previous employers for the previous two years (three years if applicant is a CDL driver.) PTC Assist, LLC provides this verification service for PTC. This service is done in accordance with 49 CFR Part 40.25 requirements.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Recordkeeping</b></h2>';
    // outlineServicesText +='<p>Maintenance and recordkeeping functions are provided. The records are kept electronically via a secure digital file source and can be retrieved quickly for submission. PTC also maintains BAT and QAP records.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>PTC Online Access</b></h2>';
    // outlineServicesText +=
    // '<p>Allows employers to access their pool information 24/7. Employers can view employee test result history, current random pool lists, history check information and much more.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>ePay<sup>TM</sup></b></h2>';
    // outlineServicesText +=
    // '<p>View and pay invoices online. Members are given unique login criteria to view their specific account details quickly and securely. View payment history and pending statements.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Statistical Data Reporting</b></h2>';
    // outlineServicesText +=
    // '<p>Quarterly statistical data reports are provided to the pipeline contractor and to the pipeline operators that each contractor works for.</p>';

    // outlineServicesText +='<h2 style="margin-bottom:5px;"><b>Compliance Audits and/or Updates</b></h2>';
    // outlineServicesText +=
    // '<p>All operator audit requests are handled by Pipeline Testing Consortium, Inc. When a pipeline contractor is solicited by the operator, all requested information is to be sent to PTC for response directly to the operator.</p>';


    // outlineServicesText +=
    // '<p>All new and existing regulations are monitored to maintain complete compliance of the DOT regulations.</p>';
    //end old



    outlineServicesText += '<h2 style="margin-bottom:8px"><b>FEES FOR ALL SERVICES AS OUTLINED</b></h2>';
    outlineServicesText += '<table cellpadding="4" style=" width: 90%; margin: 0 auto;"><tr><td style="width:100px"; class="text-right pr-3 align-top">$250.00</td><td><b>Administration Fee</b><br /><span style="font-size:13px; line-height:13px">(one time set-up charge)</span></td></tr><tr><td class="text-right pr-3 align-top">$550.00</td><td><b>Annual Subscription Fee / Renewal </b></br><span style="font-size:13px; line-height:13px">(This fee covers statistical data reporting, assistance with compliance audits, record keeping and etc.)</span></td></tr><tr><td class="text-right pr-3 align-top">$30.00</td><td><b>Annual Employee Fee</b></br><span style="font-size:13px; line-height:13px"><i>(This fee covers the supervisor training module, EAP informational materials, posters, testing schedules, and related program resources. The annual employee fee is calculated based on the average number of employees during the previous 12 months at a rate of $30.00 per employee, with a maximum annual employee fee of $6,000.00.)</i></span></td></tr><tr><td class="text-right pr-3 align-top">$85.00</td><td><b>Each Drug Test</b></br><span style="font-size:13px; line-height:13px">(This fee covers the specimen collection, laboratory and MRO fees.)*</span></td></tr><tr><td class="text-right pr-3 align-top">$85.00</td><td><b>Each Alcohol Test</b></br><span style="font-size:13px; line-height:13px">(This fee covers the initial and confirmation alcohol testing fee.)*</span></td></tr><tr><td class="text-right pr-3 align-top">$18.00</td><td><b>Each Drug/Alcohol History Check</b></br><span style="font-size:13px; line-height:13px">Required by 49 CFR Part 40.25.</br><i>$25 history check fee applies if legacy paper authorization method utilized. (Checks performed through PTC Assist, LLC.)</i></span></td></tr></table>';

    outlineServicesText += '<div class="print-space-1"></div>';

    outlineServicesText += '<div style="border:2px solid #ccc" class="px-4 py-3 my-4"><h2 class="text-center" style="margin-bottom:5px">"Example Estimate Based on Five (5) Employees"</h2><p class="text-center">(Adjust the estimate for the number of "covered" employees for your company.)</p><table style="width: 86%; margin: 0 auto;" cellpadding="0"><tr><td><strong>Administration Fee (1x fee)</strong></td><td class="text-right">$250.00</td><td></td></tr><tr><td><strong>Annual Subscription Fee / Renewal </strong></td><td class="text-right">$550.00</td></tr><td></td><tr><td><strong>Annual Employee Fee</strong></td><td class="text-right"></td><td></td></tr><tr><td><strong>(5 Employees X $30.00)</strong></td><td class="text-right"><span style="text-decoration:underline">$150.00</span></td><td><span style="font-size:13px">&nbsp;(Maximum Employee Fee $6,000)</span></td></tr><tr><td><strong>Total</strong></td><td class="text-right">$950.00</td><td></td></tr></table><p style="font-size:13px;font-weight:bold; padding-top:20px">**NOTE** All drug and/or alcohol tests will be invoiced after completion at $85.00 per test  if and when any testing is completed. The DOT required history checks will also be invoiced after completion.</p><p style="font-size:13px;">If previous drug testing had been conducted with a SAMHSA certified lab and all tests were DOT 5-panel tests and your company has been conducting random testing at the proper annualized rate. The drug testing records may be transferred with employee release. Contact us with further questions regarding the potential for you to transfer your past DOT records.</p></div>';

    outlineServicesText += '<p>*PTC consolidates all fees associated with alcohol and drug testing. PTC will pay up to a pre-determined, maximum collection fee per test. Other charges may apply for after-hour, on-site, out-of-network, or non-standard rate testing.</p><br/>';


    let refundPolicy = '<h2 style="margin-bottom:8px"><b>No Refund & Credit Policy</b></h2>';
    refundPolicy +=
      '<p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p></br>';

    let electronicTranmission =
      '<h2 style="margin-bottom:8px; margin-top"24px"><b>Electronic Transmission Acknowledgment</b></h2>';
    electronicTranmission +=
      '<p>This is to confirm your company’s permission to use web or e-mail as a means of receiving test results, as opposed to calling the test results out by phone. As the contracted agent, Pipeline Testing Consortium, Inc. maintains all original records on behalf of your company. The guidelines will be as follows: </p> <p>• Individual expectations of privacy and confidentiality must be carefully maintained. Any transmission is confidential and is intended only for the use of the individual or entity identified. If the reader of the communication is not the intended recipient, they are hereby notified that dissemination or distribution of the data contained therein is prohibited under federal and state laws. </p> <p> Please acknowledge that you have read the above requirements/ restrictions for giving / receiving tests results via web or e-mail. </p></br>';

    let consumerReport =
      '<div class="print-space-1"></div><h2 style="margin-bottom:8px; margin-top"24px"><b>Consumer Report Service Agreement for Employers Subject to Substance Abuse Testing Verification Requirements</b></h2>';
    consumerReport +=
      '<p>(hereinafter "' + this.objCompanyInfo.CompanyName + '") and PTC Assist, LLC have entered into a Consumer Report Service Agreement (hereinafter “Agreement”) through which ' + this.objCompanyInfo.CompanyName + ' will utilize PTC Assist to obtain consumer reports for employment purposes. ' + this.objCompanyInfo.CompanyName + ' and PTC Assist mutually desire to add the authorization provisions set forth below to the scope of that Agreement. ' + this.objCompanyInfo.CompanyName + ' is subject to drug and alcohol testing requirements under federal, state, or local laws, including those enforced by the U.S. Department of Transportation. ' + this.objCompanyInfo.CompanyName + ' understands that compliance with these requirements includes verifying the drug and alcohol testing record of certain of its employees or prospective employees. In addition, ' + this.objCompanyInfo.CompanyName + ' understands that these requirements impose an obligation on ' + this.objCompanyInfo.CompanyName + ' to disclose information regarding the testing history of its current or former employees in response to verification requests from other employers also subject to these requirements. ' + this.objCompanyInfo.CompanyName + ' has determined to utilize a consortium / third party administrator (hereinafter “TPA”), to act as ' + this.objCompanyInfo.CompanyName + '’s agent in complying with its alcohol and drug testing requirements. ' + this.objCompanyInfo.CompanyName + '’s TPA is as follows: </p><p>Third Party Administrator: Pipeline Testing Consortium, Inc.';
    consumerReport +=
      '<br/>Contact Address: 9 Compound Drive, Hutchinson, KS 67502<br/>Contact Phone: 620 - 669 - 8800</p>';
    consumerReport +=
      '<p>For the mutual benefit of ' + this.objCompanyInfo.CompanyName + ' and PTC Assist, ' + this.objCompanyInfo.CompanyName + ' provides the following additional authorizations:</p>';
    consumerReport +=
      '<p>Whether in response to a request from ' + this.objCompanyInfo.CompanyName + ' or from another employer also subject to the drug and alcohol testing requirements, ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to communicate directly with TPA to obtain information regarding the alcohol or drug testing record of any of ' + this.objCompanyInfo.CompanyName + '’s current or former employees.</p>';
    consumerReport +=
      '<p>' + this.objCompanyInfo.CompanyName + ' authorizes TPA to release to PTC Assist any information that ' + this.objCompanyInfo.CompanyName + ' would be required to release in response to a drug and alcohol testing record verification request regarding any current or former employee of ' + this.objCompanyInfo.CompanyName + '’s. ' + this.objCompanyInfo.CompanyName + ' further authorizes PTC Assist to share a copy of this Addendum with TPA, on request, to confirm ' + this.objCompanyInfo.CompanyName + '’s authorization.</p>';

    consumerReport +=
      '<p>So that TPA may maintain accurate records for ' + this.objCompanyInfo.CompanyName + ', ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to share the results of its testing verifications directly with TPA.</p>';
    consumerReport +=
      '<p>The authorizations set forth above shall remain in effect until the termination of the Agreement.</p><br/>';
    
    // ===================== Service Agreement Section Added =====================
    consumerReport += '<p style="margin:5px 20px;">The U.S. Department of Transportation (DOT) has published rules requiring DOT covered employers to test certain employees under certain circumstances for the presence of certain prohibited drugs and alcohol and to provide such employees with an employee assistance program. The ' + this.objCompanyInfo.CompanyName + ' is subject to performing covered employee functions under and subject to the aforesaid rules and is required and desires to comply with said DOT requirements and/or the ' + this.objCompanyInfo.CompanyName + ' is an employer conducting NON-DOT drug and alcohol testing and wishes to adopt an Alcohol and Drug Program pursuant to the DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements.</p>';
          
    consumerReport += '<p style="margin:5px 20px;">' + this.objCompanyInfo.CompanyName + ' desires to engage Pipeline Testing Consortium, Inc. (PTC), a Kansas Corporation, and PTC desires to be engaged to assist ' + this.objCompanyInfo.CompanyName + ' in administering their Alcohol and Drug programs and desires to contract with the ' + this.objCompanyInfo.CompanyName + ' to assist, and act as ' + this.objCompanyInfo.CompanyName + '’s agent, in administering its program by administering the Testing (pre-employment, post-accident, at random, reasonable cause, return-to-duty or follow-up) Employee Assistance Program, and Recordkeeping functions of the DOT regulations and/or NON-DOT requirements. PTC wishes to enlist ' + this.objCompanyInfo.CompanyName + ' in a Consortium of DOT-regulated employers and/or NON-DOT employers for greater efficiency in compliance with said regulations and/or ' + this.objCompanyInfo.CompanyName + ' requirements.</p>';
          
    consumerReport += '<p style="margin:5px 20px;">THEREFORE, ' + this.objCompanyInfo.CompanyName + ' hereby contracts with PTC to administer the Alcohol and Drug Testing, Employee Assistance Program, and Recordkeeping functions required of ' + this.objCompanyInfo.CompanyName + ' by the DOT regulations and/or NON-DOT requirements, upon the following terms and conditions:</p>';
          
    consumerReport += '<ol style="margin:10px;">'
          
          + '<li><h2 style="margin-bottom:5px;">SERVICES</h2><p>PTC will provide ' + this.objCompanyInfo.CompanyName + ' with an Alcohol and Drug Program that is intended to be adopted and used by ' + this.objCompanyInfo.CompanyName + ' in conjunction with its business as an operator or contractor under the applicable DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements. ' + this.objCompanyInfo.CompanyName + ' hereby agrees to execute through PTC a Drug Testing and Service Agreement with Clinical Reference Laboratory, 8433 Quivira Road, Lenexa, Kansas, 66215, and to name and appoint David Paine, MD of American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, KS, 67502 as its Medical Review Officer pursuant to the DOT regulations (collectively the “Services”). The ' + this.objCompanyInfo.CompanyName + ' agrees that PTC shall be the exclusive provider of the Services during the Term of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">MEMBERSHIP IN CONSORTIUM</h2><p>Subject to the terms and conditions of this Agreement, PTC will enlist ' + this.objCompanyInfo.CompanyName + ' in, and ' + this.objCompanyInfo.CompanyName + ' agrees to be listed as, a member of a Consortium (or group) of DOT-regulated employers and/or NON-DOT employers who have or will individually contract with PTC for similar services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">TERM</h2><p>The Term of this Agreement will start on the 1st day of the Month in which this Agreement is electronically signed by the ' + this.objCompanyInfo.CompanyName + ' and will continue until terminated in accordance with the terms and conditions of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SUBSCRIPTION FEES</h2><p>In exchange for the Services and Membership in the PTC Consortium, the ' + this.objCompanyInfo.CompanyName + ' shall pay an Annual Subscription Fee and Annual Employee Fee as established by PTC from time to time (the “Fees”) which shall be paid in accordance with PTC’s No Refund and Credit Policy. PTC may terminate or suspend this Agreement, the Services under this Agreement, and remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium if ' + this.objCompanyInfo.CompanyName + ' is in default of its obligations to pay the Fees or is in default under PTC’s No Refund and Credit Policy. This Agreement and Membership in the Consortium may be canceled in writing by ' + this.objCompanyInfo.CompanyName + ' at any time, however, there is NO REFUND for any unused portion of the Fees.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RECORDS RETENTION</h2><p>PTC shall retain records, including the ' + this.objCompanyInfo.CompanyName + '’s records, for the period of their immediate or current use, unless longer retention is necessary for historical reference or to comply with contractual or legal requirements. Thereafter, all records may be destroyed in accord with PTC’s then-current records retention policy.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">COOPERATION</h2><p>' + this.objCompanyInfo.CompanyName + ' will reasonably cooperate with PTC to facilitate PTC\'s responsibilities under this Agreement. Reasonable cooperation shall include, but not be limited to, making reasonable efforts to insure that those employees subject to DOT regulations and/or NON-DOT requirements adhere to the ' + this.objCompanyInfo.CompanyName + '\'s Alcohol and Drug Program and PTC procedures; submit to drug and alcohol testing, conduct DOT background/history checks, education or training as appropriate and travel to PTC specimen collection sites when required by PTC and/or ' + this.objCompanyInfo.CompanyName + '.</p><p>The ' + this.objCompanyInfo.CompanyName + ' shall designate PTC as its agent and hereby authorize PTC to receive all test results from the MRO. PTC shall promptly, upon receipt from the MRO, report all test results to ' + this.objCompanyInfo.CompanyName + '. ' + this.objCompanyInfo.CompanyName + ' shall designate a ' + this.objCompanyInfo.CompanyName + ' management official as the Designated Employer Representative (DER) to receive such confidential test results from PTC. PTC shall maintain all test results and records in strict confidence consistent with applicable DOT regulations and/or NON-DOT requirements.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">DEFAULT</h2><p>In the event ' + this.objCompanyInfo.CompanyName + ' fails to make payments of amounts due under this contract within 30 days from the date of invoice, PTC is authorized to suspend performance of its obligations to ' + this.objCompanyInfo.CompanyName + ' until full payment of the amount upon which ' + this.objCompanyInfo.CompanyName + ' is in default. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium and to report on any listing or report of compliance prepared or caused to be prepared by PTC that ' + this.objCompanyInfo.CompanyName + ' is not in compliance with applicable regulations (or, in the case where PTC is listing only ' + this.objCompanyInfo.CompanyName + '’s in compliance, to omit such defaulting' + this.objCompanyInfo.CompanyName + '). Such action by PTC shall not relieve ' + this.objCompanyInfo.CompanyName + ' of its obligation to pay any annual, administration, or other fees provided herein.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">REIMBURSEMENT</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to be solely responsible for obtaining reimbursement for testing costs from ' + this.objCompanyInfo.CompanyName + ' employees where desired by ' + this.objCompanyInfo.CompanyName + ' and where permissible under applicable laws and employment contracts.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">ADDITIONAL COMPENSATION</h2><p>To the extent the issuance of new, amended or supplemental regulations by the Department of Transportation necessitates additional testing or other services not contemplated by the terms of this Agreement, the compensation to be paid to PTC as a result of the additional testing or other services shall be agreed upon by the parties to this Agreement, but shall in no event be less than the actual cost incurred by PTC in providing the additional testing or other services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RESPONSIBILITY REGARDING TEST RESULTS, DETERMINATIONS, REFERRALS, AND REPORTING</h2><p>' + this.objCompanyInfo.CompanyName + ' shall be solely responsible for taking any action required by applicable DOT regulations or NON-DOT requirements based on an employee’s positive or refused drug or alcohol test. ' + this.objCompanyInfo.CompanyName + ' shall also be solely responsible for any other post-testing action concerning the employment status of its employee, whether required by applicable regulations, ' + this.objCompanyInfo.CompanyName + ' requirements, or ' + this.objCompanyInfo.CompanyName + '’s discretion. In addition, ' + this.objCompanyInfo.CompanyName + ' is responsible for making any testing determinations required by applicable DOT regulations or NON-DOT requirements for post-accident, reasonable-cause, or refusal-to-test situations. ' + this.objCompanyInfo.CompanyName + ' shall make any required referral to a qualified Substance Abuse Professional following a positive or refused drug or alcohol test. If applicable, ' + this.objCompanyInfo.CompanyName + ' is responsible for any required reporting to the Federal Motor Carrier Safety Administration Clearinghouse, except those items required to be reported by the Medical Review Officer.</p></li>'

          + '<li><h2 style="margin-bottom:5px;">INDEMNITY</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to hold PTC harmless and to indemnify and defend PTC from all claims, causes of action, or suits by employees or third parties except those that are a direct and proximate result of PTC’s willful wrongdoing, gross negligence, or fraud in the performance of functions administered by it under this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">JURISDICTION</h2><p>This Agreement shall be governed by and construed under the laws of the State of Kansas without regard to conflicts of laws principles. Any action or proceeding seeking to enforce any provision of, or based on any right arising out of, this Agreement shall be brought against either of the parties only in the courts of the State of Kansas, County of Reno, or, if it has or can acquire jurisdiction, in the United States District Court for the District of Kansas, and each of the parties consents to the exclusive jurisdiction of such courts (and of the appropriate appellate courts) in any such action or proceeding and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on either party anywhere in the world.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SEVERABILITY</h2><p>If any provision of this Agreement is held invalid or unenforceable by any court of competent jurisdiction, the other provisions of this Agreement will remain in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">BINDING EFFECT</h2><p>This Agreement shall be binding upon and inure to the benefit of the successors and assigns of the parties hereto.</p></li>'
          
          + '</ol>';

    let signedDate = new Date(this.AckAndAgreement.AckDate); //use your date here
    let currentDate = this.datePipe.transform(signedDate, 'MM/dd/yyyy');
    let signingdetails =
      '<div class="companyname-width-popup"><div  class="signature-wrap-height-popup">' +
      this.AckAndAgreement.CompanyName +
      '</div>';
    signingdetails +=
      '<div style="border-top:1px solid #000;padding-top:5px; line-height: 17px;"><b>Company Name</b></div></div> <div class="authorized-width-popup"> <div class="signature-wrap-height-popup">' +
      this.AckAndAgreement.CompanyRepresentativeName +
      '</div><div style="border-top:1px solid #000;padding-top:5px"><b>Name of Authorized Company Representative</b></div></div>';
    signingdetails +=
      '<div class="date-width-popup"><div class="signature-wrap-height-popup">' +
      currentDate +
      '</div><div style="border-top:1px solid #000; padding-top:5px"><b>Date</b></div></div>';

    let agreestmnt =
      "<p style='font-size:13px;font-weight:bold;'>I Agree By checking the “I Accept” box, you are signing these acknowledgments and policies electronically. You agree your electronic signature is the legal equivalent of your manual/handwritten signature on these documents. By selecting “I Accept” using any device, means, or action, you consent to the legally binding terms and conditions of these documents. You further agree that your electronic signature on this document is as valid as if you signed these documents in writing.</p>";

    // Swal.fire({
    //   title: 'Acknowledgment And Agreement Policies',
    //   html:
    //     outlineServicesText +
    //     refundPolicy +
    //     electronicTranmission +
    //     consumerReport +
    //     agreestmnt +
    //     signingdetails,
    //   showCancelButton: true,
    //   cancelButtonColor: '#fff',
    //   cancelButtonText: `<div><button onClick="print()" class="next action-button popup_print_btn">Print</button></div>`,
    // });
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<kendo-pdf-export #pdf1 paperSize="A4" margin="2cm"> <div> ajsdjashdaj</div> </kendo-pdf-export><button onClick="pdf1.saveAs(\'ServiceAgreement.pdf\')" class="next action-button popup_print_btn">Print</button>'
    })
    // .then((result) => {
    //   if (result.isConfirmed) {

    //   }
    //   else if (
    //     /* Read more about handling dismissals below */
    //     result.dismiss === Swal.DismissReason.cancel
    //   ) {
    //     let htmlComp =  document.getElementById('pdfAckPrint');
    //     htmlComp.saveAs('ServiceAgreement.pdf');

    //   }
    // })
  }
  AgreeByChecking() {
    if (!this.AckAndAgreement.ElectronicSignatureAck) {
      let signedDate = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
      this.AckAndAgreement.AckDate =
        signedDate == null ? '' : signedDate.toString();
      this.AckAndAgreement.CompanyName = this.objCompanyInfo.CompanyName;
      // this.AckAndAgreement.AckDate = new Date()
    }
    //let signedDate = new Date(); //use your date here
    else {
      this.AckAndAgreement.AckDate = '';
      this.AckAndAgreement.CompanyName = '';
      this.AckAndAgreement.CompanyRepresentativeName = '';
    }
  }
  openModal(content: any) {
    window.scrollTo(0, 0);
    this.modalService.open(content, { size: 'lg' });
    
  }
  setAckDate() {
    if (
      this.AckAndAgreement.ElectronicSignatureAck &&
      this.AckAndAgreement.ConsumerReportAck &&
      this.AckAndAgreement.ElectronicTransmissionAck &&
      this.AckAndAgreement.NoRefundCreditPolicy &&
      this.AckAndAgreement.OutlineServicesCosts &&
      this.AckAndAgreement.ServiceAgreement
    ) {
      this.AckAndAgreement.AckDate = new Date().toLocaleDateString();
    } else {
      this.AckAndAgreement.AckDate = '';
    }
  }

  SpanPopupConsumerReport() {
    this.AckAndAgreement.ConsumerReportAck =
      !this.AckAndAgreement.ConsumerReportAck;
    if (this.AckAndAgreement.ConsumerReportAck) {
      Swal.fire({
        title:
          'Consumer Report Service Agreement for Employers Subject to Substance Abuse Testing Verification Requirements',
        html: '<p>(hereinafter “' + this.objCompanyInfo.CompanyName + '”) and PTC Assist, LLC have entered into a Consumer Report Service Agreement (hereinafter “Agreement”) through which ' + this.objCompanyInfo.CompanyName + ' will utilize PTC Assist to obtain consumer reports for employment purposes. ' + this.objCompanyInfo.CompanyName + ' and PTC Assist mutually desire to add the authorization provisions set forth below to the scope of that Agreement. ' + this.objCompanyInfo.CompanyName + ' is subject to drug and alcohol testing requirements under federal, state, or local laws, including those enforced by the U.S. Department of Transportation. ' + this.objCompanyInfo.CompanyName + ' understands that compliance with these requirements includes verifying the drug and alcohol testing record of certain of its employees or prospective employees. In addition, ' + this.objCompanyInfo.CompanyName + ' understands that these requirements impose an obligation on ' + this.objCompanyInfo.CompanyName + ' to disclose information regarding the testing history of its current or former employees in response to verification requests from other employers also subject to these requirements. ' + this.objCompanyInfo.CompanyName + ' has determined to utilize a consortium / third party administrator (hereinafter “TPA”), to act as ' + this.objCompanyInfo.CompanyName + '’s agent in complying with its alcohol and drug testing requirements. ' + this.objCompanyInfo.CompanyName + '’s TPA is as follows:<br /><br />Third Party Administrator: Pipeline Testing Consortium, Inc.<br />Contact Address: 9 Compound Drive, Hutchinson, KS 67502<br />Contact Phone: 620 - 669 - 8800</p><p>For the mutual benefit of ' + this.objCompanyInfo.CompanyName + ' and PTC Assist, ' + this.objCompanyInfo.CompanyName + ' provides the following additional authorizations:<br /><br />Whether in response to a request from ' + this.objCompanyInfo.CompanyName + ' or from another employer also subject to the drug and alcohol testing requirements, ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to communicate directly with TPA to obtain information regarding the alcohol or drug testing record of any of ' + this.objCompanyInfo.CompanyName + '’s current or former employees.<br /><br />' + this.objCompanyInfo.CompanyName + ' authorizes TPA to release to PTC Assist any information that ' + this.objCompanyInfo.CompanyName + ' would be required to release in response to a drug and alcohol testing record verification request regarding any current or former employee of ' + this.objCompanyInfo.CompanyName + '’s. ' + this.objCompanyInfo.CompanyName + ' further authorizes PTC Assist to share a copy of this Addendum with TPA, on request, to confirm ' + this.objCompanyInfo.CompanyName + '’s authorization.</p><p>So that TPA may maintain accurate records for ' + this.objCompanyInfo.CompanyName + ', ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to share the results of its testing verifications directly with TPA.<br /><br /> The authorizations set forth above shall remain in effect until the termination of the Agreement.</p>',
        //showCancelButton: true,
        //cancelButtonColor: '#fff',
        //cancelButtonText: `<div><button onClick="print()" class="next action-button popup_print_btn">Print</button></div>`,
      });
    }
    this.setAckDate();
  }

  SpanPopupAgreeAccept() {
    Swal.fire(
      'Agreement',
      'I Agree		By checking the “I Accept” box, you are signing these acknowledgments and 			policies electronically. You agree your electronic signature is the legal equivalent 		of your manual/handwritten signature on these documents. By selecting “I 			Accept” using any device, means, or action, you consent to the legally binding 			terms and conditions of these documents. You further agree that your electronic 		signature on this document is as valid as if you signed these documents in writing.'
    );
  }
  previous() {
    this.step--;
    if (this.step == 4) {
      if (this.showTransactionId === '') {
        this.SetSummaryData();
      }
      else {
        this.step++;
        return;
      }
    }
    if (this.step == 3) {
      var root = this;
      root.cdr.detectChanges();
    }

    window.scrollTo(0, 0);
  }

  SetSummaryData() {
    this.lstShowSummary = [];
    this.lstShowSummaryBillingInfo = [];
    this.lstShowSummary.push({
      key: 'Company Name',
      value: this.objCompanyInfo.CompanyName,
    });
    this.lstShowSummary.push({
      key: 'Mailing Address',
      value:
        this.objCompanyInfo.MailingAddress +
        ' ' +
        this.objCompanyInfo.City +
        ' ' +
        this.objCompanyInfo.State +
        ' ' +
        this.objCompanyInfo.Zip,
    });
    this.lstShowSummary.push({
      key: 'Physical Address',
      value:
        this.objCompanyInfo.PhysicalAddress +
        ' ' +
        this.objCompanyInfo.PhysicalAddressCity +
        ' ' +
        this.objCompanyInfo.PhysicalAddressState +
        ' ' +
        this.objCompanyInfo.PhysicalAddressZip,
    });
    this.lstShowSummary.push({
      key: 'Phone No',
      value: this.objCompanyInfo.CompanyPhoneNo,
    });
    this.lstShowSummary.push({
      key: 'Tax Id No',
      value: this.objCompanyInfo.FederalTaxId,
    });
    this.lstShowSummary.push({
      key: 'ISN No',
      value: this.objCompanyInfo.ISNetworldAccountNo,
    });
    this.lstShowSummary.push({
      key: 'ITS No',
      value: this.objCompanyInfo.ITSAccountNo,
    });
    this.lstShowSummary.push({
      key: 'DER Name',
      value: this.objCompanyInfo.objDer.Name,
    });
    this.lstShowSummary.push({
      key: 'DER Email',
      value: this.objCompanyInfo.objDer.Email,
    });
    this.lstShowSummary.push({
      key: 'Alternate DER Name',
      value: this.lstDer.length > 0 ? this.lstDer[0].AlternateName : '',
    });
    this.lstShowSummary.push({
      key: 'Alternate DER Email',
      value: this.lstDer.length > 0 ? this.lstDer[0].AlternateEmail : '',
    });

    this.lstShowSummaryBillingInfo.push({
      key: 'Billing Contact Name',
      value: this.objCompanyInfo.BillingContact.BillingContactName,
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Billing Contact Email',
      value: this.objCompanyInfo.BillingContact.BillingContactEmail,
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Billing Address',
      value:
        this.objCompanyInfo.BillingContact.BillingAddress +
        ' ' +
        this.objCompanyInfo.BillingContact.BillingCity +
        ' ' +
        this.objCompanyInfo.BillingContact.BillingState +
        ' ' +
        this.objCompanyInfo.BillingContact.BillingZip,
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Billing Phone No',
      value: this.objCompanyInfo.BillingContact.BillingPhoneNo,
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Billing Billing Fax No',
      value: this.objCompanyInfo.BillingContact.BillingFaxNo,
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Other Billing Contact Name',
      value:
        this.lstBillingInfo.length > 0
          ? this.lstBillingInfo[0].OtherBillingContactName
          : '',
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Other Billing Contact Email',
      value:
        this.lstBillingInfo.length > 0
          ? this.lstBillingInfo[0].OtherBillingContactEmail
          : '',
    });
    this.lstShowSummaryBillingInfo.push({
      key: 'Other Billing Contact Phone No',
      value:
        this.lstBillingInfo.length > 0
          ? this.lstBillingInfo[0].OtherBillingContactPhone
          : '',
    });
  }

  StartOver() {
    // this.step = 1;
    // window.scrollTo(0, 0);
  }
  GetPhoneNoFormat(PhoneNo: string) {
    return this.MaskingHelper.GetPhoneNoFormat(PhoneNo);
  }

  GetFaxNoFormat(FaxNo: string) {
    return this.MaskingHelper.GetFaxNoFormat(FaxNo);
  }

  GetZipFormat(Zip: string) {
    return this.MaskingHelper.GetZipFormat(Zip);
  }
  GetFederalTaxFormat(Tax: string) {
    return this.MaskingHelper.GetFederalTaxFormat(Tax);
  }

  GetISNFormat(Tax: string) {
    return this.MaskingHelper.GetISNFormat(Tax);
  }

  printAllPolicies() {
    //let mywindow: any = window.open('', '_blank', '_blank');
    let mywindow: any = window.open('', 'PRINT', 'A4');
    if (
      mywindow.outerWidth < screen.availWidth ||
      mywindow.outerHeight < screen.availHeight
    ) {
      mywindow.moveTo(100, 100);
      mywindow.resizeTo(screen.availWidth - 300, screen.availHeight - 300);
    }

    mywindow.document.write('<html><head><title>Policies</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write('<h1>No Refund & Credit Policy</h1>');
    let refundPolicy =
      '<p>Due to the nature of our services, we have, without exception, a NO REFUND policy. For this reason, we strongly recommend that before payment, you make certain that you understand the nature and cost of the services we provide. Invoices sent by PTC under this agreement are due upon receipt. The company shall owe a finance charge on any balance not paid within 30 days of the date of the invoice at the rate of 1.5% per month or 18% annually and the account may be subject to hold. In the event the company fails to make payments of amounts due under this agreement, PTC is authorized to suspend performance of its obligations to the company until full payment of the amount which the company is in default is received. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove the company from the Consortium and to report on any listing or report of compliance with applicable regulations or, in the case where PTC is listing only the company in compliance to omit such defaulting company. Such action by PTC shall not relieve the company of its obligation to pay any annual, administration, or other fees provided under this agreement.</p>';
    mywindow.document.write(refundPolicy);
    mywindow.document.write('<h1>Electronic Transmission Acknowledgment</h1>');
    let electronicTranmission =
      '<p>This is to confirm your company’s permission to use web or e-mail as a means of receiving test results, as opposed to calling the test results out by phone. As the contracted agent, Pipeline Testing Consortium, Inc. maintains all original records on behalf of your company. The guidelines will be as follows: </p> <p>• Individual expectations of privacy and confidentiality must be carefully maintained. Any transmission is confidential and is intended only for the use of the individual or entity identified. If the reader of the communication is not the intended recipient, they are hereby notified that dissemination or distribution of the data contained therein is prohibited under federal and state laws. </p> <p> Please acknowledge that you have read the above requirements/ restrictions for giving / receiving tests results via web or e-mail. </p>';
    mywindow.document.write(electronicTranmission);
    mywindow.document.write(
      '<h1>Consumer Report Service Agreement for Employers Subject to Substance Abuse Testing Verification Requirements</h1>'
    );
    let consumerReport =
      '<p>(hereinafter “' + this.objCompanyInfo.CompanyName + '”) and PTC Assist, LLC have entered into a Consumer Report Service Agreement (hereinafter “Agreement”) through which ' + this.objCompanyInfo.CompanyName + ' will utilize PTC Assist to obtain consumer reports for employment purposes. ' + this.objCompanyInfo.CompanyName + ' and PTC Assist mutually desire to add the authorization provisions set forth below to the scope of that Agreement. ' + this.objCompanyInfo.CompanyName + ' is subject to drug and alcohol testing requirements under federal, state, or local laws, including those enforced by the U.S. Department of Transportation. ' + this.objCompanyInfo.CompanyName + ' understands that compliance with these requirements includes verifying the drug and alcohol testing record of certain of its employees or prospective employees. In addition, ' + this.objCompanyInfo.CompanyName + ' understands that these requirements impose an obligation on ' + this.objCompanyInfo.CompanyName + ' to disclose information regarding the testing history of its current or former employees in response to verification requests from other employers also subject to these requirements. ' + this.objCompanyInfo.CompanyName + ' has determined to utilize a consortium / third party administrator (hereinafter “TPA”), to act as ' + this.objCompanyInfo.CompanyName + '’s agent in complying with its alcohol and drug testing requirements. ' + this.objCompanyInfo.CompanyName + '’s TPA is as follows: </p><p>Third Party Administrator: Pipeline Testing Consortium, Inc.</p>';
    consumerReport +=
      '<p>Contact Address: 9 Compound Drive, Hutchinson, KS 67502</p>';
    consumerReport += '<p>Contact Phone: 620 - 669 - 8800</p><br/>';
    consumerReport +=
      '<p>For the mutual benefit of ' + this.objCompanyInfo.CompanyName + ' and PTC Assist, ' + this.objCompanyInfo.CompanyName + ' provides the following additional authorizations:</p>';
    consumerReport +=
      '<p>Whether in response to a request from ' + this.objCompanyInfo.CompanyName + ' or from another employer also subject to the drug and alcohol testing requirements, ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to communicate directly with TPA to obtain information regarding the alcohol or drug testing record of any of ' + this.objCompanyInfo.CompanyName + '’s current or former employees.</p>';
    consumerReport +=
      '<p>' + this.objCompanyInfo.CompanyName + ' authorizes TPA to release to PTC Assist any information that ' + this.objCompanyInfo.CompanyName + ' would be required to release in response to a drug and alcohol testing record verification request regarding any current or former employee of ' + this.objCompanyInfo.CompanyName + '’s. ' + this.objCompanyInfo.CompanyName + ' further authorizes PTC Assist to share a copy of this Addendum with TPA, on request, to confirm ' + this.objCompanyInfo.CompanyName + '’s authorization.</p>';
    consumerReport +=
      '<p>So that TPA may maintain accurate records for ' + this.objCompanyInfo.CompanyName + ', ' + this.objCompanyInfo.CompanyName + ' authorizes PTC Assist to share the results of its testing verifications directly with TPA.</p>';
    consumerReport +=
      '<p>The authorizations set forth above shall remain in effect until the termination of the Agreement.</p><br/>';
    
      // ============================= Service Agreement Section Added =====================

    consumerReport += '<p style="margin:5px 20px;">The U.S. Department of Transportation (DOT) has published rules requiring DOT covered employers to test certain employees under certain circumstances for the presence of certain prohibited drugs and alcohol and to provide such employees with an employee assistance program. The ' + this.objCompanyInfo.CompanyName + ' is subject to performing covered employee functions under and subject to the aforesaid rules and is required and desires to comply with said DOT requirements and/or the ' + this.objCompanyInfo.CompanyName + ' is an employer conducting NON-DOT drug and alcohol testing and wishes to adopt an Alcohol and Drug Program pursuant to the DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements.</p>';
          
    consumerReport += '<p style="margin:5px 20px;">' + this.objCompanyInfo.CompanyName + ' desires to engage Pipeline Testing Consortium, Inc. (PTC), a Kansas Corporation, and PTC desires to be engaged to assist ' + this.objCompanyInfo.CompanyName + ' in administering their Alcohol and Drug programs and desires to contract with the ' + this.objCompanyInfo.CompanyName + ' to assist, and act as ' + this.objCompanyInfo.CompanyName + '’s agent, in administering its program by administering the Testing (pre-employment, post-accident, at random, reasonable cause, return-to-duty or follow-up) Employee Assistance Program, and Recordkeeping functions of the DOT regulations and/or NON-DOT requirements. PTC wishes to enlist ' + this.objCompanyInfo.CompanyName + ' in a Consortium of DOT-regulated employers and/or NON-DOT employers for greater efficiency in compliance with said regulations and/or ' + this.objCompanyInfo.CompanyName + ' requirements.</p>';
          
    consumerReport += '<p style="margin:5px 20px;">THEREFORE, ' + this.objCompanyInfo.CompanyName + ' hereby contracts with PTC to administer the Alcohol and Drug Testing, Employee Assistance Program, and Recordkeeping functions required of ' + this.objCompanyInfo.CompanyName + ' by the DOT regulations and/or NON-DOT requirements, upon the following terms and conditions:</p>';
          
    consumerReport += '<ol style="margin:10px;">'
          
          + '<li><h2 style="margin-bottom:5px;">SERVICES</h2><p>PTC will provide ' + this.objCompanyInfo.CompanyName + ' with an Alcohol and Drug Program that is intended to be adopted and used by ' + this.objCompanyInfo.CompanyName + ' in conjunction with its business as an operator or contractor under the applicable DOT regulations and/or ' + this.objCompanyInfo.CompanyName + ' NON-DOT requirements. ' + this.objCompanyInfo.CompanyName + ' hereby agrees to execute through PTC a Drug Testing and Service Agreement with Clinical Reference Laboratory, 8433 Quivira Road, Lenexa, Kansas, 66215, and to name and appoint David Paine, MD of American Medical Review Officers, LLC, 9 Compound Drive, Hutchinson, KS, 67502 as its Medical Review Officer pursuant to the DOT regulations (collectively the “Services”). The ' + this.objCompanyInfo.CompanyName + ' agrees that PTC shall be the exclusive provider of the Services during the Term of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">MEMBERSHIP IN CONSORTIUM</h2><p>Subject to the terms and conditions of this Agreement, PTC will enlist ' + this.objCompanyInfo.CompanyName + ' in, and ' + this.objCompanyInfo.CompanyName + ' agrees to be listed as, a member of a Consortium (or group) of DOT-regulated employers and/or NON-DOT employers who have or will individually contract with PTC for similar services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">TERM</h2><p>The Term of this Agreement will start on the 1st day of the Month in which this Agreement is electronically signed by the ' + this.objCompanyInfo.CompanyName + ' and will continue until terminated in accordance with the terms and conditions of this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SUBSCRIPTION FEES</h2><p>In exchange for the Services and Membership in the PTC Consortium, the ' + this.objCompanyInfo.CompanyName + ' shall pay an Annual Subscription Fee and Annual Employee Fee as established by PTC from time to time (the “Fees”) which shall be paid in accordance with PTC’s No Refund and Credit Policy. PTC may terminate or suspend this Agreement, the Services under this Agreement, and remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium if ' + this.objCompanyInfo.CompanyName + ' is in default of its obligations to pay the Fees or is in default under PTC’s No Refund and Credit Policy. This Agreement and Membership in the Consortium may be canceled in writing by ' + this.objCompanyInfo.CompanyName + ' at any time, however, there is NO REFUND for any unused portion of the Fees.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RECORDS RETENTION</h2><p>PTC shall retain records, including the ' + this.objCompanyInfo.CompanyName + '’s records, for the period of their immediate or current use, unless longer retention is necessary for historical reference or to comply with contractual or legal requirements. Thereafter, all records may be destroyed in accord with PTC’s then-current records retention policy.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">COOPERATION</h2><p>' + this.objCompanyInfo.CompanyName + ' will reasonably cooperate with PTC to facilitate PTC\'s responsibilities under this Agreement. Reasonable cooperation shall include, but not be limited to, making reasonable efforts to insure that those employees subject to DOT regulations and/or NON-DOT requirements adhere to the ' + this.objCompanyInfo.CompanyName + '\'s Alcohol and Drug Program and PTC procedures; submit to drug and alcohol testing, conduct DOT background/history checks, education or training as appropriate and travel to PTC specimen collection sites when required by PTC and/or ' + this.objCompanyInfo.CompanyName + '.</p><p>The ' + this.objCompanyInfo.CompanyName + ' shall designate PTC as its agent and hereby authorize PTC to receive all test results from the MRO. PTC shall promptly, upon receipt from the MRO, report all test results to ' + this.objCompanyInfo.CompanyName + '. ' + this.objCompanyInfo.CompanyName + ' shall designate a ' + this.objCompanyInfo.CompanyName + ' management official as the Designated Employer Representative (DER) to receive such confidential test results from PTC. PTC shall maintain all test results and records in strict confidence consistent with applicable DOT regulations and/or NON-DOT requirements.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">DEFAULT</h2><p>In the event ' + this.objCompanyInfo.CompanyName + ' fails to make payments of amounts due under this contract within 30 days from the date of invoice, PTC is authorized to suspend performance of its obligations to ' + this.objCompanyInfo.CompanyName + ' until full payment of the amount upon which ' + this.objCompanyInfo.CompanyName + ' is in default. PTC is not obligated to keep accounts open once an invoice balance has reached 60 days. By way of illustration and not limitation, PTC is expressly allowed, during such period of default, to remove ' + this.objCompanyInfo.CompanyName + ' from the Consortium and to report on any listing or report of compliance prepared or caused to be prepared by PTC that ' + this.objCompanyInfo.CompanyName + ' is not in compliance with applicable regulations (or, in the case where PTC is listing only ' + this.objCompanyInfo.CompanyName + '’s in compliance, to omit such defaulting' + this.objCompanyInfo.CompanyName + '). Such action by PTC shall not relieve ' + this.objCompanyInfo.CompanyName + ' of its obligation to pay any annual, administration, or other fees provided herein.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">REIMBURSEMENT</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to be solely responsible for obtaining reimbursement for testing costs from ' + this.objCompanyInfo.CompanyName + ' employees where desired by ' + this.objCompanyInfo.CompanyName + ' and where permissible under applicable laws and employment contracts.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">ADDITIONAL COMPENSATION</h2><p>To the extent the issuance of new, amended or supplemental regulations by the Department of Transportation necessitates additional testing or other services not contemplated by the terms of this Agreement, the compensation to be paid to PTC as a result of the additional testing or other services shall be agreed upon by the parties to this Agreement, but shall in no event be less than the actual cost incurred by PTC in providing the additional testing or other services.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">RESPONSIBILITY REGARDING TEST RESULTS, DETERMINATIONS, REFERRALS, AND REPORTING</h2><p>' + this.objCompanyInfo.CompanyName + ' shall be solely responsible for taking any action required by applicable DOT regulations or NON-DOT requirements based on an employee’s positive or refused drug or alcohol test. ' + this.objCompanyInfo.CompanyName + ' shall also be solely responsible for any other post-testing action concerning the employment status of its employee, whether required by applicable regulations, ' + this.objCompanyInfo.CompanyName + ' requirements, or ' + this.objCompanyInfo.CompanyName + '’s discretion. In addition, ' + this.objCompanyInfo.CompanyName + ' is responsible for making any testing determinations required by applicable DOT regulations or NON-DOT requirements for post-accident, reasonable-cause, or refusal-to-test situations. ' + this.objCompanyInfo.CompanyName + ' shall make any required referral to a qualified Substance Abuse Professional following a positive or refused drug or alcohol test. If applicable, ' + this.objCompanyInfo.CompanyName + ' is responsible for any required reporting to the Federal Motor Carrier Safety Administration Clearinghouse, except those items required to be reported by the Medical Review Officer.</p></li>'

          + '<li><h2 style="margin-bottom:5px;">INDEMNITY</h2><p>' + this.objCompanyInfo.CompanyName + ' agrees to hold PTC harmless and to indemnify and defend PTC from all claims, causes of action, or suits by employees or third parties except those that are a direct and proximate result of PTC’s willful wrongdoing, gross negligence, or fraud in the performance of functions administered by it under this Agreement.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">JURISDICTION</h2><p>This Agreement shall be governed by and construed under the laws of the State of Kansas without regard to conflicts of laws principles. Any action or proceeding seeking to enforce any provision of, or based on any right arising out of, this Agreement shall be brought against either of the parties only in the courts of the State of Kansas, County of Reno, or, if it has or can acquire jurisdiction, in the United States District Court for the District of Kansas, and each of the parties consents to the exclusive jurisdiction of such courts (and of the appropriate appellate courts) in any such action or proceeding and waives any objection to venue laid therein. Process in any action or proceeding referred to in the preceding sentence may be served on either party anywhere in the world.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">SEVERABILITY</h2><p>If any provision of this Agreement is held invalid or unenforceable by any court of competent jurisdiction, the other provisions of this Agreement will remain in full force and effect. Any provision of this Agreement held invalid or unenforceable only in part or degree will remain in full force and effect to the extent not held invalid or unenforceable.</p></li>'
          
          + '<li><h2 style="margin-bottom:5px;">BINDING EFFECT</h2><p>This Agreement shall be binding upon and inure to the benefit of the successors and assigns of the parties hereto.</p></li>'
          
          + '</ol>';
      mywindow.document.write(consumerReport);
    let signedDate = new Date(this.AckAndAgreement.AckDate); //use your date here
    let currentDate = this.datePipe.transform(signedDate, 'MM/dd/yyyy');
    let signingdetails =
      '<div style="float:left; width:200px;"><div style="padding-bottom:5px">' +
      this.AckAndAgreement.CompanyRepresentativeName +
      '</div><div style="border-top:1px solid #000;padding-top:5px">Name of Authorized Company Representative</div></div> <div style="float:right; width:100px;"><div style="padding-bottom:5px">' +
      currentDate +
      '</div><div style="border-top:1px solid #000; padding-top:5px">Date</div></div>';

    mywindow.document.write(signingdetails);

    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();
  }
  autoTable(doc: any, arg1: { html: string }) {
  throw new Error('Function not implemented.');
}

pdfAckExportDownload(){
  this.pdfAckExport.saveAs(this.FileAgreementPolicies)
}
pdfDownload(){
  this.pdf.saveAs(this.FileInvoice)
}
printTransactionInfoDownload(){
  this.printTransactionInfo.saveAs(this.FileTransactionDetail)
}
pdfViewDownload(){
  this.pdfView.saveAs(this.FileServiceAgreement)
}
formatDateToLong(dateInput : string) {
  if(dateInput.length > 0) {
    const date = new Date(dateInput);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'long',   
      year: 'numeric',  
      month: 'long',   
      day: 'numeric' 
    }).format(date);
  } else {
    return ""
  }

}

downloadCreditCardPDF() {
  const link = document.createElement('a');
  link.href = 'assets/documents/PTC Credit Card Security Policy.pdf';
  link.download = 'PTC Credit Card Security Policy.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


}

